import type { Dictionary } from "@/lib/i18n/dictionaries/en";

const hi: Dictionary = {
  // ---- /citation-styles/alphabetical/<letter> ----
  styleDirectory: {
    notFoundTitle: "उद्धरण शैली निर्देशिका नहीं मिली",
    metaTitle: "{label} से शुरू होने वाली उद्धरण शैलियाँ",
    metaDescription:
      "{label} से शुरू होने वाली {count} Citation Style Language शैलियाँ देखें। वास्तविक उद्धरण उदाहरणों और मुफ़्त जनरेटर के लिए कोई भी शैली खोलें।",
    ogSubtitle: "समर्पित उदाहरणों और जनरेटर के साथ {count} शैलियाँ।",
    ogKind: "A–Z निर्देशिका",
    schemaName: "{label} से शुरू होने वाली उद्धरण शैलियाँ",
    schemaDescription:
      "{label} से शुरू होने वाली {count} Citation Style Language शैलियों की वर्णानुक्रमिक निर्देशिका।",
    breadcrumbStyles: "उद्धरण शैलियाँ",
    heading: "{label} से शुरू होने वाली उद्धरण शैलियाँ",
    intro:
      "CSL कैटलॉग के इस भाग की सभी {count} शैलियाँ देखें। हर पृष्ठ में शैली के अपने स्वरूपित उदाहरण और एक मुफ़्त उद्धरण जनरेटर शामिल है।",
    navLabel: "A से Z तक उद्धरण शैलियाँ",
    listHeading: "{label} से शुरू होने वाली सभी शैलियाँ",
  },
  nav: {
    tools: "उपकरण",
    guides: "मार्गदर्शिकाएँ",
    styles: "सभी शैलियाँ",
    bibliography: "मेरी संदर्भ सूची",
    search: "खोजें",
    glossary: "शब्दावली",
    home: "मुखपृष्ठ",
    menu: "मेनू",
  },

  home: {
    title: "निःशुल्क संदर्भ जनरेटर",
    subtitle: "2026 के लिए अद्यतन",
    intro:
      "कोई DOI, URL या BibTeX प्रविष्टि चिपकाएँ — या कोई पुस्तक खोजें — और APA, MLA, Chicago, Vancouver, Harvard तथा हज़ारों अन्य शैलियों में सही ढंग से स्वरूपित संदर्भ पाएँ। पूरी तरह निःशुल्क, बिना सशुल्क सदस्यता और बिना पंजीकरण के।",
    browseAllStyles: "सभी {count} उद्धरण शैलियाँ देखें →",
    featuresHeading: "उद्धरण देने के लिए ज़रूरी सब कुछ",
    featureStyles: "{count} शैलियाँ",
    featureStylesDetail: "APA, MLA, Chicago और अन्य",
    featureBibliographies: "कई संदर्भ सूचियाँ",
    featureBibliographiesDetail: "हर काम के लिए अलग",
    featureBookSearch: "पुस्तक खोज",
    featureBookSearchDetail: "शीर्षक या लेखक से",
    featureExport: "कहीं भी निर्यात करें",
    featureExportDetail: "BibTeX, Word, RIS, CSV",
    featureDarkMode: "गहरा रंगरूप",
    featureDarkModeDetail: "आँखों के लिए आरामदायक",
    featureNoSignup: "पंजीकरण नहीं",
    featureNoSignupDetail: "हमेशा निःशुल्क, बिना सशुल्क सदस्यता",
    aboutHeading: "विद्यार्थियों और शोधकर्ताओं के लिए निःशुल्क संदर्भ जनरेटर",
    aboutBody:
      "CitationEasy 10,000 से अधिक शैक्षणिक उद्धरण शैलियों का समर्थन करता है। मनोविज्ञान के लिए APA हो, साहित्य के लिए MLA, इतिहास के लिए Chicago या चिकित्सा पत्रिकाओं के लिए Vancouver — स्वरूपण उसी शैली की आधिकारिक परिभाषा से आता है, किसी अनुमान से नहीं।",
    howItWorksHeading: "यह कैसे काम करता है",
    howItWorksStep1:
      "कोई DOI, URL, ISBN, PubMed या arXiv पहचान-संख्या, अथवा BibTeX प्रविष्टि चिपकाएँ; आप पुस्तक को शीर्षक से भी खोज सकते हैं।",
    howItWorksStep2:
      "अपनी उद्धरण शैली चुनें। सभी {count} शैलियों में खोजने के लिए टाइप करें।",
    howItWorksStep3:
      "तैयार संदर्भ को कॉपी करें, या उसे संदर्भ सूची में सहेजकर Word, BibTeX या RIS में निर्यात करें।",
    privacyNote:
      "आपकी संदर्भ सूची आपके अपने ब्राउज़र में सहेजी जाती है। कोई खाता नहीं, और कुछ भी अपलोड नहीं होता।",
  },

  hubs: {
    toolsTitle: "लेखन और उद्धरण के निःशुल्क उपकरण",
    toolsIntro:
      "ब्राउज़र में चलने वाले {count} उपकरण: हर प्रकार के स्रोत के लिए जनरेटर, शब्द और अक्षर गणक, पठनीयता आकलन, स्वरूपण उपकरण और परिवर्तक। सभी निःशुल्क और तुरंत उपलब्ध।",
    stylesTitle: "सभी उद्धरण शैलियाँ देखें",
    stylesIntro:
      "Citation Style Language परियोजना की सभी {count} शैलियाँ, जिन्हें देश, विषय और शैक्षणिक क्षेत्र के अनुसार खोजा और छाना जा सकता है।",
    guidesTitle: "उद्धरण और शैक्षणिक लेखन की मार्गदर्शिकाएँ",
    guidesIntro:
      "हर प्रकार के स्रोत का उद्धरण कैसे दें, जो मिले उसका मूल्यांकन कैसे करें और बेहतर कैसे लिखें — इन पर विस्तृत मार्गदर्शिकाएँ।",
    howToCiteTitle: "किसी भी स्रोत का उद्धरण कैसे दें",
    howToCiteIntro:
      "चरण-दर-चरण पृष्ठ, जो हर सामान्य स्रोत प्रकार को प्रमुख उद्धरण शैलियों के साथ जोड़ते हैं और हर एक में वास्तविक हल किया हुआ उदाहरण होता है।",
    faqTitle: "उद्धरण से जुड़े सामान्य प्रश्न",
    faqIntro:
      "उद्धरण देते समय विद्यार्थियों के मन में सचमुच उठने वाले प्रश्नों के संक्षिप्त और सटीक उत्तर।",
    glossaryTitle: "उद्धरण शब्दावली",
    glossaryIntro:
      "शैली-पुस्तिकाओं और असाइनमेंट के निर्देशों में आने वाले शब्दों की सरल परिभाषाएँ।",
    openHub: "खोलें",
  },

  styleLanding: {
    metaTitle: "निःशुल्क {style} संदर्भ जनरेटर",
    metaDescription:
      "{style} उद्धरण निःशुल्क बनाएँ। DOI, URL, ISBN या BibTeX चिपकाएँ और सही {style} स्वरूप में संदर्भ तथा पाठ-आंतरिक उद्धरण पाएँ।",
    heading: "{style} संदर्भ जनरेटर",
    intro:
      "पुस्तकों, शोध-पत्रिका लेखों और वेबसाइटों के लिए सटीक {style} उद्धरण एक क्लिक में बनाएँ। निःशुल्क और बिना पंजीकरण।",
    aboutHeading: "{style} के बारे में",
    whenToUseHeading: "{style} का प्रयोग कब करें",
    factsHeading: "एक नज़र में {style}",
    factEdition: "संस्करण",
    factSystem: "उद्धरण प्रणाली",
    factInText: "पाठ में स्वरूप",
    factReferenceList: "सूची का नाम",
    factFields: "आमतौर पर इनमें",
    systemAuthorDate: "लेखक–वर्ष",
    systemNumbered: "क्रमांकित",
    systemFootnotes: "पाद-टिप्पणियाँ",
    howToHeading: "इस {style} जनरेटर का उपयोग कैसे करें",
    howToStep1:
      "ऊपर दिए बक्से में URL, DOI, ISBN या BibTeX प्रविष्टि चिपकाएँ, अथवा पुस्तक को शीर्षक से खोजें।",
    howToStep2:
      "इस पृष्ठ पर {style} पहले से चुना हुआ है, इसलिए आप सीधे उद्धरण बना सकते हैं।",
    howToStep3:
      "परिणाम को अपने दस्तावेज़ में कॉपी करें, या उसे सहेजकर बाद में पूरी सूची निर्यात करें।",
    relatedHeading: "{style} पर और सामग्री",
    englishOnlyNote:
      "{style} की विस्तृत मार्गदर्शिकाएँ और स्रोत-प्रकार के अनुसार उदाहरण अंग्रेज़ी में उपलब्ध हैं।",
  },

  // The per-style pages at `/<locale>/citation-style/<slug>` — one per catalog style.
  //
  // The formatted examples the page is built around (the style's own output for a
  // fixed journal article, book and website) and the style's own name stay in
  // `src/data/citation-styles.ts` and `src/data/style-examples-generated.json`. They
  // are language-neutral: a citation rendered by the style's own CSL definition looks
  // the same whatever language the reader speaks, and "translating" one would make the
  // page wrong.
  //
  // The rest of what `src/data/**` supplies to these pages is NOT like that — see the
  // `generic*`, `discipline*` and `internationalLabel` keys below.
  citationStylePage: {
    notFoundTitle: "उद्धरण शैली नहीं मिली",
    metaTitle: "{style} संदर्भ जनरेटर - निःशुल्क {style} प्रारूप",
    metaFormatAndFields:
      "{style}, {fields} में प्रयुक्त होने वाली एक {format} शैली है।",
    metaFormatOnly: "{style} एक {format} शैली है।",
    metaFieldsOnly: "{style} का उपयोग {fields} में किया जाता है।",
    metaPromiseNote:
      "एक वास्तविक {style} पाद-टिप्पणी देखें, और अपनी खुद की निःशुल्क बनाएँ।",
    metaPromiseExamples:
      "शोध-पत्रिका लेख, पुस्तक और वेबसाइट के लिए वास्तविक {style} उद्धरण उदाहरण देखें, और अपना खुद का उद्धरण निःशुल्क बनाएँ।",
    ogKindFormat: "{format} शैली",
    ogKindDefault: "उद्धरण शैली",
    // Joins the style's discipline list: "psychology, education and nursing".
    disciplineConjunction: "और",
    // ---- Data-derived facts that are nonetheless mail-merged prose ----
    //
    // Every entry in `src/data/citation-styles-generated.ts` carries exactly the
    // two sentences below with their own name spliced in, exactly one region value
    // ("International" — that is `internationalLabel` above, reused rather than
    // duplicated), and discipline tokens drawn from a closed 26-word vocabulary. None
    // of that is a citation, so none of it is language-neutral the way the formatted
    // examples are. Left in `src/data/**` it renders English facts inside translated
    // chrome, which is precisely the hybrid page this tree exists to avoid.
    //
    // The page substitutes the two templates ONLY when a style's stored text is
    // byte-identical to the English template with its own name interpolated, so the
    // ~100 hand-curated styles keep their bespoke English descriptions instead of
    // being flattened into a generic sentence. `{name}` is the style's full name.
    genericDescription:
      "{name} के लिए उद्धरण शैली। Citation Style Language रिपॉज़िटरी से।",
    genericWhenUsed:
      "{name} शैली का उपयोग करने वाले प्रकाशनों में सबमिट करते समय, या उनमें उद्धृत करते समय।",

    // The 26 discipline tokens `style-examples-generated.json` uses. Each English
    // value is the exact string the page printed before these keys existed — the raw
    // token with hyphens turned into spaces — so `generic-base` reads "generic base"
    // and `political_science` keeps its underscore. An unknown token (a new one from
    // upstream CSL) falls back to that same prettified form rather than to a key name.
    disciplineAnthropology: "मानवशास्त्र",
    disciplineAstronomy: "खगोल विज्ञान",
    disciplineBiology: "जीव विज्ञान",
    disciplineBotany: "वनस्पति विज्ञान",
    disciplineChemistry: "रसायन विज्ञान",
    disciplineCommunications: "जनसंचार",
    disciplineEngineering: "अभियांत्रिकी",
    disciplineGenericBase: "सामान्य",
    disciplineGeography: "भूगोल",
    disciplineGeology: "भूविज्ञान",
    disciplineHistory: "इतिहास",
    disciplineHumanities: "मानविकी",
    disciplineLaw: "विधि",
    disciplineLinguistics: "भाषा विज्ञान",
    disciplineLiterature: "साहित्य",
    disciplineMath: "गणित",
    disciplineMedicine: "चिकित्सा विज्ञान",
    disciplinePhilosophy: "दर्शनशास्त्र",
    disciplinePhysics: "भौतिकी",
    disciplinePoliticalScience: "राजनीति विज्ञान",
    disciplinePsychology: "मनोविज्ञान",
    disciplineScience: "विज्ञान",
    disciplineSocialScience: "सामाजिक विज्ञान",
    disciplineSociology: "समाजशास्त्र",
    disciplineTheology: "धर्मशास्त्र",
    disciplineZoology: "प्राणि विज्ञान",

    // Plain-language descriptions of the citation-format classes the CSL definitions
    // declare. `{format}` in the fallback is the raw class name from the data.
    formatClassAuthorDate:
      "एक लेखक-वर्ष शैली है: पाठ-अंतर्गत उद्धरण लेखक और वर्ष के नाम पर आधारित होते हैं, और संदर्भ सूची लेखक के अनुसार वर्णानुक्रम में होती है",
    formatClassNumeric:
      "एक क्रमांकित शैली है: स्रोतों को पहली बार उद्धृत किए जाने के क्रम में क्रमांक दिया जाता है, और पाठ-अंतर्गत उद्धरण उन्हीं क्रमांकों का उपयोग करते हैं",
    formatClassNote:
      "एक टिप्पणी-आधारित शैली है: उद्धरण पाठ में कोष्ठकों के बजाय पाद-टिप्पणियों या अंत-टिप्पणियों में दिखाई देते हैं",
    formatClassLabel:
      "एक लेबल शैली है: पाठ-अंतर्गत उद्धरण लेखक के नाम और वर्ष से बने एक संक्षिप्त लेबल का उपयोग करते हैं",
    formatClassAuthor:
      "एक केवल-लेखक शैली है: पाठ-अंतर्गत उद्धरण लेखक का नाम बताते हैं, और पूरा विवरण संदर्भ सूची में होता है",
    formatClassOther: "एक {format} शैली है",
    breadcrumbStyles: "उद्धरण शैलियाँ",
    internationalLabel: "अंतरराष्ट्रीय",
    heading: "{style} संदर्भ जनरेटर",
    intro: "पुस्तकों, लेखों और वेबसाइटों के लिए सटीक {style} उद्धरण एक क्लिक में बनाएँ।",
    examplesHeading: "{style} उद्धरण उदाहरण",
    examplesIntro: "{style} में प्रारूपित वही तीन स्रोत:",
    examplesIntroWithFormat: "{style} में प्रारूपित वही तीन स्रोत — {format}:",
    examplesNoteOnlyIntro:
      "{style} एक टिप्पणी-आधारित शैली है: इसमें कोई संदर्भ सूची नहीं होती, और हर उद्धरण एक पाद-टिप्पणी होता है। यहाँ हमारा नमूना शोध-पत्रिका लेख {style} में उद्धृत है:",
    labelJournalArticle: "शोध-पत्रिका लेख",
    labelBook: "पुस्तक",
    labelWebsite: "वेबसाइट",
    labelFootnote: "पाद-टिप्पणी (शोध-पत्रिका लेख)",
    labelInText: "पाठ-अंतर्गत उद्धरण (शोध-पत्रिका लेख के लिए)",
    aboutHeading: "{style} के बारे में",
    whenToUseLabel: "{style} का प्रयोग कब करें:",
    commonInLabel: "आमतौर पर इनमें:",
    subjectAreasLabel: "विषय क्षेत्र:",
    formattingRulesLabel: "स्वरूपण नियम:",
    parentStylePrefix: "{style}",
    parentStyleSuffix: " के स्वरूपण नियमों का अनुसरण करती है, जो इसकी मूल शैली है।",
    howToHeading: "इस {style} जनरेटर का उपयोग कैसे करें",
    howToBody:
      "ऊपर दिए बक्से में कोई DOI, समाचार लेख या वेबपेज का URL, या सीधा BibTeX चिपकाएँ। आप पुस्तक को शीर्षक या लेखक से खोजकर उसे ISBN द्वारा भी उद्धृत कर सकते हैं। शैली ड्रॉपडाउन में ‘{style}’ चुनें (यह इस पृष्ठ पर पहले से चयनित है), फिर ‘उद्धरण बनाएँ’ पर क्लिक करें। परिणाम को अपनी संदर्भ सूची में कॉपी करें। कॉपी करने से पहले आप बनाई गई प्रविष्टि को संपादित कर सकते हैं (जैसे शीर्षक ठीक करना या तिथि जोड़ना)।",
    faqHeading: "{style} के बारे में अक्सर पूछे जाने वाले प्रश्न",
    faqWhatIsQ: "{style} क्या है?",
    faqWhenQ: "{style} का प्रयोग कब करना चाहिए?",
    faqInTextQ: "{style} में पाठ-अंतर्गत उद्धरण कैसा दिखता है?",
    faqInTextA:
      "{style} {format}। पाठ में हमारे नमूना शोध-पत्रिका लेख को उद्धृत करने पर यह ऐसा दिखता है: {example}",
    faqReferenceQ: "{style} संदर्भ सूची की प्रविष्टि कैसी दिखती है?",
    faqReferenceA:
      "{style} में प्रारूपित शोध-पत्रिका लेख कुछ इस तरह दिखता है: {example}",
    faqWhereQ: "{style} का उपयोग आमतौर पर कहाँ किया जाता है?",
    faqWhereA: "{style} का उपयोग {region} किया जाता है। {whenUsed}",
    faqRegionDefault: "अंतरराष्ट्रीय स्तर पर",
    faqGenerateQ: "{style} उद्धरण कैसे बनाएं?",
    faqGenerateA:
      "इस पृष्ठ पर दिए निःशुल्क जनरेटर का उपयोग करें: कोई DOI, URL (जैसे कोई समाचार लेख) या BibTeX चिपकाएँ, या पुस्तक को शीर्षक या लेखक से खोजें। उद्धरण शैली के रूप में {style} चुनें और प्रारूपित संदर्भ पाने के लिए ‘उद्धरण बनाएँ’ पर क्लिक करें, जिसे आप अपने शोध-पत्र या संदर्भ सूची में कॉपी कर सकते हैं।",
    footerSupports:
      "दुनिया भर की कई उद्धरण शैलियों का समर्थन करता है। हमारा जनरेटर Citation Style Language (CSL) शैलियों के लिए इस स्रोत का उपयोग करता है —",
    footerRepoLink: "आधिकारिक CSL रिपॉज़िटरी",
  },

  // The source × style pages at `/<locale>/how-to-cite/<slug>` — 1,290 combinations.
  //
  // Same division as above: the citation templates, the worked examples generated from
  // each style's own CSL definition, the in-text samples and the hand-checked
  // formatting rules stay in the page module and in
  // `src/data/how-to-cite-examples-generated.json`. They are the citations themselves,
  // not prose about them. Source names, style names and editions come from
  // `src/data/how-to-cite.ts` and arrive here as placeholder values.
  crossLinks: {
    generateHeading: "यह उद्धरण बनाएँ",
    generateBody:
      "URL, DOI, ISBN या स्रोत का विवरण चिपकाएँ और {source} के लिए तैयार {style} उद्धरण पाएँ।",
    generateCta: "{tool} खोलें →",
    guideHeading: "और गहराई से समझें",
    guideCta: "पूरी मार्गदर्शिका पढ़ें: {guide}",
    howToCiteHeading: "हर शैली में {source} का उद्धरण कैसे दें",
    howToCiteBody:
      "सबसे अधिक माँगी जाने वाली शैलियों के लिए प्रारूप नियम, टेम्पलेट और हल किए गए उदाहरण।",
    howToCiteMore: "सभी स्रोत प्रकार और शैलियाँ →",
    citeNowHeading: "अभी {style} में {source} का उद्धरण दें",
    citeNowHowTo: "प्रारूप नियम और हल किए गए उदाहरण",
    citeNowTool: "{tool} से बनाएँ",
    citeNowHub: "{style} उद्धरण जनरेटर",
    hubSourcesHeading: "{style} में सामान्य स्रोतों का उद्धरण कैसे दें",
    hubGuidesHeading: "{style} मार्गदर्शिकाएँ",
    hubCompareHeading: "{style} की अन्य शैलियों से तुलना करें",
    moreInCollection: "{collection} में और",
    seeAllInCollection: "{collection} में सभी देखें",
  },

  howToCitePage: {
    notFoundTitle: "नहीं मिला",
    title: "{style} ({edition}) में {source} का उद्धरण कैसे दें",
    metaTitle: "{style} में {source} का उद्धरण कैसे दें [{edition}, 2026 में अद्यतन]",
    metaDescription:
      "{style} प्रारूप ({edition}) में {description} का उद्धरण देना सीखें। निःशुल्क उदाहरण, टेम्पलेट और पाठ-अंतर्गत उद्धरण मार्गदर्शिकाएँ।",
    keywordCite: "{source} {style} उद्धरण",
    keywordCitation: "{style} {source} उद्धरण",
    keywordHowTo: "{source} का उद्धरण कैसे दें",
    keywordExample: "{style} उद्धरण उदाहरण",
    keywordReference: "{source} संदर्भ {style}",
    // What each style calls the list at the back of the paper, in the two casings the
    // prose needs. MLA says "Works Cited", Chicago and the legal styles "Bibliography".
    refListWorksCited: "उद्धृत रचना सूची",
    refListWorksCitedPage: "उद्धृत रचना सूची",
    refListBibliography: "ग्रंथ सूची",
    refListBibliographyLower: "ग्रंथ सूची",
    refListReferenceList: "संदर्भ सूची",
    refListReferenceListLower: "संदर्भ सूची",
    backLink: "← सभी उद्धरण मार्गदर्शिकाएँ",
    lead: "{style} प्रारूप ({edition}) में {description} का उद्धरण देना सीखें। इस मार्गदर्शिका में संदर्भ सूची का प्रारूप, पाठ-अंतर्गत उद्धरण के उदाहरण और मुख्य स्वरूपण नियम शामिल हैं।",
    referenceFormatHeading: "{style} {list} प्रारूप",
    referenceFormatIntro:
      "अपनी {list} में {source} का उद्धरण देने के लिए मानक {style} प्रारूप यह है:",
    noTemplateNote: "इस प्रकार के स्रोत के लिए मानक {style} टेम्पलेट का पालन करें।",
    workedHeading: "{source} के लिए {style} उदाहरण",
    workedIntro:
      "{source} के लिए पूरा {style} संदर्भ, जो आधिकारिक {style} CSL शैली परिभाषा से प्रारूपित है — वही इंजन जो इस साइट के जनरेटर को चलाता है:",
    workedNoteOnlyIntro:
      "{style} में {source} को {list} में शामिल नहीं किया जाता — इसे केवल एक टिप्पणी में उद्धृत किया जाता है। यह रही वह टिप्पणी, जो आधिकारिक {style} CSL शैली परिभाषा से प्रारूपित है:",
    workedOscolaNote:
      "इस साइट पर बना OSCOLA आउटपुट चौथे संस्करण की CSL शैली का पालन करता है, क्योंकि Citation Style Language रिपॉज़िटरी में पाँचवें संस्करण की कोई CSL शैली अभी प्रकाशित नहीं हुई है। इसे हाथ से ठीक करें: हर ibid की जगह संक्षिप्त नाम और (n X) लिखें, पाँचवें संस्करण के न्यायालय पहचानकर्ता इस्तेमाल करें, अधिनियम का संक्षिप्त रूप एकल उद्धरण चिह्नों में रखें और पहुँच-तिथि की जगह स्थायी लिंक या DOI को वरीयता दें",
    workedCheckedIntro:
      "{source} के लिए पूरा {style} संदर्भ, जो हाथ से लिखा गया है और इस स्रोत के लिए आधिकारिक {style} दिशानिर्देशों से जाँचा गया है:",
    workedCheckedNoteOnlyIntro:
      "{style} में {source} को {list} में शामिल नहीं किया जाता — इसे केवल एक टिप्पणी में उद्धृत किया जाता है। यह रही वह टिप्पणी, जो हाथ से लिखी गई है और आधिकारिक {style} दिशानिर्देशों से जाँची गई है:",
    workedInTextLabel: "संगत पाठ-अंतर्गत उद्धरण:",
    inTextHeading: "{style} पाठ-अंतर्गत उद्धरण",
    inTextIntro:
      "अपने शोध-पत्र में इस स्रोत का संदर्भ देते समय इनमें से कोई एक प्रारूप उपयोग करें:",
    inTextParenthetical: "कोष्ठकीय",
    inTextNarrative: "वर्णनात्मक",
    rulesHeading: "प्रमुख {style} स्वरूपण नियम",
    stepsHeading: "चरण-दर-चरण मार्गदर्शिका",
    step1Label: "स्रोत की जानकारी एकत्र करें:",
    step1Body:
      "{source} का उद्धरण देने के लिए लेखक का नाम, शीर्षक, प्रकाशन तिथि, और URL या DOI एकत्र करें।",
    step2Label: "संदर्भ को प्रारूपित करें:",
    step2Body:
      "ऊपर दिखाए गए {style} ({edition}) टेम्पलेट के अनुसार तत्वों को व्यवस्थित करें।",
    step3Label: "पाठ-अंतर्गत उद्धरण बनाएँ:",
    step3Body:
      "अपने शोध-पत्र में जहाँ आप इस स्रोत का संदर्भ देते हैं, वहाँ कोष्ठकीय या वर्णनात्मक उद्धरण जोड़ें।",
    step4Label: "अपनी {list} में जोड़ें:",
    step4Body: "अपने शोध-पत्र के अंत में पूरा प्रारूपित उद्धरण शामिल करें।",
    step5Label: "स्वरूपण दोबारा जाँचें:",
    step5Body:
      "जाँच लें कि इटैलिक, विराम-चिह्न, बड़े-छोटे अक्षर और लटका हुआ इंडेंट {style} की आवश्यकताओं से मेल खाते हैं।",
    ctaHeading: "यह उद्धरण स्वतः बनाएँ",
    ctaBody:
      "हाथ से प्रारूपित करने की ज़रूरत नहीं। CitationEasy में कोई DOI, URL या ISBN चिपकाएँ और सेकंडों में पूरी तरह प्रारूपित {style} उद्धरण पाएँ।",
    ctaButton: "अभी {style} में उद्धृत करें →",
    otherStylesHeading: "{source} को अन्य शैलियों में उद्धृत करें",
    comboLink: "{style} में {source}",
    otherSourcesHeading: "{style} में अन्य स्रोतों को उद्धृत करें",
    resourcesHeading: "और संसाधन",
    resourceGenerator: "निःशुल्क उद्धरण जनरेटर ({count} शैलियाँ)",
    resourceTools: "निःशुल्क लेखन उपकरण",
    resourceCompare: "उद्धरण शैलियों की तुलना करें",
    resourceGuides: "सभी उद्धरण मार्गदर्शिकाएँ",
    resourceCheatSheets: "त्वरित संदर्भ पत्रक (APA, MLA, Chicago)",
    resourceGlossary: "उद्धरण शब्दावली (et al., ibid., DOI, लटका हुआ इंडेंट)",
    // HowTo structured data. Deliberately worded differently from the visible steps
    // above: the schema describes the task generically, the page walks the reader
    // through this particular source and style.
    schemaStep1Name: "स्रोत की जानकारी एकत्र करें",
    schemaStep1Text:
      "{source} के उद्धरण के लिए सभी आवश्यक जानकारी एकत्र करें, जिसमें लेखक, शीर्षक, तिथि और URL या DOI शामिल हैं।",
    schemaStep2Name: "{style} में प्रारूपित करें",
    schemaStep2Text:
      "उद्धरण के तत्वों को सही क्रम में व्यवस्थित करने के लिए {style} ({edition}) के स्वरूपण नियमों का पालन करें।",
    schemaStep3Name: "पाठ-अंतर्गत उद्धरण बनाएँ",
    schemaStep3Text:
      "{style} प्रारूप का उपयोग करते हुए अपने शोध-पत्र में संगत पाठ-अंतर्गत उद्धरण जोड़ें।",
    schemaStep4Name: "संदर्भ सूची में जोड़ें",
    schemaStep4Text: "अपने शोध-पत्र के अंत में अपनी {list} में पूरा उद्धरण शामिल करें।",
    faqHowQ: "{style} में {source} का उद्धरण कैसे दें?",
    faqHowA:
      "{style} ({edition}) में {source} का उद्धरण देने के लिए लेखक, शीर्षक, तिथि और स्रोत का स्थान शामिल करें। स्वतः स्वरूपण के लिए हमारे निःशुल्क उद्धरण जनरेटर का उपयोग करें।",
    faqFormatQ: "{source} के उद्धरण के लिए {style} प्रारूप क्या है?",
    faqFormatA: "{source} के लिए {style} प्रारूप यह है: {example}",
    faqFormatFallback:
      "{style} प्रारूप में लेखक, शीर्षक, तिथि और स्रोत के स्थान जैसे विशेष तत्वों को एक निश्चित क्रम में व्यवस्थित करना आवश्यक है।",
    faqInTextQ: "{style} में {source} के लिए पाठ-अंतर्गत उद्धरण कैसा दिखता है?",
    faqInTextA:
      "{style} में, ऊपर दिए उदाहरण के लिए पाठ-अंतर्गत उद्धरण यह है {example}",
  },

  // The 43 source types the how-to-cite pages are built from (`SOURCE_TYPES` in
  // `src/data/how-to-cite.ts`), in the five forms those pages print. Each form is a whole
  // phrase, never an article and a noun joined in code: an article agrees with its noun
  // in gender, number and case, elides in French and Italian, and has no counterpart
  // at all in Polish, Russian or Japanese.
  //
  // - `…Name` ("Book") is the type on its own, as a label: `howToCitePage.comboLink`.
  //   English also lower-cases it into the `keyword*` templates.
  // - `…Title` ("a Book") is the type as the object of "cite" in a title or heading:
  //   `title`, `metaTitle`, `workedHeading` and `otherStylesHeading`, plus
  //   `crossLinks.generateBody`, `howToCiteHeading` and `citeNowHeading`. Through
  //   `title` it is also the HowTo name, the OG card and every link to the page.
  // - `…Phrase` ("a book") is the same inside a sentence: `referenceFormatIntro`,
  //   `workedIntro`, `workedNoteOnlyIntro` and the five `faq*` questions and answers.
  // - `…Noun` ("book") is the bare noun inside a sentence, where English puts "your" in
  //   front of it: `step1Body` and `schemaStep1Text`. A translation also uses it in the
  //   `keyword*` templates, which read as search queries.
  // - `…Description` is what the type covers: `{description}` in `lead` and
  //   `metaDescription`.
  //
  // A language with case picks one case per form and words every template above around
  // it — German writes Title and Phrase in the accusative, Polish and Russian write Name
  // and Noun in the nominative. Changing a form's case means re-reading every template
  // that receives it. A key missing here falls back to the English data
  // (`howToCiteSourceForms`), so a new source type renders in English, not as a key.
  // Hindi: Name is direct case; Title, Phrase, Noun and Description are oblique ("न्यायालय मामले") — every template follows them with a postposition.
  howToCiteSources: {
    websiteName: "वेबसाइट",
    websiteTitle: "वेबसाइट",
    websitePhrase: "वेबसाइट",
    websiteNoun: "वेबसाइट",
    websiteDescription: "वेबपेजों, ऑनलाइन लेखों और वेब सामग्री",

    bookName: "पुस्तक",
    bookTitle: "पुस्तक",
    bookPhrase: "पुस्तक",
    bookNoun: "पुस्तक",
    bookDescription: "मुद्रित और इलेक्ट्रॉनिक पुस्तकों",

    journalArticleName: "शोध-पत्रिका लेख",
    journalArticleTitle: "शोध-पत्रिका लेख",
    journalArticlePhrase: "शोध-पत्रिका लेख",
    journalArticleNoun: "शोध-पत्रिका लेख",
    journalArticleDescription: "सहकर्मी-समीक्षित और अकादमिक शोध-पत्रिका लेखों",

    youtubeVideoName: "YouTube वीडियो",
    youtubeVideoTitle: "YouTube वीडियो",
    youtubeVideoPhrase: "YouTube वीडियो",
    youtubeVideoNoun: "YouTube वीडियो",
    youtubeVideoDescription: "YouTube और ऑनलाइन वीडियो",

    podcastName: "पॉडकास्ट",
    podcastTitle: "पॉडकास्ट",
    podcastPhrase: "पॉडकास्ट",
    podcastNoun: "पॉडकास्ट",
    podcastDescription: "पॉडकास्ट एपिसोडों और शृंखलाओं",

    newspaperArticleName: "समाचार-पत्र लेख",
    newspaperArticleTitle: "समाचार-पत्र लेख",
    newspaperArticlePhrase: "समाचार-पत्र लेख",
    newspaperArticleNoun: "समाचार-पत्र लेख",
    newspaperArticleDescription: "मुद्रित और ऑनलाइन समाचार-पत्र लेखों",

    magazineArticleName: "पत्रिका लेख",
    magazineArticleTitle: "पत्रिका लेख",
    magazineArticlePhrase: "पत्रिका लेख",
    magazineArticleNoun: "पत्रिका लेख",
    magazineArticleDescription: "मुद्रित और ऑनलाइन पत्रिका लेखों",

    blogPostName: "ब्लॉग पोस्ट",
    blogPostTitle: "ब्लॉग पोस्ट",
    blogPostPhrase: "ब्लॉग पोस्ट",
    blogPostNoun: "ब्लॉग पोस्ट",
    blogPostDescription: "ब्लॉग पोस्टों और ऑनलाइन विचार-लेखों",

    wikipediaName: "Wikipedia",
    wikipediaTitle: "Wikipedia",
    wikipediaPhrase: "Wikipedia",
    wikipediaNoun: "Wikipedia",
    wikipediaDescription: "Wikipedia लेखों और विकि प्रविष्टियों",

    pdfName: "PDF दस्तावेज़",
    pdfTitle: "PDF दस्तावेज़",
    pdfPhrase: "PDF दस्तावेज़",
    pdfNoun: "PDF दस्तावेज़",
    pdfDescription: "PDF दस्तावेज़ों और रिपोर्टों",

    interviewName: "साक्षात्कार",
    interviewTitle: "साक्षात्कार",
    interviewPhrase: "साक्षात्कार",
    interviewNoun: "साक्षात्कार",
    interviewDescription: "व्यक्तिगत, प्रकाशित और प्रसारित साक्षात्कारों",

    socialMediaName: "सोशल मीडिया पोस्ट",
    socialMediaTitle: "सोशल मीडिया पोस्ट",
    socialMediaPhrase: "सोशल मीडिया पोस्ट",
    socialMediaNoun: "सोशल मीडिया पोस्ट",
    socialMediaDescription:
      "ट्वीटों, Instagram पोस्टों, Facebook पोस्टों और TikTok वीडियो",

    governmentDocumentName: "सरकारी दस्तावेज़",
    governmentDocumentTitle: "सरकारी दस्तावेज़",
    governmentDocumentPhrase: "सरकारी दस्तावेज़",
    governmentDocumentNoun: "सरकारी दस्तावेज़",
    governmentDocumentDescription: "सरकारी रिपोर्टों, विधानों और आधिकारिक दस्तावेज़ों",

    dissertationName: "शोध-प्रबंध या थीसिस",
    dissertationTitle: "शोध-प्रबंध या थीसिस",
    dissertationPhrase: "शोध-प्रबंध या थीसिस",
    dissertationNoun: "शोध-प्रबंध या थीसिस",
    dissertationDescription: "डॉक्टरेट शोध-प्रबंधों और स्नातकोत्तर लघु शोध-प्रबंधों",

    conferencePaperName: "सम्मेलन शोध-पत्र",
    conferencePaperTitle: "सम्मेलन शोध-पत्र",
    conferencePaperPhrase: "सम्मेलन शोध-पत्र",
    conferencePaperNoun: "सम्मेलन शोध-पत्र",
    conferencePaperDescription: "सम्मेलन कार्यवाहियों और प्रस्तुतियों",

    lectureNotesName: "व्याख्यान या PowerPoint",
    lectureNotesTitle: "व्याख्यान या PowerPoint",
    lectureNotesPhrase: "व्याख्यान या PowerPoint",
    lectureNotesNoun: "व्याख्यान या PowerPoint",
    lectureNotesDescription: "कक्षा व्याख्यानों, स्लाइडों और पाठ्यक्रम सामग्री",

    webinarName: "वेबिनार",
    webinarTitle: "वेबिनार",
    webinarPhrase: "वेबिनार",
    webinarNoun: "वेबिनार",
    webinarDescription: "लाइव और रिकॉर्ड किए गए वेबिनारों और ऑनलाइन संगोष्ठियों",

    onlineCourseName: "ऑनलाइन पाठ्यक्रम",
    onlineCourseTitle: "ऑनलाइन पाठ्यक्रम",
    onlineCoursePhrase: "ऑनलाइन पाठ्यक्रम",
    onlineCourseNoun: "ऑनलाइन पाठ्यक्रम",
    onlineCourseDescription:
      "ऑनलाइन पाठ्यक्रमों और MOOC (Coursera, edX, Udemy, FutureLearn)",

    presentationSlidesName: "PowerPoint प्रस्तुति",
    presentationSlidesTitle: "PowerPoint प्रस्तुति",
    presentationSlidesPhrase: "PowerPoint प्रस्तुति",
    presentationSlidesNoun: "PowerPoint प्रस्तुति",
    presentationSlidesDescription: "PowerPoint और अन्य प्रस्तुति स्लाइडों",

    imageName: "छवि या तस्वीर",
    imageTitle: "छवि या तस्वीर",
    imagePhrase: "छवि या तस्वीर",
    imageNoun: "छवि या तस्वीर",
    imageDescription: "तस्वीरों, कलाकृतियों, चार्टों और ऑनलाइन छवियों",

    movieName: "फ़िल्म",
    movieTitle: "फ़िल्म",
    moviePhrase: "फ़िल्म",
    movieNoun: "फ़िल्म",
    movieDescription: "किसी फ़िल्म",

    documentaryName: "वृत्तचित्र",
    documentaryTitle: "वृत्तचित्र",
    documentaryPhrase: "वृत्तचित्र",
    documentaryNoun: "वृत्तचित्र",
    documentaryDescription: "वृत्तचित्रों और गैर-काल्पनिक फ़िल्मों",

    tvShowName: "टीवी शो",
    tvShowTitle: "टीवी शो",
    tvShowPhrase: "टीवी शो",
    tvShowNoun: "टीवी शो",
    tvShowDescription: "किसी टीवी शो या धारावाहिक",

    songName: "गीत या संगीत",
    songTitle: "गीत या संगीत",
    songPhrase: "गीत या संगीत",
    songNoun: "गीत या संगीत",
    songDescription: "किसी गीत या संगीत रिकॉर्डिंग",

    poemName: "कविता",
    poemTitle: "कविता",
    poemPhrase: "कविता",
    poemNoun: "कविता",
    poemDescription: "कविताओं, पद्य और संकलनों या संग्रहों से ली गई काव्य-रचनाओं",

    courtCaseName: "न्यायालय मामला",
    courtCaseTitle: "न्यायालय मामले",
    courtCasePhrase: "न्यायालय मामले",
    courtCaseNoun: "न्यायालय मामले",
    courtCaseDescription: "किसी न्यायालय मामले या न्यायिक निर्णय",

    patentName: "पेटेंट",
    patentTitle: "पेटेंट",
    patentPhrase: "पेटेंट",
    patentNoun: "पेटेंट",
    patentDescription: "किसी पेटेंट या बौद्धिक संपदा आवेदन",

    encyclopediaName: "विश्वकोश प्रविष्टि",
    encyclopediaTitle: "विश्वकोश प्रविष्टि",
    encyclopediaPhrase: "विश्वकोश प्रविष्टि",
    encyclopediaNoun: "विश्वकोश प्रविष्टि",
    encyclopediaDescription: "किसी विश्वकोश लेख या प्रविष्टि",

    dictionaryName: "शब्दकोश प्रविष्टि",
    dictionaryTitle: "शब्दकोश प्रविष्टि",
    dictionaryPhrase: "शब्दकोश प्रविष्टि",
    dictionaryNoun: "शब्दकोश प्रविष्टि",
    dictionaryDescription: "किसी शब्दकोश परिभाषा या प्रविष्टि",

    datasetName: "डेटासेट",
    datasetTitle: "डेटासेट",
    datasetPhrase: "डेटासेट",
    datasetNoun: "डेटासेट",
    datasetDescription: "किसी डेटासेट या डेटाबेस",

    softwareName: "सॉफ़्टवेयर या ऐप",
    softwareTitle: "सॉफ़्टवेयर या ऐप",
    softwarePhrase: "सॉफ़्टवेयर या ऐप",
    softwareNoun: "सॉफ़्टवेयर या ऐप",
    softwareDescription: "सॉफ़्टवेयर, किसी ऐप या कंप्यूटर प्रोग्राम",

    videoGameName: "वीडियो गेम",
    videoGameTitle: "वीडियो गेम",
    videoGamePhrase: "वीडियो गेम",
    videoGameNoun: "वीडियो गेम",
    videoGameDescription: "वीडियो गेमों और संवादात्मक गेम सॉफ़्टवेयर",

    pressReleaseName: "प्रेस विज्ञप्ति",
    pressReleaseTitle: "प्रेस विज्ञप्ति",
    pressReleasePhrase: "प्रेस विज्ञप्ति",
    pressReleaseNoun: "प्रेस विज्ञप्ति",
    pressReleaseDescription: "किसी प्रेस विज्ञप्ति या समाचार विज्ञप्ति",

    reportName: "रिपोर्ट",
    reportTitle: "रिपोर्ट",
    reportPhrase: "रिपोर्ट",
    reportNoun: "रिपोर्ट",
    reportDescription: "किसी रिपोर्ट या श्वेत पत्र",

    preprintName: "प्रीप्रिंट",
    preprintTitle: "प्रीप्रिंट",
    preprintPhrase: "प्रीप्रिंट",
    preprintNoun: "प्रीप्रिंट",
    preprintDescription: "arXiv, bioRxiv और अन्य प्रीप्रिंट सर्वरों के शोध-पत्रों",

    bookChapterName: "पुस्तक अध्याय",
    bookChapterTitle: "पुस्तक अध्याय",
    bookChapterPhrase: "पुस्तक अध्याय",
    bookChapterNoun: "पुस्तक अध्याय",
    bookChapterDescription: "संपादित पुस्तकों के अध्यायों और निबंधों",

    chatgptName: "ChatGPT",
    chatgptTitle: "ChatGPT",
    chatgptPhrase: "ChatGPT",
    chatgptNoun: "ChatGPT",
    chatgptDescription: "ChatGPT और अन्य जनरेटिव AI उपकरणों",

    bibleName: "बाइबल",
    bibleTitle: "बाइबल",
    biblePhrase: "बाइबल",
    bibleNoun: "बाइबल",
    bibleDescription: "बाइबल, धर्मग्रंथों और अन्य पवित्र ग्रंथों",

    tedTalkName: "TED टॉक",
    tedTalkTitle: "TED टॉक",
    tedTalkPhrase: "TED टॉक",
    tedTalkNoun: "TED टॉक",
    tedTalkDescription: "TED टॉक जैसे रिकॉर्ड किए गए सम्मेलन व्याख्यानों",

    emailName: "ईमेल",
    emailTitle: "ईमेल",
    emailPhrase: "ईमेल",
    emailNoun: "ईमेल",
    emailDescription: "ईमेलों, पत्रों और अन्य व्यक्तिगत संचार",

    redditName: "Reddit या फ़ोरम पोस्ट",
    redditTitle: "Reddit या फ़ोरम पोस्ट",
    redditPhrase: "Reddit पोस्ट",
    redditNoun: "Reddit पोस्ट",
    redditDescription: "Reddit थ्रेडों, AMA सत्रों और ऑनलाइन फ़ोरम या चर्चा-मंच पोस्टों",

    tweetName: "X (Twitter) पोस्ट",
    tweetTitle: "X (Twitter) पोस्ट",
    tweetPhrase: "X पोस्ट",
    tweetNoun: "X पोस्ट",
    tweetDescription: "ट्वीटों और X (पहले Twitter) की पोस्टों",

    mapName: "मानचित्र",
    mapTitle: "मानचित्र",
    mapPhrase: "मानचित्र",
    mapNoun: "मानचित्र",
    mapDescription: "मुद्रित मानचित्रों, एटलसों और Google Maps जैसे गतिशील मानचित्रों",

    claudeName: "Claude",
    claudeTitle: "Claude",
    claudePhrase: "Claude",
    claudeNoun: "Claude",
    claudeDescription: "Claude वार्तालापों और Anthropic की अन्य AI-जनित सामग्री",

    geminiName: "Gemini",
    geminiTitle: "Gemini",
    geminiPhrase: "Gemini",
    geminiNoun: "Gemini",
    geminiDescription: "Google Gemini वार्तालापों और AI-जनित सामग्री",

    copilotName: "Microsoft Copilot",
    copilotTitle: "Microsoft Copilot",
    copilotPhrase: "Microsoft Copilot",
    copilotNoun: "Microsoft Copilot",
    copilotDescription: "Microsoft Copilot वार्तालापों और AI उत्तरों",

    perplexityName: "Perplexity",
    perplexityTitle: "Perplexity",
    perplexityPhrase: "Perplexity",
    perplexityNoun: "Perplexity",
    perplexityDescription: "Perplexity के AI उत्तरों, थ्रेडों और उनमें उद्धृत स्रोतों",

    aiImageName: "AI-जनित छवि",
    aiImageTitle: "AI-जनित छवि",
    aiImagePhrase: "AI-जनित छवि",
    aiImageNoun: "AI-जनित छवि",
    aiImageDescription:
      "DALL·E, Midjourney, Gemini और अन्य AI उपकरणों से बनाई गई छवियों",

    tiktokName: "TikTok वीडियो",
    tiktokTitle: "TikTok वीडियो",
    tiktokPhrase: "TikTok वीडियो",
    tiktokNoun: "TikTok वीडियो",
    tiktokDescription: "TikTok वीडियो और रचनाकारों की पोस्टों",

    instagramName: "Instagram पोस्ट",
    instagramTitle: "Instagram पोस्ट",
    instagramPhrase: "Instagram पोस्ट",
    instagramNoun: "Instagram पोस्ट",
    instagramDescription: "Instagram पोस्टों, रीलों और स्टोरियों",

    statuteName: "क़ानून या अधिनियम",
    statuteTitle: "क़ानून या अधिनियम",
    statutePhrase: "क़ानून या अधिनियम",
    statuteNoun: "क़ानून या अधिनियम",
    statuteDescription:
      "विधायिका द्वारा पारित अधिनियमों, क़ानूनों और संहिताबद्ध विधियों",

    isoStandardName: "ISO मानक",
    isoStandardTitle: "ISO मानक",
    isoStandardPhrase: "ISO मानक",
    isoStandardNoun: "ISO मानक",
    isoStandardDescription: "ISO, IEC और अन्य प्रकाशित तकनीकी मानकों",

    quranName: "क़ुरआन",
    quranTitle: "क़ुरआन",
    quranPhrase: "क़ुरआन",
    quranNoun: "क़ुरआन",
    quranDescription: "अरबी में या अनुवाद में क़ुरआन",

    ebookNoPageNumbersName: "बिना पृष्ठ संख्या वाली ई-पुस्तक",
    ebookNoPageNumbersTitle: "बिना पृष्ठ संख्या वाली ई-पुस्तक",
    ebookNoPageNumbersPhrase: "बिना पृष्ठ संख्या वाली ई-पुस्तक",
    ebookNoPageNumbersNoun: "बिना पृष्ठ संख्या वाली ई-पुस्तक",
    ebookNoPageNumbersDescription:
      "बिना निश्चित पृष्ठ संख्या वाली Kindle, EPUB और ऑनलाइन ई-पुस्तकों",

    speechName: "भाषण",
    speechTitle: "भाषण",
    speechPhrase: "भाषण",
    speechNoun: "भाषण",
    speechDescription: "प्रत्यक्ष या रिकॉर्ड किए गए भाषणों, संबोधनों और प्रवचनों",

    letterName: "पत्र",
    letterTitle: "पत्र",
    letterPhrase: "पत्र",
    letterNoun: "पत्र",
    letterDescription: "प्रकाशित पत्रों, अभिलेखागारों में रखे पत्रों और खुले पत्रों",

    secondarySourceName: "द्वितीयक स्रोत",
    secondarySourceTitle: "द्वितीयक स्रोत",
    secondarySourcePhrase: "द्वितीयक स्रोत",
    secondarySourceNoun: "द्वितीयक स्रोत",
    secondarySourceDescription: "किसी अन्य कृति में उद्धृत या संदर्भित किसी स्रोत",
  },

  // ---------------------------------------------------------------------------
  // STRINGS TRANSLATED; PAGE TYPES NOT YET ENABLED. These sections' string
  // values are now translated, but the page types they cover (`taxonomy`,
  // `compare`, `convert`) are still deliberately absent from
  // TRANSLATED_PAGE_TYPES — enabling them is a separate step that also needs
  // the data-derived facts and a real-render check (see CLAUDE.md's
  // "translating a page type takes two passes" note), not just this string pass.
  // ---------------------------------------------------------------------------
  // The three browse-by-facet pages under `/<locale>/citation-styles/…` — 32 academic
  // fields, 68 countries and 39 subject categories, 139 pages in one section because
  // they share a shell, a breadcrumb trail and a styles browser.
  //
  // The style NAMES, slugs and the CSL catalog itself stay in `src/data/**`: those are
  // subject matter. What the facets themselves are called is not — "Political Science",
  // "United Kingdom" and "Film & Media" are ordinary nouns that every reader expects in
  // their own language, and there are only 139 of them in total (see the `academicFields`,
  // `regions` and `styleCategories` sections below).
  taxonomyPage: {
    // ---- /citation-styles/field/<slug> ----
    fieldNotFoundTitle: "नहीं मिला",
    fieldMetaTitle: "{field} के लिए उद्धरण शैलियाँ - सर्वश्रेष्ठ संदर्भ शैलियाँ [2026]",
    fieldMetaDescription:
      "{field} में सबसे अधिक उपयोग की जाने वाली उद्धरण शैलियाँ जानें। अपने {fieldLower} शोध-पत्र, शोध-प्रबंध या जर्नल सबमिशन के लिए सही संदर्भ प्रारूप खोजें।",
    fieldOgTitle: "{field} के लिए उद्धरण शैलियाँ",
    fieldOgSubtitle: "आमतौर पर आवश्यक: {styles}.",
    fieldOgKind: "शैक्षणिक क्षेत्र के अनुसार",
    fieldKeywordStyle: "{field} उद्धरण शैली",
    fieldKeywordReferencing: "{field} में संदर्भ देना",
    fieldKeywordBest: "{fieldLower} के लिए सर्वश्रेष्ठ उद्धरण शैली",
    fieldKeywordBibliography: "{fieldLower} ग्रंथ सूची प्रारूप",
    fieldKeywordDiscipline: "विषय के अनुसार उद्धरण शैलियाँ",
    fieldBackLink: "← सभी उद्धरण शैलियाँ",
    fieldHeading: "{field} के लिए उद्धरण शैलियाँ",
    fieldRecommendedHeading: "अनुशंसित उद्धरण शैलियाँ",
    fieldRecommendedIntro:
      "{field} के शोध, शोध-पत्रिकाओं और कोर्सवर्क में आमतौर पर निम्नलिखित उद्धरण शैलियाँ उपयोग की जाती हैं। अधिक जानने और उद्धरण बनाना शुरू करने के लिए कोई शैली चुनें।",
    fieldStyleFallback: "{field} और संबंधित विषयों में प्रयुक्त एक उद्धरण शैली।",
    fieldRelatedHeading: "संबंधित क्षेत्र",
    fieldRelatedIntro: "संबंधित शैक्षणिक विषयों में प्रयुक्त उद्धरण शैलियाँ देखें:",
    fieldCtaHeading: "सभी उद्धरण शैलियाँ देखें",
    fieldCtaBody:
      "CitationEasy हर शैक्षणिक विषय में {count} उद्धरण शैलियों का समर्थन करता है। अपनी ज़रूरत का सटीक प्रारूप खोजने के लिए पूरा संग्रह देखें।",
    fieldCtaButton: "सभी शैलियाँ देखें →",
    fieldFaqWhichQ: "{field} में कौन-सी उद्धरण शैली उपयोग की जाती है?",
    fieldFaqWhichA:
      "{field} में उपयोग की जाने वाली उद्धरण शैली विशिष्ट शोध-पत्रिका, संस्थान या प्रशिक्षक की आवश्यकताओं पर निर्भर करती है। सामान्य शैलियों में {styles} शामिल हैं। आवश्यक प्रारूप जानने के लिए हमेशा अपने असाइनमेंट के निर्देश या लक्षित पत्रिका देखें।",
    fieldFaqSameQ: "क्या {field} की सभी शोध-पत्रिकाएँ एक ही शैली उपयोग करती हैं?",
    fieldFaqSameA:
      "नहीं, {field} की सभी शोध-पत्रिकाएँ एक ही उद्धरण शैली उपयोग नहीं करतीं। हालाँकि इस क्षेत्र में कुछ शैलियाँ अधिक सामान्य हैं, अलग-अलग पत्रिकाओं की अपनी स्वरूपण आवश्यकताएँ हो सकती हैं। अपनी पांडुलिपि तैयार करने से पहले हमेशा पत्रिका के सबमिशन दिशा-निर्देश देखें।",
    fieldFaqChooseQ: "मैं अपने {field} शोध-पत्र के लिए उद्धरण शैली कैसे चुनूँ?",
    fieldFaqChooseA:
      "अपने {field} शोध-पत्र के लिए उद्धरण शैली चुनने हेतु, पहले देखें कि क्या आपके प्रशिक्षक या लक्षित पत्रिका ने कोई शैली अनिवार्य की है। यदि नहीं, तो ऊपर दी गई {field} के लिए सामान्यतः अनुशंसित शैलियों में से कोई एक उपयोग करें। CitationEasy {count} से अधिक शैलियों का समर्थन करता है और उनमें से किसी में भी मुफ़्त में उद्धरण बना सकता है।",

    // ---- /citation-styles/country/<slug> ----
    countryNotFoundTitle: "देश नहीं मिला",
    countryMetaTitle: "{country} उद्धरण शैलियाँ - APA, MLA और अधिक",
    countryMetaDescription:
      "{country} में उपयोग की जाने वाली उद्धरण शैलियाँ देखें। {country} प्रारूपों के लिए निःशुल्क उद्धरण जनरेटर।",
    countryOgTitle: "{country} में उपयोग की जाने वाली उद्धरण शैलियाँ",
    countryOgKind: "देश के अनुसार",
    countryHeading: "{country} उद्धरण शैलियाँ",
    countryIntroOne:
      "{country} में उपयोग होने वाली या उससे जुड़ी {count} उद्धरण शैली। समर्पित जनरेटर खोलने के लिए इसे चुनें।",
    countryIntroMany:
      "{country} में उपयोग होने वाली या उससे जुड़ी {count} उद्धरण शैलियाँ। समर्पित जनरेटर खोलने के लिए एक चुनें।",
    countryBrowserTitle: "{country} उद्धरण शैलियाँ",

    // ---- /citation-styles/type/<slug> ----
    typeNotFoundTitle: "प्रकार नहीं मिला",
    typeMetaTitle: "{type} उद्धरण शैलियाँ - निःशुल्क जनरेटर",
    typeMetaDescription:
      "{typeLower} के लिए उद्धरण शैलियाँ। APA, MLA, Vancouver और अन्य। निःशुल्क उद्धरण जनरेटर।",
    typeOgTitle: "{type} उद्धरण शैलियाँ",
    typeOgKind: "विषय के अनुसार",
    typeHeading: "{type} उद्धरण शैलियाँ",
    typeIntroOne:
      "{typeLower} के लिए {count} उद्धरण शैली। सामान्य प्रश्नों सहित समर्पित जनरेटर खोलने के लिए इसे चुनें।",
    typeIntroMany:
      "{typeLower} के लिए {count} उद्धरण शैलियाँ। सामान्य प्रश्नों सहित समर्पित जनरेटर खोलने के लिए एक चुनें।",
    typeBrowserTitle: "{type} उद्धरण शैलियाँ",

    // ---- Shared chrome ----
    breadcrumbStyles: "उद्धरण शैलियाँ",
    // Title case, because the BreadcrumbList markup says "Citation Styles" while the
    // visible trail says "Citation styles". Two keys rather than one so translating
    // either does not silently change the other.
    breadcrumbStylesSchema: "उद्धरण शैलियाँ",
    breadcrumbByCountry: "देश के अनुसार",
    breadcrumbByDiscipline: "विषय के अनुसार",
    allStylesLink: "← सभी उद्धरण शैलियाँ",
    internationalLabel: "अंतरराष्ट्रीय",
  },

  // The 32 academic fields (`ACADEMIC_FIELDS` in src/data/style-pages.ts), keyed by
  // slug. Their one-sentence `description` is next door in `academicFieldDescriptions`.
  academicFields: {
    psychology: "मनोविज्ञान",
    education: "शिक्षा",
    sociology: "समाजशास्त्र",
    anthropology: "मानवशास्त्र",
    politicalScience: "राजनीति विज्ञान",
    economics: "अर्थशास्त्र",
    business: "वाणिज्य एवं प्रबंधन",
    literature: "साहित्य एवं भाषाएँ",
    history: "इतिहास",
    philosophy: "दर्शनशास्त्र",
    law: "विधि एवं कानूनी अध्ययन",
    medicine: "चिकित्सा एवं नैदानिक विज्ञान",
    nursing: "नर्सिंग एवं मिडवाइफरी",
    publicHealth: "लोक स्वास्थ्य एवं महामारी विज्ञान",
    pharmacy: "फार्मेसी",
    biology: "जीव विज्ञान एवं जीवन विज्ञान",
    chemistry: "रसायन विज्ञान",
    physics: "भौतिकी",
    engineering: "अभियांत्रिकी",
    computerScience: "कंप्यूटर विज्ञान",
    mathematics: "गणित एवं सांख्यिकी",
    environmentalScience: "पर्यावरण विज्ञान",
    earthScience: "पृथ्वी विज्ञान एवं भूविज्ञान",
    artHistory: "कला इतिहास एवं दृश्य कला",
    music: "संगीत एवं संगीतशास्त्र",
    theology: "धर्मशास्त्र एवं धार्मिक अध्ययन",
    socialWork: "समाज कार्य",
    linguistics: "भाषा विज्ञान",
    architecture: "वास्तुकला एवं नगर नियोजन",
    filmMedia: "फ़िल्म एवं मीडिया अध्ययन",
    journalism: "पत्रकारिता एवं जनसंचार",
    criminology: "अपराधशास्त्र एवं आपराधिक न्याय",
  },

  // The same 32 fields' one-sentence ledes — the opening paragraph of every
  // `/citation-styles/field/<slug>` page.
  //
  // Unlike everything above, these are hand-written per field rather than mail-merged
  // from a template, which is why the extraction pass left them in
  // `src/data/style-pages.ts`: translating them is a content job, not a string swap.
  // But "hand-written" describes how they were produced, not where they belong. With
  // the chrome translated and the lede still English, the page is the hybrid CLAUDE.md
  // calls worse than an honest redirect — translated furniture around an English core.
  // `academicFieldDescription()` (src/lib/i18n/data-labels.ts) falls back to the data
  // file's own value, so a field added upstream is untranslated rather than blank.
  academicFieldDescriptions: {
    psychology:
      "मनोविज्ञान, व्यवहार विज्ञान और संज्ञानात्मक अनुसंधान में सामान्यतः उपयोग की जाने वाली उद्धरण शैलियाँ।",
    education: "शिक्षा अनुसंधान, शिक्षाशास्त्र और पाठ्यचर्या अध्ययन के लिए उद्धरण शैलियाँ।",
    sociology:
      "समाजशास्त्रीय अनुसंधान और सामाजिक सिद्धांत में उपयोग की जाने वाली उद्धरण शैलियाँ।",
    anthropology: "मानवशास्त्रीय एवं नृजातीय अनुसंधान के लिए उद्धरण शैलियाँ।",
    politicalScience:
      "राजनीति विज्ञान, शासन और लोक नीति अनुसंधान के लिए उद्धरण शैलियाँ।",
    economics: "अर्थशास्त्र और अर्थमिति अनुसंधान में उपयोग की जाने वाली उद्धरण शैलियाँ।",
    business: "व्यवसाय, प्रबंधन, विपणन और वित्त अनुसंधान के लिए उद्धरण शैलियाँ।",
    literature: "साहित्यिक अध्ययन, भाषा विज्ञान और भाषा अनुसंधान के लिए उद्धरण शैलियाँ।",
    history: "ऐतिहासिक अनुसंधान, इतिहासलेखन और अभिलेखीय अध्ययन के लिए उद्धरण शैलियाँ।",
    philosophy: "दार्शनिक लेखन और नैतिकता अनुसंधान के लिए उद्धरण शैलियाँ।",
    law: "न्यायालयी दस्तावेज़ों, विधि पत्रिकाओं और विधिक शोध के लिए विधिक उद्धरण शैलियाँ।",
    medicine: "चिकित्सा अनुसंधान, नैदानिक अध्ययन और स्वास्थ्य सेवा के लिए उद्धरण शैलियाँ।",
    nursing: "नर्सिंग अनुसंधान और स्वास्थ्य सेवा अभ्यास के लिए उद्धरण शैलियाँ।",
    publicHealth:
      "लोक स्वास्थ्य अनुसंधान और महामारी विज्ञान अध्ययन के लिए उद्धरण शैलियाँ।",
    pharmacy: "औषध एवं औषध विज्ञान अनुसंधान के लिए उद्धरण शैलियाँ।",
    biology: "जैविक अनुसंधान, पारिस्थितिकी और आनुवंशिकी के लिए उद्धरण शैलियाँ।",
    chemistry:
      "रसायन विज्ञान, जैव रसायन और पदार्थ विज्ञान अनुसंधान के लिए उद्धरण शैलियाँ।",
    physics: "भौतिकी, खगोल भौतिकी और अनुप्रयुक्त भौतिकी अनुसंधान के लिए उद्धरण शैलियाँ।",
    engineering: "अभियांत्रिकी और अनुप्रयुक्त प्रौद्योगिकी अनुसंधान के लिए उद्धरण शैलियाँ।",
    computerScience:
      "कंप्यूटर विज्ञान, एआई और सॉफ़्टवेयर इंजीनियरिंग अनुसंधान के लिए उद्धरण शैलियाँ।",
    mathematics: "गणित, अनुप्रयुक्त गणित और सांख्यिकी अनुसंधान के लिए उद्धरण शैलियाँ।",
    environmentalScience: "पर्यावरण अनुसंधान और सततता अध्ययन के लिए उद्धरण शैलियाँ।",
    earthScience: "भूविज्ञान, भू-भौतिकी और पृथ्वी विज्ञान अनुसंधान के लिए उद्धरण शैलियाँ।",
    artHistory: "कला इतिहास, दृश्य संस्कृति और संग्रहालय अध्ययन के लिए उद्धरण शैलियाँ।",
    music: "संगीत अनुसंधान, सिद्धांत और प्रदर्शन अध्ययन के लिए उद्धरण शैलियाँ।",
    theology: "धर्मशास्त्रीय एवं धार्मिक शोध के लिए उद्धरण शैलियाँ।",
    socialWork: "समाज कार्य अनुसंधान और अभ्यास के लिए उद्धरण शैलियाँ।",
    linguistics:
      "भाषाविज्ञान, स्वनविज्ञान और भाषा-विज्ञान अनुसंधान के लिए उद्धरण शैलियाँ।",
    architecture: "वास्तुकला, शहरी अभिकल्पन और नियोजन अनुसंधान के लिए उद्धरण शैलियाँ।",
    filmMedia: "फ़िल्म, टेलीविज़न, मीडिया और संचार अध्ययन के लिए उद्धरण शैलियाँ।",
    journalism: "पत्रकारिता, मीडिया अध्ययन और संचार अनुसंधान के लिए उद्धरण शैलियाँ।",
    criminology: "अपराधशास्त्र और आपराधिक न्याय अनुसंधान के लिए उद्धरण शैलियाँ।",
  },

  // The 68 country/region facets (`REGIONS` in src/data/citation-styles.ts), keyed by
  // slug. `getRegionCountryCode` still keys off the English data value, so translating these
  // moves the label without moving the flag.
  regions: {
    unitedStates: "संयुक्त राज्य अमेरिका",
    unitedKingdom: "यूनाइटेड किंगडम",
    australia: "ऑस्ट्रेलिया",
    canada: "कनाडा",
    newZealand: "न्यूज़ीलैंड",
    ireland: "आयरलैंड",
    southAfrica: "दक्षिण अफ़्रीका",
    germany: "जर्मनी",
    france: "फ़्रांस",
    spain: "स्पेन",
    italy: "इटली",
    netherlands: "नीदरलैंड",
    belgium: "बेल्जियम",
    switzerland: "स्विट्ज़रलैंड",
    austria: "ऑस्ट्रिया",
    portugal: "पुर्तगाल",
    luxembourg: "लक्ज़मबर्ग",
    sweden: "स्वीडन",
    norway: "नॉर्वे",
    denmark: "डेनमार्क",
    finland: "फ़िनलैंड",
    iceland: "आइसलैंड",
    poland: "पोलैंड",
    czechRepublic: "चेक गणराज्य",
    hungary: "हंगरी",
    romania: "रोमानिया",
    russia: "रूस",
    ukraine: "यूक्रेन",
    greece: "यूनान",
    turkey: "तुर्की",
    croatia: "क्रोएशिया",
    slovenia: "स्लोवेनिया",
    slovakia: "स्लोवाकिया",
    serbia: "सर्बिया",
    bulgaria: "बुल्गारिया",
    lithuania: "लिथुआनिया",
    latvia: "लातविया",
    estonia: "एस्टोनिया",
    japan: "जापान",
    china: "चीन",
    southKorea: "दक्षिण कोरिया",
    india: "भारत",
    singapore: "सिंगापुर",
    hongKong: "हांगकांग",
    taiwan: "ताइवान",
    malaysia: "मलेशिया",
    indonesia: "इंडोनेशिया",
    thailand: "थाईलैंड",
    vietnam: "वियतनाम",
    philippines: "फ़िलीपींस",
    pakistan: "पाकिस्तान",
    bangladesh: "बांग्लादेश",
    sriLanka: "श्रीलंका",
    israel: "इज़राइल",
    saudiArabia: "सऊदी अरब",
    unitedArabEmirates: "संयुक्त अरब अमीरात",
    brazil: "ब्राज़ील",
    mexico: "मेक्सिको",
    argentina: "अर्जेंटीना",
    chile: "चिली",
    colombia: "कोलंबिया",
    peru: "पेरू",
    venezuela: "वेनेज़ुएला",
    egypt: "मिस्र",
    nigeria: "नाइजीरिया",
    kenya: "केन्या",
    morocco: "मोरक्को",
    international: "अंतरराष्ट्रीय",
  },

  // The 39 subject categories (`CATEGORIES` in src/data/citation-styles.ts), keyed by
  // slug. The emoji beside each one stays in the data — it is language-neutral.
  styleCategories: {
    medicine: "चिकित्सा",
    nursing: "नर्सिंग",
    publicHealth: "लोक स्वास्थ्य",
    pharmacy: "फार्मेसी",
    dentistry: "दंत चिकित्सा",
    veterinary: "पशु चिकित्सा विज्ञान",
    psychology: "मनोविज्ञान",
    sociology: "समाजशास्त्र",
    anthropology: "मानवशास्त्र",
    politicalScience: "राजनीति विज्ञान",
    economics: "अर्थशास्त्र",
    education: "शिक्षा",
    socialWork: "समाज कार्य",
    biology: "जीव विज्ञान",
    chemistry: "रसायन विज्ञान",
    physics: "भौतिकी",
    environmentalScience: "पर्यावरण विज्ञान",
    earthScience: "पृथ्वी विज्ञान एवं भूविज्ञान",
    agriculture: "कृषि विज्ञान",
    ecology: "पारिस्थितिकी",
    engineering: "अभियांत्रिकी",
    computerScience: "कंप्यूटर विज्ञान",
    mathematics: "गणित",
    statistics: "सांख्यिकी",
    history: "इतिहास",
    literature: "साहित्य",
    philosophy: "दर्शनशास्त्र",
    linguistics: "भाषा विज्ञान",
    artHistory: "कला इतिहास",
    music: "संगीत",
    filmMedia: "फ़िल्म एवं मीडिया",
    archaeology: "पुरातत्व विज्ञान",
    law: "विधि",
    business: "वाणिज्य",
    architecture: "वास्तुकला",
    religion: "धर्म एवं धर्मशास्त्र",
    geography: "भूगोल",
    general: "सामान्य / बहु-विषयक",
    other: "अन्य",
  },

  // The closed vocabularies `STYLE_LANDING_PAGES` (src/data/style-pages.ts) draws on for
  // the 30 major styles: what each style calls its end-of-paper list, the shape of its
  // in-text citation, its edition, and the disciplines that require it. The comparison
  // pages print all four in a table and the field pages print two of them under every
  // style card, so leaving them in the data means a translated page with an English
  // table in the middle of it.
  //
  // Style NAMES (`name`, `fullName`) are NOT here: a style's official name is what it
  // is called everywhere. The 30 hand-written taglines are, in `styleTaglines` below.
  styleFacts: {
    // `referenceListName` — 6 distinct values across the 30 styles.
    listReferenceList: "संदर्भ सूची",
    listWorksCited: "उद्धृत रचना सूची",
    listReferences: "संदर्भों की सूची",
    listBibliography: "ग्रंथ सूची",
    listTableOfAuthorities: "विधिक स्रोत तालिका",
    listReferencesCited: "उद्धृत संदर्भ सूची",
    listLowerReferenceList: "संदर्भ सूची",
    listLowerWorksCited: "उद्धृत रचना सूची",
    listLowerReferences: "संदर्भों की सूची",
    listLowerBibliography: "ग्रंथ सूची",
    listLowerTableOfAuthorities: "विधिक स्रोत तालिका",
    listLowerReferencesCited: "उद्धृत संदर्भ सूची",

    // `inTextFormat` — 14 distinct values. "Author", "Year" and "Page" are slot names,
    // not part of the citation, so they read as English words on a Spanish page.
    inTextAuthorCommaYear: "(लेखक, वर्ष)",
    inTextAuthorPage: "(लेखक पृष्ठ)",
    inTextAuthorYear: "(लेखक वर्ष)",
    inTextSuperscriptOrBracketed: "सुपरस्क्रिप्ट या कोष्ठक में संख्या (1)",
    inTextBracketedNumbers: "वर्गकोष्ठक में संख्या [1]",
    inTextSuperscriptNumbers: "सुपरस्क्रिप्ट संख्या¹",
    inTextSuperscriptOrAuthorYear: "सुपरस्क्रिप्ट संख्या या (लेखक वर्ष)",
    inTextKeyBased: "कुंजी-आधारित संदर्भ",
    inTextSuperscriptOrAuthorCommaYear: "सुपरस्क्रिप्ट संख्या या (लेखक, वर्ष)",
    inTextFootnotesCaseLegislation: "मुकदमों और विधानों के उद्धरण सहित पाद-टिप्पणियाँ",
    inTextFootnotesSignals: "संकेत संक्षिप्ताक्षरों सहित पाद-टिप्पणियाँ",
    inTextFootnotesPinpoint: "सटीक संदर्भ स्थान सहित पाद-टिप्पणियाँ",
    inTextParenNumbers: "कोष्ठक में संख्या (1)",
    inTextItalicNumbers: "इटैलिक संख्या (1)",

    // `edition` — 12 distinct values. The ordinal and the word "edition" translate; the
    // handbook name inside "Cite Them Right 11th edition" does not.
    edition4th: "4वाँ संस्करण",
    edition5th: "5वाँ संस्करण",
    edition7th: "7वाँ संस्करण",
    edition8th: "8वाँ संस्करण",
    edition9th: "9वाँ संस्करण",
    edition11th: "11वाँ संस्करण",
    edition18th: "18वाँ संस्करण",
    edition22nd: "22वाँ संस्करण",
    editionCiteThemRight11th: "Cite Them Right 11वाँ संस्करण",
    editionIcmjeStandard: "ICMJE मानक",
    editionStandard: "मानक",
    editionCurrent: "वर्तमान",

    // `fields` — the 67 discipline names the 30 styles are tagged with.
    fieldAcoustics: "ध्वनिकी",
    fieldAnthropology: "मानवशास्त्र",
    fieldAppliedPhysics: "व्यावहारिक भौतिकी",
    fieldArchaeology: "पुरातत्व विज्ञान",
    fieldArts: "कला",
    fieldAstrophysics: "खगोल भौतिकी",
    fieldAustralianLaw: "ऑस्ट्रेलियाई विधि",
    fieldBiochemistry: "जैव रसायन विज्ञान",
    fieldBiology: "जीव विज्ञान",
    fieldBiomedicalSciences: "जैव चिकित्सा विज्ञान",
    fieldBiotechnology: "जैव प्रौद्योगिकी",
    fieldBusiness: "वाणिज्य",
    fieldCellBiology: "कोशिका विज्ञान",
    fieldChemicalEngineering: "रासायनिक अभियांत्रिकी",
    fieldChemistry: "रसायन विज्ञान",
    fieldClinicalResearch: "नैदानिक अनुसंधान",
    fieldComputerScience: "कंप्यूटर विज्ञान",
    fieldCondensedMatter: "संघनित पदार्थ भौतिकी",
    fieldCourtDocuments: "न्यायालय दस्तावेज़",
    fieldCriminology: "अपराधशास्त्र",
    fieldCulturalStudies: "सांस्कृतिक अध्ययन",
    fieldDemography: "जनसांख्यिकी",
    fieldEcology: "पारिस्थितिकी",
    fieldEducation: "शिक्षा",
    fieldElectronics: "इलेक्ट्रॉनिकी",
    fieldEngineering: "अभियांत्रिकी",
    fieldEnvironmentalScience: "पर्यावरण विज्ञान",
    fieldEpidemiology: "महामारी विज्ञान",
    fieldEthnography: "नृवंशविज्ञान",
    fieldGenetics: "आनुवंशिकी",
    fieldGeology: "भूविज्ञान",
    fieldGlobalHealth: "वैश्विक स्वास्थ्य",
    fieldHealthSciences: "स्वास्थ्य विज्ञान",
    fieldHistory: "इतिहास",
    fieldHumanities: "मानविकी",
    fieldInformationSystems: "सूचना प्रणाली",
    fieldInformationTechnology: "सूचना प्रौद्योगिकी",
    fieldInternationalRelations: "अंतरराष्ट्रीय संबंध",
    fieldJurisprudence: "विधिशास्त्र",
    fieldLanguages: "भाषाएँ",
    fieldLaw: "विधि",
    fieldLawReview: "विधि पत्रिका",
    fieldLegalStudies: "विधिक अध्ययन",
    fieldLifeSciences: "जीवन विज्ञान",
    fieldLiterature: "साहित्य",
    fieldMaterialsScience: "पदार्थ विज्ञान",
    fieldMathematics: "गणित",
    fieldMedicine: "चिकित्सा विज्ञान",
    fieldMolecularBiology: "आणविक जीव विज्ञान",
    fieldMultidisciplinary: "बहु-विषयक",
    fieldMultidisciplinaryScience: "बहु-विषयक विज्ञान",
    fieldNaturalSciences: "प्राकृतिक विज्ञान",
    fieldNursing: "नर्सिंग",
    fieldPharmacy: "फार्मेसी",
    fieldPhysics: "भौतिकी",
    fieldPoliticalScience: "राजनीति विज्ञान",
    fieldPsychology: "मनोविज्ञान",
    fieldPublicHealth: "लोक स्वास्थ्य",
    fieldPublicPolicy: "लोक नीति",
    fieldPublishing: "प्रकाशन",
    fieldScience: "विज्ञान",
    fieldSciences: "विज्ञान",
    fieldSocialSciences: "सामाजिक विज्ञान",
    fieldSocialWork: "समाज कार्य",
    fieldSociology: "समाजशास्त्र",
    fieldSoftwareEngineering: "सॉफ़्टवेयर अभियांत्रिकी",
    fieldTheology: "धर्मशास्त्र",
  },

  // The 30 major styles' hero taglines (`STYLE_LANDING_PAGES[].tagline`), keyed by
  // slug.
  //
  // Per-page hand-written copy, not a template — which is why they outlived the
  // extraction pass in `src/data/style-pages.ts`. Three page types print them: the
  // style landing page's hero, the card for each recommended style on a field
  // taxonomy page, and the lower-cased clause inside a comparison page's opening
  // sentence ("APA (…) is the most widely used citation style in the social
  // sciences"). Leaving them in the data means an English sentence in the first
  // paragraph of an otherwise translated page. `styleTagline()`
  // (src/lib/i18n/data-labels.ts) falls back to the data file's own value.
  styleTaglines: {
    apa: "सामाजिक विज्ञान में सबसे अधिक प्रयुक्त उद्धरण शैली",
    mla: "मानविकी के लिए मानक उद्धरण शैली",
    chicago: "लेखकों, संपादकों और प्रकाशकों के लिए अमेरिका की सबसे विश्वसनीय शैली-पुस्तिका",
    harvard: "यूके और ऑस्ट्रेलिया के विश्वविद्यालयों में सबसे लोकप्रिय संदर्भ शैली",
    vancouver: "चिकित्सा और जैव-चिकित्सा पत्रिकाओं के लिए मानक उद्धरण शैली",
    ieee: "अभियांत्रिकी और कंप्यूटर विज्ञान के लिए सर्वाधिक प्रयुक्त उद्धरण शैली",
    ama: "अमेरिकी चिकित्सा पत्रिकाओं के लिए उद्धरण मानक",
    turabian: "Chicago शैली का विद्यार्थी-अनुकूल संस्करण",
    cse: "प्राकृतिक एवं भौतिक विज्ञान के लिए पसंदीदा उद्धरण शैली",
    bibtex: "LaTeX उपयोगकर्ताओं और अकादमिक टाइपसेटिंग के लिए ग्रंथ सूची प्रारूप",
    nature: "विश्व की अग्रणी बहु-विषयक पत्रिका द्वारा उपयोग की जाने वाली उद्धरण शैली",
    acs: "रसायन विज्ञान और रासायनिक विज्ञान के लिए उद्धरण मानक",
    oscola: "यूके की विधि शालाओं और पत्रिकाओं के लिए मानक विधिक उद्धरण शैली",
    bluebook: "अमेरिकी न्यायालयों और विधि पत्रिकाओं के लिए सर्वोच्च विधिक उद्धरण प्रणाली",
    aglc: "ऑस्ट्रेलियाई विधि शालाओं और न्यायालयों के लिए मानक विधिक उद्धरण शैली",
    asa: "समाजशास्त्र और सामाजिक शोध के लिए मानक उद्धरण शैली",
    apsa: "राजनीति विज्ञान शोध और पत्रिकाओं के लिए उद्धरण शैली",
    aaa: "मानवशास्त्रीय शोध के लिए मानक उद्धरण शैली",
    nlm: "PubMed और National Library of Medicine द्वारा उपयोग किया जाने वाला उद्धरण मानक",
    acm: "ACM सम्मेलनों और कंप्यूटिंग शोध के लिए उद्धरण शैली",
    aps: "Physical Review और APS पत्रिकाओं के लिए उद्धरण शैली",
    aip: "AIP और भौतिकी पत्रिकाओं के लिए उद्धरण शैली",
    cell: "Cell Press और प्रमुख जीव विज्ञान पत्रिकाओं के लिए उद्धरण शैली",
    science: "Science पत्रिका और AAAS प्रकाशनों के लिए उद्धरण शैली",
    plos: "PLOS की मुक्त-पहुँच पत्रिकाओं के लिए उद्धरण शैली",
    bmj: "BMJ और प्रमुख ब्रिटिश चिकित्सा पत्रिकाओं के लिए उद्धरण शैली",
    lancet: "The Lancet समूह की चिकित्सा पत्रिकाओं के लिए उद्धरण शैली",
    jama: "JAMA और JAMA Network पत्रिकाओं के लिए उद्धरण शैली",
    elsevierHarvard:
      "Elsevier की पत्रिकाओं में उपयोग किया जाने वाला Harvard-शैली संस्करण",
    springer: "Springer Nature की पत्रिकाओं और पुस्तकों के लिए उद्धरण शैली",
  },

  // The 105 style-versus-style pages at `/<locale>/compare/<slug>`.
  //
  // The two style names arrive as placeholder values and are never translated. The
  // facts in the table come from `styleFacts` above and the taglines from
  // `styleTaglines`; only `fullName` stays in `src/data/style-pages.ts`, because an
  // official name is the same in every language.
  comparePage: {
    notFoundTitle: "नहीं मिला",
    metaTitle: "{a} बनाम {b} - मुख्य अंतर स्पष्ट [2026]",
    metaDescription:
      "{a} और {b} उद्धरण शैलियों की सीधी तुलना करें। सही शैली चुनने के लिए स्वरूपण, पाठ-अंतर्गत उद्धरण और संदर्भ सूची में मुख्य अंतर जानें।",
    ogTitle: "{a} बनाम {b}",
    ogSubtitle:
      "पाठ-अंतर्गत प्रारूप, संदर्भ प्रविष्टियाँ, बड़े अक्षरों का प्रयोग, और किस विषय में कौन-सी शैली आवश्यक है।",
    ogKind: "शैली तुलना",
    keywordVs: "{a} बनाम {b}",
    keywordVersus: "{a} बनाम {b}",
    keywordDifference: "{a} और {b} के बीच अंतर",
    keywordOr: "{a} या {b}",
    keywordComparison: "उद्धरण शैली तुलना",
    breadcrumbCompare: "शैलियों की तुलना करें",
    breadcrumbCurrent: "{a} बनाम {b}",
    backLink: "← तुलना उपकरण पर वापस जाएँ",
    heading: "{a} बनाम {b}: मुख्य अंतर",
    intro:
      "{a} और {b} अकादमिक जगत में सबसे अधिक उपयोग की जाने वाली दो उद्धरण शैलियाँ हैं, लेकिन इनमें महत्वपूर्ण अंतर हैं। {introA} {introB} इन अंतरों को समझने से आपको अपने शोध-पत्र के लिए सही प्रारूप चुनने में मदद मिलेगी।",
    styleIntro: "{style} ({fullName}) {tagline}.",
    styleIntroFallback:
      "{style} एक लोकप्रिय उद्धरण शैली है जो कई शैक्षणिक विषयों में उपयोग की जाती है।",
    tableHeading: "समानांतर तुलना",
    tableFeature: "विशेषता",
    tableCitationSystem: "उद्धरण प्रणाली",
    tableInText: "पाठ-अंतर्गत प्रारूप",
    tableReferenceList: "संदर्भ सूची का नाम",
    tableEdition: "संस्करण",
    tableCommonFields: "सामान्य क्षेत्र",
    // Title case, for the table cell. `styleLanding.system*` says "Author–date" for the
    // fact list on the style landing pages; both spellings are deliberate.
    systemAuthorDate: "लेखक–वर्ष",
    systemNumbered: "क्रमांकित",
    systemFootnotes: "पाद-टिप्पणियाँ",
    // The same three systems inside a sentence ("uses a numbered citation system").
    describeAuthorDate: "कोष्ठकीय लेखक-वर्ष",
    describeNumbered: "क्रमांकित",
    describeFootnotes: "पाद-टिप्पणी-आधारित",
    whenToUseHeading: "{style} का उपयोग कब करें",
    whenToUseBody:
      "{style} ({fullName}) में {system} उद्धरण प्रणाली है, जिसमें पाठ-अंतर्गत उद्धरण {inText} रूप में होते हैं और शोध-पत्र के अंत में {list} होती है। यह {fields}{more} में सबसे अधिक उपयोग होती है।",
    whenToUseMoreFields: ", और संबंधित क्षेत्रों",
    whenToUseFallback:
      "{style} एक व्यापक रूप से मान्यता प्राप्त उद्धरण शैली है। यह पुष्टि करने के लिए कि क्या आवश्यक प्रारूप {style} है, अपने असाइनमेंट के निर्देश या लक्षित पत्रिका देखें।",
    ctaHeading: "अंतर को व्यावहारिक रूप में देखें",
    ctaBodyBefore: "आज़माएँ हमारा",
    ctaBodyLink: "इंटरैक्टिव तुलना उपकरण",
    ctaBodyAfter:
      ", जिससे आप अपने स्रोतों का उपयोग करके {a} और {b} के उद्धरणों की तुलना समानांतर रूप से कर सकें।",
    ctaCiteIn: "{style} में उद्धृत करें →",
    faqDifferenceQ: "{a} और {b} के बीच क्या अंतर है?",
    faqDifferenceA:
      "{a} और {b} अपने पाठ-अंतर्गत उद्धरण प्रारूप, संदर्भ सूची की संरचना और उपयोग करने वाले शैक्षणिक विषयों में भिन्न हैं। {detail}",
    faqDifferenceDetail:
      "{a} में पाठ-अंतर्गत उद्धरण {inTextA} रूप में होते हैं और {listA} होती है, जबकि {b} में {inTextB} रूप में उद्धरण होते हैं और {listB} होती है।",
    faqDifferenceDetailFallback:
      "प्रत्येक शैली में उद्धरण स्वरूपित करने, ग्रंथ सूची व्यवस्थित करने और विभिन्न प्रकार के स्रोतों को संभालने के लिए अलग-अलग नियम होते हैं।",
    faqBetterQ: "{a} या {b}, कौन बेहतर है?",
    faqBetterA:
      "न तो {a} और न ही {b} स्वाभाविक रूप से बेहतर है। सही चुनाव आपके शैक्षणिक विषय, आपके प्रशिक्षक की आवश्यकताओं या आप जिस पत्रिका में सबमिट कर रहे हैं, उस पर निर्भर करता है। किस शैली का उपयोग करना है यह तय करने के लिए अपने असाइनमेंट के निर्देश या लक्षित प्रकाशन देखें।",
    faqSwitchQ: "क्या {a} और {b} के बीच बदलना संभव है?",
    faqSwitchA:
      "हाँ, CitationEasy के निःशुल्क उद्धरण जनरेटर का उपयोग करके {a} और {b} के बीच बदला जा सकता है। बस वांछित शैली चुनें और आपके उद्धरण स्वतः पुनः प्रारूपित हो जाएँगे। हालाँकि, जब तक आपके प्रशिक्षक अन्यथा न कहें, आपको प्रति शोध-पत्र केवल एक ही शैली उपयोग करनी चाहिए।",
  },

  // The ~21 converter-pair pages at `/<locale>/convert/<slug>`.
  //
  // Only the shell is here; each pair's own four strings are in `converterCopy` below.
  // The format names (DOI, ISBN, BibTeX, RIS, CSL-JSON, PubMed ID, arXiv ID, Word) are
  // identifiers, never translated.
  converterPage: {
    notFoundTitle: "परिवर्तक नहीं मिला",
    metaTitle: "{title} - निःशुल्क और तुरंत",
    ogTitle: "{title}",
    ogKind: "परिवर्तक",
    breadcrumbConverters: "परिवर्तक",
    breadcrumbLabel: "पथ प्रदर्शक",
    whenHeading: "इसकी आवश्यकता कब होती है",
    relatedHeading: "संबंधित परिवर्तक",
    allConverters: "सभी परिवर्तक",
    formatConverterTool: "उद्धरण प्रारूप परिवर्तक",
    faqHowQ: "मैं {input} को {output} में कैसे बदलूँ?",
    faqHowA:
      "{intro} सब कुछ निःशुल्क है, न कोई खाता चाहिए और न ही रूपांतरण की कोई सीमा।",
    faqPrivacyQ: "क्या मेरा डेटा कहीं अपलोड होता है?",
    faqPrivacyIdentifier:
      "प्रत्येक {input} को संबंधित सार्वजनिक मेटाडेटा सेवा में जाँचा जाता है (DOI के लिए Crossref, PMID के लिए PubMed, ISBN के लिए पुस्तकालय रिकॉर्ड), और केवल पहचानकर्ता ही भेजा जाता है — आपके दस्तावेज़ कभी नहीं। प्रारूपित परिणाम आपके अपने हैं, जिन्हें आप कॉपी या डाउनलोड कर सकते हैं; कुछ भी संग्रहीत नहीं किया जाता।",
    faqPrivacyLocal:
      "नहीं — आपके द्वारा चिपकाया या अपलोड किया गया {input} पूरी तरह आपके ब्राउज़र में ही विश्लेषित होता है। {detail}",
    faqPrivacyDetailStyle:
      "केवल विश्लेषित संदर्भ फ़ील्ड (लेखक, शीर्षक, वर्ष) उद्धरण बनाने के लिए हमारे फ़ॉर्मेटर को भेजी जाती हैं; आपकी फ़ाइल स्वयं कभी आपके डिवाइस से बाहर नहीं जाती।",
    faqPrivacyDetailOffline:
      "रूपांतरण पूरी तरह पृष्ठ के भीतर ऑफ़लाइन चलता है — किसी भी सर्वर पर कुछ नहीं भेजा जाता।",
    faqUsefulQ: "{input} से {output} में रूपांतरण कब उपयोगी होता है?",
    faqOtherQ: "क्या अन्य शैलियों और प्रारूपों में भी बदलना संभव है?",
    faqOtherA:
      "हाँ। CitationEasy का जनरेटर किसी भी स्रोत को {count} उद्धरण शैलियों में प्रारूपित करता है, संदर्भ सूची Word, RTF, BibTeX, RIS और CSL-JSON में निर्यात होती है, और परिवर्तक हब हर सीधी रूपांतरण जोड़ी को सूचीबद्ध करता है। यदि आपको पहले से प्रारूपित पाठ को एक शैली से दूसरी शैली में फिर से लिखवाना है, तो इसके बजाय उद्धरण प्रारूप परिवर्तक उपकरण का उपयोग करें।",
  },

  // The 21 converter pairs' own copy (`CONVERTER_PAIRS` in src/data/converters.ts),
  // keyed by slug: title, meta description, the intro paragraph under the H1, and the
  // "when you need this" paragraph.
  //
  // Four hand-written strings per pair, and `src/data/converters.ts` has a quality rule
  // saying they must stay hand-written — no mail-merged sentences, because mass-templated
  // pages are what earned the site a scaled-content penalty. That rule is about how the
  // copy is authored; it says nothing about which language a reader gets it in. Left in
  // the data file they are the entire body of an otherwise translated page.
  // `converterPairCopy()` (src/lib/i18n/data-labels.ts) returns all four at once and
  // falls back to the data file per field, so a converter added upstream ships English
  // copy rather than a blank page.
  converterCopy: {
    doiToApaTitle: "DOI से APA परिवर्तक",
    doiToApaMetaDescription:
      "DOI चिपकाएँ (एक पंक्ति में एक) और प्रकाशक के आधिकारिक Crossref मेटाडेटा से तुरंत APA 7 संदर्भ पाएँ। निःशुल्क, कोई खाता नहीं।",
    doiToApaIntro:
      "DOI पहले से ही प्रकाशक के प्रामाणिक मेटाडेटा की ओर इंगित करता है, इसलिए APA संदर्भ हाथ से टाइप करने की कोई आवश्यकता नहीं। एक पंक्ति में एक DOI चिपकाएँ और हर एक पूर्ण APA 7 संदर्भ में बदल जाएगा — लेखकों के नाम उलटे क्रम में, शीर्षक में केवल पहला अक्षर बड़ा, पत्रिका का नाम इटैलिक में, और APA द्वारा आवश्यक https://doi.org/ लिंक सहित।",
    doiToApaUseCase:
      "आम स्थिति: आपके प्रोफ़ेसर को APA संदर्भ सूची चाहिए, और आपके पास केवल पढ़ते समय सहेजे गए DOI का ढेर है। पूरा ढेर चिपकाएँ, सूची कॉपी करें।",
    doiToMlaTitle: "DOI से MLA परिवर्तक",
    doiToMlaMetaDescription:
      "Crossref मेटाडेटा का उपयोग करके DOI को स्वतः MLA 9 works-cited प्रविष्टियों में बदलें। एक पंक्ति में एक DOI चिपकाएँ — निःशुल्क, कुछ भी इंस्टॉल करने की आवश्यकता नहीं।",
    doiToMlaIntro:
      "MLA 9 किसी शोध-पत्रिका लेख को एक 'कंटेनर श्रृंखला' के रूप में देखता है — लेख का शीर्षक उद्धरण चिह्नों में, पत्रिका का नाम इटैलिक में, खंड, अंक, वर्ष, पृष्ठ — जिसे हाथ से जोड़ना उलझन भरा है। DOI लुकअप प्रकाशक के रिकॉर्ड से हर स्थान को भरता है, इसलिए works-cited प्रविष्टि पहली बार में ही सही बनती है।",
    doiToMlaUseCase:
      "उपयोगी जब मानविकी के किसी पाठ्यक्रम में MLA आवश्यक हो, लेकिन आपके स्रोत विज्ञान-केंद्रित डेटाबेस से आए हों जो केवल DOI देते हैं।",
    doiToBibtexTitle: "DOI से BibTeX परिवर्तक",
    doiToBibtexMetaDescription:
      "LaTeX और Overleaf के लिए DOI को BibTeX प्रविष्टियों में बदलें। एक पंक्ति में एक DOI चिपकाएँ, तैयार .bib फ़ाइल डाउनलोड करें — निःशुल्क और असीमित।",
    doiToBibtexIntro:
      "हर LaTeX शोध-पत्र को अंततः अपनी .bib फ़ाइल चाहिए ही होती है। एक पंक्ति में एक DOI चिपकाएँ और जनरेट किए गए cite key सहित स्वच्छ @article प्रविष्टियाँ पाएँ, जो Overleaf, natbib या biblatex के लिए तैयार हैं — प्रकाशक के पृष्ठों से फ़ील्ड हाथ से कॉपी करने की आवश्यकता नहीं।",
    doiToBibtexUseCase:
      "क्लासिक स्थिति: एक समीक्षक आपको उद्धृत करने के लिए तीन शोध-पत्र भेजता है, आपके पास उनके DOI हैं, और आज रात ही समय-सीमा है। चिपकाएँ, डाउनलोड करें, और \\cite करते रहें।",
    doiToRisTitle: "DOI से RIS परिवर्तक",
    doiToRisMetaDescription:
      "DOI को ऐसी RIS फ़ाइल में बदलें जिसे Zotero, Mendeley और EndNote सीधे आयात कर लें। DOI एक पंक्ति में एक चिपकाएँ — निःशुल्क, पंजीकरण की आवश्यकता नहीं।",
    doiToRisIntro:
      "RIS वह विनिमय प्रारूप है जिसे हर संदर्भ प्रबंधक आयात करता है। DOI चिपकाएँ और एक .ris फ़ाइल डाउनलोड करें जिसके TY/AU/TI/T2 फ़ील्ड सीधे Crossref से आते हैं — फिर इसे File → Import के ज़रिए Zotero, Mendeley या EndNote में डालें और प्रविष्टियाँ पूरी तरह संरचित होकर आएँगी।",
    doiToRisUseCase:
      "हाथ से एकत्र की गई DOI सूची को बिना एक भी लेखक का नाम फिर से टाइप किए, एक उचित संदर्भ प्रबंधक में स्थानांतरित करने के लिए एकदम सही।",
    isbnToApaTitle: "ISBN से APA परिवर्तक",
    isbnToApaMetaDescription:
      "ISBN को स्वतः APA 7 पुस्तक संदर्भों में बदलें। एक पंक्ति में एक ISBN चिपकाएँ और प्रारूपित सूची कॉपी करें — निःशुल्क, कोई खाता नहीं।",
    isbnToApaIntro:
      "पुस्तक के कॉपीराइट पृष्ठ पर छपा ISBN ही उसके APA संदर्भ के लिए काफ़ी है। प्रत्येक ISBN को पुस्तकालय मेटाडेटा से मिलाया जाता है और APA 7 शैली में प्रारूपित किया जाता है — लेखक, वर्ष, इटैलिक शीर्षक और प्रकाशक — साथ ही संस्करण की जानकारी भी, यदि रिकॉर्ड में उपलब्ध हो।",
    isbnToApaUseCase:
      "भौतिक पुस्तकालय की पुस्तकों के ढेर को उद्धृत करने का सबसे तेज़ तरीका: प्रत्येक को कॉपीराइट पृष्ठ पर पलटें, ISBN टाइप करें, सूची यहाँ चिपकाएँ।",
    isbnToMlaTitle: "ISBN से MLA परिवर्तक",
    isbnToMlaMetaDescription:
      "एक बार में ISBN को MLA 9 works-cited प्रविष्टियों में बदलें। प्रारूपित परिणाम के साथ निःशुल्क ISBN लुकअप — पंजीकरण की आवश्यकता नहीं।",
    isbnToMlaIntro:
      "MLA 9 की पुस्तक प्रविष्टियाँ छोटी होती हैं — लेखक, इटैलिक शीर्षक, प्रकाशक, वर्ष — लेकिन लेखक-नाम की उलट क्रम व्यवस्था और सही विराम चिह्न लगाना अब भी लोगों को उलझा देता है। ISBN लुकअप पुस्तक का वास्तविक सूची-पत्र रिकॉर्ड लौटाता है और उसे MLA पुस्तिका के मूल-तत्व टेम्पलेट के अनुसार प्रारूपित करता है।",
    isbnToMlaUseCase:
      "साहित्य के निबंधों के लिए आदर्श: अपनी मेज़ पर रखे हर उपन्यास और समीक्षात्मक ग्रंथ को उद्धृत करें, बस उनके पिछले कवर पर लिखे नंबर टाइप करके।",
    isbnToBibtexTitle: "ISBN से BibTeX परिवर्तक",
    isbnToBibtexMetaDescription:
      "ISBN को LaTeX के लिए BibTeX @book प्रविष्टियों में बदलें। एक पंक्ति में एक ISBN चिपकाएँ, .bib फ़ाइल डाउनलोड करें — निःशुल्क और तुरंत।",
    isbnToBibtexIntro:
      "पुस्तकें BibTeX का असुविधाजनक हिस्सा हैं — देखने के लिए कोई DOI नहीं, और प्रकाशकों के पृष्ठ शायद ही कभी .bib निर्यात देते हैं। यह परिवर्तक प्रत्येक ISBN को पुस्तकालय मेटाडेटा से मिलाता है और लेखक, शीर्षक, प्रकाशक तथा वर्ष के फ़ील्ड भरे हुए @book प्रविष्टियाँ बनाता है।",
    isbnToBibtexUseCase:
      "थीसिस लेखकों के लिए: विधि अध्याय शोध-पत्रिका के DOI उद्धृत करते हैं, लेकिन सिद्धांत अध्याय बारह पुस्तकों को उद्धृत करता है। यह उन बारह पुस्तकों को संभाल लेता है।",
    pmidToApaTitle: "PMID से APA परिवर्तक",
    pmidToApaMetaDescription:
      "PubMed ID को स्वतः APA 7 संदर्भों में बदलें। PMID एक पंक्ति में एक चिपकाएँ और प्रारूपित संदर्भ सूची पाएँ — निःशुल्क।",
    pmidToApaIntro:
      "हर PubMed रिकॉर्ड में एक PMID होता है, और मनोविज्ञान तथा नर्सिंग कार्यक्रमों में लगभग हमेशा APA अनिवार्य होता है। PMID एक पंक्ति में एक चिपकाएँ और हर एक PubMed के अपने मेटाडेटा के ज़रिए एक पूर्ण APA 7 पत्रिका संदर्भ में बदल जाता है, रिकॉर्ड में होने पर DOI लिंक सहित।",
    pmidToApaUseCase:
      "साक्ष्य-आधारित अभ्यास असाइनमेंट के लिए बनाया गया: आपकी खोज रणनीति PMID की सूची पर समाप्त होती है, और आपके शोध-पत्र को इन्हें APA में चाहिए।",
    pmidToRisTitle: "PMID से RIS परिवर्तक",
    pmidToRisMetaDescription:
      "PubMed ID को Zotero, Mendeley या EndNote के लिए RIS फ़ाइल में बदलें। PMID एक पंक्ति में एक चिपकाएँ, .ris डाउनलोड करें — निःशुल्क।",
    pmidToRisIntro:
      "व्यवस्थित समीक्षा (सिस्टेमैटिक रिव्यू) की कार्यप्रणाली RIS फ़ाइलों पर टिकी होती है। अपनी PubMed खोज से PMID चिपकाएँ और अपने स्क्रीनिंग टूल या संदर्भ प्रबंधक के लिए तैयार .ris डाउनलोड करें — हर रिकॉर्ड स्क्रैप किए गए पाठ के बजाय PubMed के प्रामाणिक मेटाडेटा से संरचित होता है।",
    pmidToRisUseCase:
      "समीक्षा के बीच में उपयोगी, जब कोई सहकर्मी 'इन पाँच अध्ययनों को भी शामिल करें' कहते हुए केवल PMID ईमेल करता है, और आपकी लाइब्रेरी EndNote में रहती है।",
    arxivToBibtexTitle: "arXiv से BibTeX परिवर्तक",
    arxivToBibtexMetaDescription:
      "LaTeX शोध-पत्रों के लिए arXiv ID को BibTeX प्रविष्टियों में बदलें। 2301.12345 जैसी ID एक पंक्ति में एक चिपकाएँ, और .bib डाउनलोड करें — निःशुल्क।",
    arxivToBibtexIntro:
      "तेज़ी से बदलते क्षेत्रों में प्रीप्रिंट लगातार उद्धृत होते हैं, और arXiv ID (जैसे 2301.12345) ही वह तरीका है जिससे वे प्रसारित होते हैं। ID चिपकाएँ और प्रीप्रिंट के लेखकों, शीर्षक, वर्ष और arXiv लिंक सहित BibTeX प्रविष्टियाँ पाएँ — आपके शोध-पत्र की .bib फ़ाइल के लिए तैयार।",
    arxivToBibtexUseCase:
      "ML और भौतिकी लेखकों के लिए जिनका संबंधित-कार्य खंड 80% arXiv से बना होता है: पढ़ते समय ID इकट्ठा करें, लिखते समय एक साथ बदल लें।",
    bibtexToApaTitle: "BibTeX से APA परिवर्तक",
    bibtexToApaMetaDescription:
      ".bib फ़ाइल चिपकाएँ या अपलोड करें और APA 7 संदर्भ सूची पाएँ। कई प्रविष्टियों वाली फ़ाइलों को संभालता है — निःशुल्क, विश्लेषण आपके ब्राउज़र में ही होता है।",
    bibtexToApaIntro:
      "कभी-कभी शोध-पत्र को LaTeX छोड़ना पड़ता है: कोई पत्रिका Word में सबमिशन चाहती है, या समिति संदर्भ सूची सादे पाठ के रूप में चाहती है। अपना BibTeX चिपकाएँ (या .bib अपलोड करें) और हर प्रविष्टि आपके ब्राउज़र में विश्लेषित होकर APA 7 संदर्भ सूची के रूप में प्रारूपित हो जाती है, जिसे आप किसी भी दस्तावेज़ में डाल सकते हैं।",
    bibtexToApaUseCase:
      "अनुदान-आवेदन विशेष: आपकी प्रकाशन सूची .bib फ़ाइल में रहती है, और फ़ंडर का फ़ॉर्म एक टेक्स्ट बॉक्स में APA-प्रारूपित संदर्भ चाहता है।",
    bibtexToMlaTitle: "BibTeX से MLA परिवर्तक",
    bibtexToMlaMetaDescription:
      "BibTeX को MLA 9 works-cited प्रविष्टियों में बदलें। .bib फ़ाइल चिपकाएँ या अपलोड करें और प्रारूपित सूची कॉपी करें — निःशुल्क, कोई खाता नहीं।",
    bibtexToMlaIntro:
      "BibTeX कच्चे फ़ील्ड संग्रहीत करता है; MLA बिल्कुल बताता है कि उन्हें कैसे व्यवस्थित करें। यह परिवर्तक आपकी .bib प्रविष्टियों को स्थानीय रूप से विश्लेषित करता है और हर एक को MLA 9 टेम्पलेट के अनुसार प्रस्तुत करता है — लेखक-नाम की उलट क्रम व्यवस्था, उद्धरण चिह्नों में लेख शीर्षक, इटैलिक कंटेनर, और तत्वों के बीच सही विराम चिह्न।",
    bibtexToMlaUseCase:
      "क्रॉसओवर विद्वानों के लिए: आपके संदर्भ पिछले LaTeX कार्य से BibTeX में रहते हैं, लेकिन जिस मानविकी पत्रिका में आप सबमिट कर रहे हैं वह MLA चाहती है।",
    bibtexToRisTitle: "BibTeX से RIS परिवर्तक",
    bibtexToRisMetaDescription:
      ".bib फ़ाइल को Zotero, Mendeley या EndNote के लिए RIS में बदलें। BibTeX चिपकाएँ या अपलोड करें, .ris डाउनलोड करें — निःशुल्क और ऑफ़लाइन।",
    bibtexToRisIntro:
      "LaTeX उपकरणों से संदर्भ प्रबंधक की ओर बढ़ने का अर्थ है BibTeX की @article/@book प्रविष्टियों को RIS के TY/AU/TI टैग में अनुवाद करना। यह रूपांतरण पूरी तरह आपके ब्राउज़र में होता है — फ़ील्ड मैपिंग सहित — और आपको एक .ris फ़ाइल देता है जिसे कोई भी प्रबंधक आयात कर लेता है।",
    bibtexToRisUseCase:
      "सहयोग में सामान्य स्थिति: नया सह-लेखक Zotero में काम करता है, आपके साझा संदर्भ रिपॉज़िटरी में .bib हैं, और किसी को यह अंतर पाटना है।",
    bibtexToCslJsonTitle: "BibTeX से CSL-JSON परिवर्तक",
    bibtexToCslJsonMetaDescription:
      "Pandoc और Quarto के लिए BibTeX को CSL-JSON में बदलें। .bib चिपकाएँ या अपलोड करें, references.json डाउनलोड करें — निःशुल्क, ब्राउज़र में ही।",
    bibtexToCslJsonIntro:
      "Pandoc और Quarto स्वाभाविक रूप से CSL-JSON से उद्धृत करते हैं, और आपकी मौजूदा .bib फ़ाइल को बदलने से बिल्ड से एक चलता-पुर्ज़ा हट जाता है। प्रविष्टियाँ आपके ब्राउज़र में विश्लेषित होती हैं और एक स्वच्छ CSL-JSON ऐरे के रूप में सामने आती हैं — ठीक वही रूप जो --bibliography=references.json चाहता है।",
    bibtexToCslJsonUseCase:
      "Markdown-प्रथम शिक्षाविदों के लिए जो पुरानी LaTeX परियोजना को Quarto में बदल रहे हैं: JSON को हाथ से संपादित किए बिना ग्रंथ सूची साथ ले जाएँ।",
    bibtexToWordTitle: "BibTeX से Word परिवर्तक",
    bibtexToWordMetaDescription:
      ".bib फ़ाइल को APA-प्रारूपित, हैंगिंग-इंडेंट संदर्भ सूची वाले Word दस्तावेज़ में बदलें। निःशुल्क — विश्लेषण आपके ब्राउज़र में होता है।",
    bibtexToWordIntro:
      "जब .bib फ़ाइल को किसी अन्य डेटा प्रारूप के बजाय एक दस्तावेज़ बनना हो, तो यह परिवर्तक आपके BibTeX को स्थानीय रूप से विश्लेषित करता है, हर प्रविष्टि को APA 7 में प्रारूपित करता है, और पहले से वर्णानुक्रम में सजी और हैंगिंग-इंडेंट संदर्भ सूची वाली Word फ़ाइल डाउनलोड करता है।",
    bibtexToWordUseCase:
      "प्रक्रिया के अंत का कदम: पत्रिका ने शोध-पत्र स्वीकार कर लिया है लेकिन अंतिम संदर्भ सूची संपादन-योग्य Word फ़ाइल के रूप में चाहती है, और आपका मूल स्रोत BibTeX है।",
    risToApaTitle: "RIS से APA परिवर्तक",
    risToApaMetaDescription:
      "RIS निर्यात चिपकाएँ या अपलोड करें और APA 7 संदर्भ सूची पाएँ। Zotero, Mendeley, EndNote और डेटाबेस निर्यातों के साथ काम करता है — निःशुल्क।",
    risToApaIntro:
      "हर डेटाबेस का Export बटन RIS बनाता है; असाइनमेंट को APA चाहिए। निर्यात चिपकाएँ (या .ris अपलोड करें) और हर TY/AU/TI रिकॉर्ड आपके ब्राउज़र में विश्लेषित होकर APA 7 संदर्भ के रूप में प्रस्तुत होता है — किसी संदर्भ प्रबंधक को इंस्टॉल करने की आवश्यकता नहीं।",
    risToApaUseCase:
      "पुस्तकालय-डेटाबेस शॉर्टकट: अपने खोज परिणामों को RIS के रूप में निर्यात करें, यहाँ बदलें, और एक बार के शोध-पत्र के लिए Zotero सेट अप करने से बचें।",
    risToMlaTitle: "RIS से MLA परिवर्तक",
    risToMlaMetaDescription:
      "डेटाबेस या संदर्भ प्रबंधकों से RIS निर्यातों को MLA 9 works-cited प्रविष्टियों में बदलें। चिपकाएँ या अपलोड करें — निःशुल्क, पंजीकरण की आवश्यकता नहीं।",
    risToMlaIntro:
      "JSTOR, ProQuest और EBSCO — सभी RIS निर्यात करते हैं, और अंग्रेज़ी विभाग सभी को MLA चाहिए। यह पृष्ठ उस अंतर को पाटता है: रिकॉर्ड स्थानीय रूप से विश्लेषित होते हैं और MLA 9 मूल-तत्व टेम्पलेट के अनुसार प्रस्तुत होते हैं, आपके works-cited पृष्ठ पर चिपकाने के लिए तैयार।",
    risToMlaUseCase:
      "निबंध जमा करने से पहली रात के लिए बना: JSTOR से citations.ris के रूप में निर्यात किए गए दस स्रोत, और उन्हें हाथ से प्रारूपित करने की इच्छा शून्य।",
    risToBibtexTitle: "RIS से BibTeX परिवर्तक",
    risToBibtexMetaDescription:
      "LaTeX और Overleaf के लिए RIS को BibTeX में बदलें। .ris निर्यात चिपकाएँ या अपलोड करें, स्वच्छ .bib फ़ाइल डाउनलोड करें — निःशुल्क, ब्राउज़र में ही।",
    risToBibtexIntro:
      "LaTeX की दिशा में बढ़ते हुए: संदर्भ प्रबंधक और डेटाबेस RIS 'बोलते' हैं, आपके शोध-पत्र के बिल्ड को .bib चाहिए। रिकॉर्ड पूरी तरह आपके ब्राउज़र में बदलते हैं — प्रकार TY टैग से मैप किए जाते हैं, cite key जनरेट होते हैं — एक ऐसी फ़ाइल में जिसे Overleaf जैसा-का-तैसा स्वीकार करता है।",
    risToBibtexUseCase:
      "सहयोग में आम: Zotero उपयोगकर्ता RIS निर्यात करता है, LaTeX उपयोगकर्ता इसे इस पृष्ठ से चलाता है, और दोनों अपने-अपने उपकरण बनाए रखते हैं।",
    risToCslJsonTitle: "RIS से CSL-JSON परिवर्तक",
    risToCslJsonMetaDescription:
      "Pandoc और Quarto पाइपलाइनों के लिए RIS निर्यातों को CSL-JSON में बदलें। .ris चिपकाएँ या अपलोड करें, references.json डाउनलोड करें — निःशुल्क।",
    risToCslJsonIntro:
      "Pandoc और Quarto उपयोगकर्ताओं के लिए, CSL-JSON मूल ग्रंथ सूची प्रारूप है। इस पृष्ठ को अपने डेटाबेस या प्रबंधक द्वारा निर्यात किया गया RIS दें और बदले में एक संरचित JSON ऐरे पाएँ — हर रिकॉर्ड स्थानीय रूप से विश्लेषित, कहीं कुछ भी अपलोड नहीं होता।",
    risToCslJsonUseCase:
      "docs-as-code वर्कफ़्लो में फ़िट बैठता है: समीक्षक RIS अटैचमेंट भेजते हैं, आपकी रिपॉज़िटरी की उद्धरण फ़ाइल references.json है, यह पृष्ठ उनके बीच का अडैप्टर है।",
    cslJsonToBibtexTitle: "CSL-JSON से BibTeX परिवर्तक",
    cslJsonToBibtexMetaDescription:
      "CSL-JSON (Pandoc/Quarto/Zotero निर्यात) को BibTeX में बदलें। .json चिपकाएँ या अपलोड करें, .bib डाउनलोड करें — निःशुल्क, ब्राउज़र में ही।",
    cslJsonToBibtexIntro:
      "कभी-कभी प्रवाह उलट जाता है: Pandoc या Zotero पाइपलाइन में जन्मी ग्रंथ सूची को LaTeX बिल्ड में भोजन देना होता है। यह परिवर्तक आपके ब्राउज़र में CSL-JSON ऐरे पढ़ता है और CSL मॉडल से वापस मैप किए गए प्रकार और फ़ील्ड के साथ BibTeX प्रविष्टियाँ बनाता है।",
    cslJsonToBibtexUseCase:
      "उस Quarto लेखक के लिए जिसका सह-लेखक Overleaf पर अड़ा है: references.json को मानक बनाए रखें और ज़रूरत पड़ने पर .bib जनरेट करें।",
    cslJsonToRisTitle: "CSL-JSON से RIS परिवर्तक",
    cslJsonToRisMetaDescription:
      "CSL-JSON को RIS में बदलें ताकि Zotero, Mendeley या EndNote इसे आयात कर सकें। .json चिपकाएँ या अपलोड करें, .ris डाउनलोड करें — निःशुल्क।",
    cslJsonToRisIntro:
      "CSL-JSON Pandoc पाइपलाइनों के भीतर शानदार है और अधिकांश संदर्भ प्रबंधकों के आयात संवादों के लिए अपारदर्शी। RIS में बदलने से वही रिकॉर्ड सार्वभौमिक रूप से आयात-योग्य बन जाते हैं — हर आइटम आपके ब्राउज़र में TY/AU/TI टैग से मैप किया जाता है, कहीं भी सर्वर पर कुछ नहीं भेजा जाता।",
    cslJsonToRisUseCase:
      "हस्तांतरण की समस्या: आपकी ग्रंथ सूची git रिपॉज़िटरी में references.json है, और आपके सलाहकार को शुक्रवार तक इसे 'EndNote में' चाहिए।",
  },

  // The infinite-scroll style list shared by the country and subject pages and by the
  // /citation-styles hub. It is a client component, so these arrive as a prop rather
  // than through `getDictionary` — pulling all 17 dictionaries into the browser bundle
  // to label a search box is the thing `link-path.ts` exists to avoid.
  stylesBrowser: {
    defaultTitle: "सभी उद्धरण शैलियाँ",
    styleSingular: "शैली",
    stylePlural: "शैलियाँ",
    found: "प्राप्त",
    filterPlaceholder: "शैलियाँ फ़िल्टर करें...",
    noMatches: "आपकी खोज से कोई शैली मेल नहीं खाती।",
    loadingMore: "और शैलियाँ लोड हो रही हैं...",
    loadMore: "और लोड करें ({count} शेष)",
    showingAll: "सभी {count} शैलियाँ दिखाई जा रही हैं",
    internationalLabel: "अंतरराष्ट्रीय",
  },

  footer: {
    tagline:
      "{count} शैलियों वाला निःशुल्क संदर्भ जनरेटर। न खाता, न सशुल्क सदस्यता, न कोई सीमा।",
    freeTools: "निःशुल्क उपकरण",
    resources: "संसाधन",
    legal: "कानूनी",
    language: "भाषा",
    languageLabel: "अपनी भाषा चुनें",
    rights:
      "उद्धरण Citation Style Language की आधिकारिक परिभाषाओं से स्वरूपित किए जाते हैं।",
    popularStyles: "लोकप्रिय शैलियाँ",
    about: "परिचय",
    privacy: "निजता",
    terms: "शर्तें",
    contact: "संपर्क",
    copyright: "© {year} CitationEasy. उपयोग निःशुल्क है।",
    poweredBy: "संचालित:",
    allTools: "सभी लेखन उपकरण",
    citationGuides: "उद्धरण मार्गदर्शिकाएँ",
    allStyles: "सभी उद्धरण शैलियाँ",
    citationGlossary: "उद्धरण शब्दावली",
    howToCiteAny: "किसी भी स्रोत का उद्धरण कैसे दें",
  },

  faq: {
    heading: "अक्सर पूछे जाने वाले प्रश्न",
    homeQ1: "क्या CitationEasy सचमुच निःशुल्क है?",
    homeA1:
      "हाँ। CitationEasy पूरी तरह निःशुल्क है — न पंजीकरण, न कोई सीमा, न कोई सशुल्क संस्करण। सभी {count} उद्धरण शैलियाँ हर किसी के लिए उपलब्ध हैं।",
    homeQ2: "कौन-कौन सी उद्धरण शैलियाँ समर्थित हैं?",
    homeA2:
      "Citation Style Language परियोजना की सभी {count} शैलियाँ, जिनमें APA 7वाँ संस्करण, MLA 9वाँ संस्करण, Chicago, Harvard, Vancouver, IEEE, AMA और Turabian शामिल हैं।",
    homeQ3: "क्या मुझे खाता बनाना होगा?",
    homeA3:
      "नहीं। CitationEasy पूरी तरह आपके ब्राउज़र में चलता है और आपकी संदर्भ सूची आपके ही उपकरण पर सहेजी जाती है। कुछ भी सर्वर पर नहीं भेजा जाता और पंजीकरण की ज़रूरत नहीं है।",
    homeQ4: "क्या मैं अपनी भाषा में उद्धरण बना सकता हूँ?",
    homeA4:
      "हाँ। उद्धरण की भाषा साइट की भाषा से अलग सेटिंग है, इसलिए आप हिंदी में काम करते हुए भी अपने शोधपत्र की भाषा में संदर्भ तैयार कर सकते हैं।",
    styleQ1: "क्या {style} उद्धरण जनरेटर निःशुल्क है?",
    styleA1:
      "हाँ। {style} उद्धरण बनाना निःशुल्क और असीमित है, खाते की ज़रूरत नहीं। DOI, URL, ISBN या BibTeX प्रविष्टि चिपकाइए और तैयार संदर्भ कॉपी कर लीजिए।",
    styleQ2: "{style} में किसी स्रोत का उद्धरण कैसे दें?",
    styleA2:
      "स्रोत का DOI, URL, ISBN या BibTeX इस पृष्ठ के जनरेटर में चिपकाइए। {style} पहले से चुनी हुई है, इसलिए संदर्भ और पाठ-अंतर्गत उद्धरण तुरंत दिख जाते हैं।",
    styleQ3: "{style} स्वरूपण कितना सटीक है?",
    styleA3:
      "हर संदर्भ Citation Style Language परियोजना द्वारा प्रकाशित आधिकारिक {style} परिभाषा से बनता है — वही फ़ाइल जिसका उपयोग Zotero और Mendeley करते हैं — न कि नियमों के किसी अनुमान से।",
  },

  tool: {
    modeLabel: "उद्धरण इनपुट मोड",
    modeAuto: "URL / DOI / ISBN",
    modeBook: "पुस्तकें खोजें",
    modeArticles: "लेख खोजें",
    modeManual: "मैन्युअल प्रविष्टि",
    errorEnterManually: "विवरण मैन्युअल रूप से भरें",
    autoLabel: "URL, DOI, PMID, arXiv ID, ISBN या BibTeX चिपकाएँ",
    autoHint:
      "हम प्रकार अपने आप पहचान लेते हैं और मेटाडेटा ले आते हैं। पूरी सूची एक साथ उद्धृत करने के लिए हर पंक्ति में एक पहचानकर्ता चिपकाएँ।",
    generate: "उद्धरण बनाएँ",
    generating: "बन रहा है…",
    bookSearchLabel: "शीर्षक, लेखक या ISBN से खोजें",
    bookSearchEmpty: "अभी कोई परिणाम नहीं। पुस्तकें खोजने के लिए ‘खोजें’ पर क्लिक करें।",
    bookSearchSource: "Open Library की लाखों पुस्तकों की सूची में खोजता है",
    worksSearchLabel: "लेख के शीर्षक या लेखकों से खोजें",
    worksSearchEmpty: "अभी कोई परिणाम नहीं। लेख खोजने के लिए ‘खोजें’ पर क्लिक करें।",
    worksSearchSource:
      "Crossref की सूची में खोजता है: शोध-पत्रिका लेख, सम्मेलन पत्र और पुस्तक अध्याय",
    showingResults: "{total} में से {shown} परिणाम दिखाए जा रहे हैं",
    search: "खोजें",
    searching: "खोज रहे हैं…",
    bulkResults: "थोक उद्धरण परिणाम",
    copy: "कॉपी करें",
    copied: "कॉपी हो गया!",
    copyHint: "अपने शोध-पत्र में कॉपी-पेस्ट करें",
    resultTitle: "प्रारूपित उद्धरण",
    edit: "संपादित करें",
    completeFields: "पूरा करें",
    fieldsIncomplete: "one:{count} फ़ील्ड अधूरी है|other:{count} फ़ील्ड अधूरी हैं",
    outputLanguage: "भाषा",
    sourceType: "स्रोत का प्रकार",
    fieldAuthors: "लेखक",
    fieldAuthorsHint: "शर्मा, अनिल या अनिल शर्मा",
    fieldTitle: "लेख या पुस्तक का शीर्षक",
    fieldBookTitle: "पुस्तक का शीर्षक",
    fieldBookTitleHint: "पुस्तक या संकलन का शीर्षक",
    fieldEditors: "संपादक",
    fieldJournal: "शोध-पत्रिका / प्रकाशन",
    fieldJournalHint: "शोध-पत्रिका या प्रकाशन का नाम",
    fieldPublisher: "प्रकाशक / वेबसाइट",
    fieldPublisherHint: "प्रकाशक का नाम या वेबसाइट",
    fieldDate: "तिथि / वर्ष",
    fieldVolume: "खंड",
    fieldIssue: "अंक",
    fieldPages: "पृष्ठ",
    fieldFormat: "प्रारूप / माध्यम",
    fieldAuthorsGroup: "समूह या संगठन लेखक",
    fieldAuthorsGroupHint:
      "किसी समूह को व्यक्तियों के साथ लिखने के लिए उसे कोष्ठक में रखें: {R Core Team}, अनिल शर्मा",
    fieldTranslators: "अनुवादक",
    fieldInterviewers: "साक्षात्कारकर्ता",
    fieldVersion: "संस्करण",
    fieldCourt: "न्यायालय",
    fieldIssuingAuthority: "जारी करने वाला प्राधिकरण",
    fieldPatentNumber: "पेटेंट संख्या",
    fieldEpisodeNumber: "एपिसोड संख्या",
    fieldLawNumber: "कानून या विधेयक संख्या",
    fieldReportNumber: "रिपोर्ट संख्या",
    fieldReviewedTitle: "समीक्षित कृति का शीर्षक",
    fieldReviewedAuthors: "समीक्षित कृति के लेखक",
    inTextCitation: "पाठ-अंतर्गत उद्धरण",
    quickEdit: "त्वरित संपादन",
    quickEditHint: "मेटाडेटा अद्यतन करें और उद्धरण फिर से बनाएँ।",
    update: "अद्यतन करें",
    saving: "सहेजा जा रहा है…",
    fieldAuthor: "लेखक",
    fieldDateShort: "तिथि",
    fieldTitleShort: "शीर्षक",
  },

  toolCollections: {
    "citation-generators": "उद्धरण जनरेटर",
    "citation-tools": "उद्धरण और संदर्भ टूल",
    "paper-formatting": "शोध-पत्र फ़ॉर्मेटिंग",
    "essay-writing": "निबंध और शोध-पत्र लेखन",
    "writing-analysis": "लेखन विश्लेषण और संपादन",
    "word-counters": "काउंटर और पठनीयता",
    vocabulary: "शब्दावली और शब्द खोज",
    "research-tools": "शोध और प्रकाशन",
    statistics: "सांख्यिकी कैलकुलेटर",
    math: "गणित कैलकुलेटर",
    science: "विज्ञान और प्रयोगशाला कैलकुलेटर",
    charts: "चार्ट और आरेख",
    economics: "अर्थशास्त्र, व्यवसाय और वित्त",
    grades: "GPA और ग्रेड कैलकुलेटर",
    study: "पढ़ाई और उत्पादकता",
    classroom: "कक्षा और प्रिंट करने योग्य सामग्री",
    random: "रैंडम जनरेटर और चयन",
    "text-tools": "टेक्स्ट सफ़ाई और फ़ॉर्मेटिंग",
    "fancy-text": "सजावटी टेक्स्ट और प्रतीक",
    language: "भाषा और लिप्यंतरण",
    ciphers: "कोड और सिफ़र",
    converters: "इकाई, तारीख और संख्या कन्वर्टर",
    developer: "डेटा, मार्कअप और कोड",
  },
  bib: {
    title: "मेरी संदर्भ-सूचियाँ",
    studioTitle: "संदर्भ-सूची स्टूडियो",
    studioProjects: "प्रोजेक्ट",
    studioExplore: "एक्सप्लोर करें",
    studioExploreIntro: "गाइड, टूल और हर उद्धरण शैली बस एक क्लिक दूर हैं।",
    studioStyleGuide: "{style} शैली गाइड",
    studioStyleGuideHint: "नियम, हल किए गए उदाहरण और इन-टेक्स्ट प्रारूप",
    studioGenerator: "उद्धरण जनरेटर",
    studioNewProject: "नया प्रोजेक्ट",
    studioSwitchProject: "प्रोजेक्ट बदलें",
    studioAddSource: "स्रोत जोड़ें",
    studioAddSourceHint:
      "DOI, URL या ISBN पेस्ट करें, किताबें और लेख खोजें, या विवरण हाथ से भरें। आप जो भी सहेजेंगे वह इसी प्रोजेक्ट में जाएगा।",
    studioDoneAdding: "हो गया",
    studioReferences: "संदर्भ",
    studioReferenceCount: "{count} संदर्भ",
    studioInspectorTitle: "संदर्भ विवरण",
    studioInspectorEmpty:
      "इन-टेक्स्ट उद्धरण, नोट्स और स्रोत विवरण देखने के लिए कोई संदर्भ चुनें।",
    studioSavedLocally: "इस ब्राउज़र में सहेजा गया",
    studioOpen: "बिब्लियोग्राफ़ी स्टूडियो खोलें",
    studioViewInStudio: "स्टूडियो में देखें",
    studioFooterSaved: "आपके बिब्लियोग्राफ़ी स्टूडियो में {count} सहेजे गए",
    studioFooterEmpty: "सहेजे गए उद्धरण स्टूडियो में पूरी बिब्लियोग्राफ़ी बनाते हैं",
    studioClearSelection: "चयन हटाएँ",
    studioDeleteSelected: "चयनित हटाएँ",
    studioDeleteSelectedBody:
      "“{name}” से {count} उद्धरण हटाएँ? इसे पूर्ववत नहीं किया जा सकता।",
    studioDeletedMany: "{count} उद्धरण हटाए गए",
    studioMoveTo: "यहाँ ले जाएँ",
    studioCopyTo: "यहाँ कॉपी करें",
    studioSearchShortcut: "खोजने के लिए / दबाएँ",
    studioStyle: "शैली",
    studioCopyEntry: "प्रविष्टि कॉपी करें",
    studioEntryCopied: "प्रविष्टि कॉपी हो गई",
    studioSourceDetails: "स्रोत विवरण",
    studioEmptyTitle: "यह प्रोजेक्ट खाली है",
    studioEmptyBody:
      "ऊपर अपना पहला स्रोत जोड़ें, या मौजूदा BibTeX, RIS या CSL-JSON लाइब्रेरी आयात करें।",
    studioBackup: "बैकअप",
    sharedTitle: "साझा की गई संदर्भ-सूची",
    save: "सहेजें",
    saving: "सहेजा जा रहा है…",
    saved: "सहेजा गया",
    searchPlaceholder: "उद्धरणों में खोजें…",
    empty: "अभी कोई उद्धरण सहेजा नहीं गया",
    emptySearch: "आपकी खोज से कोई उद्धरण मेल नहीं खाता।",
    countIn: "{name} में उद्धरण: {count}",
    savedOn: "{date} को सहेजा गया",
    emptyInBib:
      "इस संदर्भ-सूची में अभी कोई उद्धरण नहीं है। उद्धरण बनाकर सहेजें, या कोई मौजूदा BibTeX, RIS या CSL-JSON लाइब्रेरी आयात करें।",
    savedToast: "उद्धरण संदर्भ-सूची में सहेजा गया",
    copyAll: "सभी कॉपी करें",
    copyAllTitle: "सभी उद्धरण कॉपी करें",
    export: "निर्यात करें",
    exportTitle: "संदर्भ-सूची निर्यात करें",
    import: "आयात करें",
    importTitle: "संदर्भ आयात करें",
    importLabel: "संदर्भ आयात करें (BibTeX, RIS या CSL-JSON)",
    importing: "आयात हो रहा है…",
    importFailed: "आयात विफल रहा। कृपया फिर प्रयास करें।",
    importSummary:
      "आयातित: {added} · दोहराव छोड़े: {duplicates} · सीमा से अधिक: {overLimit} · विफल: {failed}",
    importUnreadable: "फ़ाइल पढ़ी नहीं जा सकी।",
    importUnparseable: "संदर्भ आयात नहीं किए जा सके।",
    importReviewTitle: "आयात की समीक्षा करें",
    importReviewIntro: "{total} {format} संदर्भों को फ़ॉर्मैट और सहेजने से पहले जाँचें।",
    importReviewCount: "{total} में से {included} शामिल",
    importSelectAll: "सभी शामिल करें",
    importExcludeAll: "सभी बाहर रखें",
    importLimitNotice:
      "200 प्रविष्टियों की सीमा से अधिक {count} संदर्भ आयात नहीं होंगे।",
    importDuplicateExisting: "पहले से सहेजे गए “{title}” की संभावित प्रति",
    importDuplicateBatch: "इस आयात में “{title}” की संभावित प्रति",
    importMissingField: "{field} अनुपलब्ध",
    importUntitled: "बिना शीर्षक का संदर्भ",
    importReview: "संदर्भों की समीक्षा करें",
    importCommit: "फ़ॉर्मैट करके आयात करें",
    importBack: "वापस",
    importOutcomeTitle: "आयात पूरा हुआ",
    importOutcomeSummary:
      "जोड़े गए: {added} · प्रतियाँ छोड़ी गईं: {duplicates} · बाहर रखे: {excluded} · सीमा से अधिक: {overLimit} · विफल: {failed}",
    sortBy: "इसके अनुसार क्रमबद्ध करें",
    sortTitle: "संदर्भ-सूची क्रमबद्ध करें",
    sortAuthor: "लेखक (अ–ज्ञ)",
    sortNewest: "जोड़ने की तिथि (नवीनतम)",
    sortOldest: "वर्ष (पुराने पहले)",
    sortManual: "मैन्युअल क्रम",
    backupAll: "सभी प्रोजेक्ट का बैकअप (.json)",
    backupDownloaded: "सभी प्रोजेक्ट का बैकअप डाउनलोड हो गया",
    backupUnreadable: "बैकअप फ़ाइल पढ़ी नहीं जा सकी।",
    restore: "पुनर्स्थापित करें",
    restoreTitle: "सभी ग्रंथसूची प्रोजेक्ट पुनर्स्थापित करें",
    restoreWarning:
      "बैकअप को पहले सत्यापित किया जाएगा, फिर यह इस ब्राउज़र में सहेजी गई सभी ग्रंथसूचियों को बदल देगा। इसे पूर्ववत नहीं किया जा सकता।",
    restoreChoose: "CitationEasy बैकअप चुनें (.json)",
    replaceAndRestore: "बदलें और पुनर्स्थापित करें",
    restoreComplete: "सभी ग्रंथसूची प्रोजेक्ट पुनर्स्थापित हो गए",
    restoreInvalid: "यह मान्य CitationEasy प्रोजेक्ट बैकअप नहीं है।",
    selectAllVisible: "दिखाए गए सभी चुनें",
    selectedCount: "{count} चुने गए",
    clusterOpen: "एक साथ उद्धृत करें",
    clusterTitle: "संयुक्त पाठ्य उद्धरण",
    clusterDescription:
      "चुने गए संदर्भों से एक ही उद्धरण समूह बनाएँ। चुनी गई शैली क्रम, विराम-चिह्न और क्रमांकन नियंत्रित करती है।",
    clusterTarget: "आउटपुट",
    clusterLocatorOptional: "वैकल्पिक स्थान-सूचक",
    clusterBuildCopy: "उद्धरण बनाएँ और कॉपी करें",
    clusterBuilding: "उद्धरण बनाया जा रहा है…",
    clusterCopied: "संयुक्त उद्धरण कॉपी किया गया",
    clusterFailed: "संयुक्त उद्धरण नहीं बनाया जा सका। कृपया फिर से प्रयास करें।",
    destination: "गंतव्य ग्रंथसूची",
    chooseDestination: "ग्रंथसूची चुनें…",
    copySelected: "कॉपी करें",
    moveSelected: "स्थानांतरित करें",
    copyComplete: "{count} उद्धरण कॉपी किए गए। {skipped} डुप्लिकेट छोड़ दिए गए।",
    moveComplete: "{count} उद्धरण स्थानांतरित किए गए। {skipped} डुप्लिकेट स्रोत में रहे।",
    selectCitation: "{title} चुनें",
    moveUp: "ऊपर ले जाएँ",
    moveDown: "नीचे ले जाएँ",
    deleteTitle: "उद्धरण हटाएँ",
    deleteConfirm: "उद्धरण हटाएँ?",
    deleted: "उद्धरण हटाया गया",
    editTitle: "उद्धरण संपादित करें",
    close: "बंद करें",
    copiedAll: "सभी उद्धरण कॉपी हो गए!",
    copiedAnnotated: "टिप्पणीयुक्त संदर्भ-सूची कॉपी हो गई!",
    copiedBibtex: "BibTeX कॉपी हो गया!",
    copiedBulleted: "बुलेट सूची कॉपी हो गई!",
    copiedNumbered: "क्रमांकित सूची कॉपी हो गई!",
    copiedHtml: "HTML अंश कॉपी हो गया!",
    downloadedWord: "Word दस्तावेज़ डाउनलोड हुआ",
    downloadedRtf: "RTF फ़ाइल डाउनलोड हुई",
    downloadedRis: "RIS फ़ाइल डाउनलोड हुई",
    downloadedCsl: "CSL-JSON फ़ाइल डाउनलोड हुई",
    downloadedAnnotated: "टिप्पणीयुक्त संदर्भ-सूची डाउनलोड हुई",
    copyFailed: "क्लिपबोर्ड पर कॉपी नहीं हो सका",
    shareCopied:
      "लिंक कॉपी हो गया! जिसके पास यह लिंक होगा वह इस सूची को देख और आयात कर सकता है।",
    shareFailed: "साझा करने का लिंक नहीं बन सका",
    regenerateFailed: "उद्धरण दोबारा नहीं बनाया जा सका",
    updateFailed: "उद्धरण अद्यतन नहीं हो सका",
    fieldAuthor: "लेखक",
    fieldTitle: "शीर्षक",
    fieldDate: "तिथि",
    fieldPublisher: "प्रकाशक",
    fieldVolume: "खंड",
    fieldIssue: "अंक",
    fieldPages: "पृष्ठ",
    fieldUrl: "URL",
    fieldAccessed: "देखने की तारीख",
    fieldEditor: "संपादक",
    fieldEvent: "कार्यक्रम स्थान",
    noteLabel: "इस स्रोत पर टिप्पणी",
    noteEdit: "यह टिप्पणी संपादित करें",
    notePlaceholder:
      "स्रोत का सार लिखें, उसका मूल्यांकन करें और बताएँ कि वह आपके काम में कैसे बैठता है…",
    noteRemoved: "टिप्पणी हटाई गई",
    noteSave: "टिप्पणी सहेजें",
    noteCancel: "रद्द करें",
    noteAdd: "टिप्पणी जोड़ें",
    noteWords: "{count} शब्द",
    noteSaved: "टिप्पणी सहेजी गई ({count} शब्द)",
    noteClickToEdit: "संपादित करने के लिए क्लिक करें",
    inTextCopy: "इस स्रोत का पाठ-अंतर्गत उद्धरण कॉपी करें",
    inTextSelect: "कॉपी करने के लिए नीचे दिया उद्धरण चुनें।",
    inTextFailed: "पाठ-अंतर्गत उद्धरण नहीं बन सका। कृपया फिर प्रयास करें।",
    locator: "स्थान-निर्देश",
    locatorType: "स्थान-निर्देश का प्रकार",
    locatorPage: "पृष्ठ",
    locatorChapter: "अध्याय",
    locatorSection: "अनुभाग",
    locatorParagraph: "अनुच्छेद",
    locatorLine: "पंक्ति",
    locatorVerse: "श्लोक",
    reformat: "पुनः प्रारूपित करें",
    reformatTitle: "सभी उद्धरणों को दूसरी शैली में पुनः प्रारूपित करें",
    reformatHeading: "सब कुछ एक ही शैली में पुनः प्रारूपित करें",
    reformatChoose: "एक शैली चुनें…",
    reformatFailed: "पुनः प्रारूपण विफल रहा। आपकी संदर्भ-सूची अपरिवर्तित है।",
    sortOrder: "क्रम का आधार",
    copyToClipboard: "क्लिपबोर्ड पर कॉपी करें",
    numberedList: "क्रमांकित सूची",
    bulletedList: "बुलेट सूची",
    htmlSnippet: "HTML अंश",
    copyWithAnnotations: "टिप्पणियों सहित कॉपी करें",
    wordAnnotated: "टिप्पणीयुक्त Word दस्तावेज़ (.doc)",
    downloadFile: "फ़ाइल डाउनलोड करें",
    wordDocument: "Word दस्तावेज़ (.doc)",
    copyShareLink: "साझा करने का लिंक कॉपी करें",
    print: "प्रिंट करें…",
    printFailed: "पॉप-अप अवरुद्ध है — प्रिंट करने के लिए अनुमति दें",
    font: "फ़ॉन्ट",
    sitePublication: "साइट / प्रकाशन का नाम",
    importIntro:
      "BibTeX (.bib), RIS (.ris) या CSL-JSON (.json) फ़ाइल चिपकाएँ या अपलोड करें",
    importUpload: ".bib, .ris या .json फ़ाइल अपलोड करें",
    importPaste: "या BibTeX, RIS या CSL-JSON चिपकाएँ",
    cancel: "रद्द करें",
    done: "पूर्ण",
    delete: "हटाएँ",
    deleteBody: "यह उद्धरण आपकी संदर्भ-सूची से स्थायी रूप से हट जाएगा।",
    editBody: "मेटाडेटा अद्यतन करें और सहेजें ताकि उद्धरण फिर से बन जाए।",
    reformatExplain:
      "सहेजे गए स्रोत-डेटा से सभी {count} प्रविष्टियाँ दोबारा बनाता है — कुछ भी दोबारा डाउनलोड नहीं होता और कोई स्रोत नहीं खोता।",
    inTextHeading: "पाठ-अंतर्गत उद्धरण",
    inTextLocatorHint:
      "उद्धरण को स्रोत में किसी स्थान से जोड़ने के लिए पृष्ठ या अन्य स्थान-निर्देश जोड़ें — सीधे उद्धरण देते समय अधिकांश शैलियाँ इसकी माँग करती हैं। सादे रूप के लिए इसे खाली छोड़ें।",
    inTextCopyButton: "पाठ-अंतर्गत उद्धरण कॉपी करें",
    mixedStyles: "इस संदर्भ-सूची में {count} उद्धरण शैलियाँ मिली-जुली हैं ({styles})।",
    mixedStylesAction:
      "जमा करने से पहले सबको एक ही शैली में लाने के लिए {action} का उपयोग करें।",
    selectBibliography: "संदर्भ-सूची चुनें",
    newBibliography: "नई संदर्भ-सूची",
    moreOptions: "अधिक विकल्प",
    rename: "नाम बदलें",
    removeDuplicates: "दोहराव हटाएँ",
    cannotDeleteOnly: "आप अपनी एकमात्र संदर्भ-सूची नहीं हटा सकते",
    newBibliographyBody: "किसी दूसरे शोधपत्र या परियोजना के लिए संदर्भ-सूची बनाएँ।",
    bibliographyName: "संदर्भ-सूची का नाम",
    create: "बनाएँ",
    renameBibliography: "संदर्भ-सूची का नाम बदलें",
    renameBibliographyBody: "“{name}” के लिए नया नाम लिखें।",
    newName: "नया नाम",
    duplicateRemovedOne: "{count} दोहराव हटाया गया",
    duplicateRemovedMany: "{count} दोहराव हटाए गए",
    noDuplicates: "कोई दोहराया हुआ संदर्भ नहीं मिला",
    removeDuplicatesConfirm: "दोहराए हुए संदर्भ हटाएँ?",
    removeDuplicatesBody:
      "यह “{name}” में समान स्रोत (DOI, ISBN या शीर्षक, वर्ष और लेखक से) खोजकर एक प्रति रखता है। जिन संदर्भों का मिलान नहीं हो सकता, वे नहीं बदलेंगे।",
    deleteBibliographyConfirm: "संदर्भ-सूची हटाएँ?",
    deleteBibliographyBody:
      "यह “{name}” और उसमें मौजूद सभी {count} उद्धरण स्थायी रूप से हटा देगा।",
  },

  bibliographyPage: {
    metaTitle: "संदर्भ-सूची स्टूडियो - उद्धरण व्यवस्थित, टिप्पणी और निर्यात करें",
    metaDescription:
      "ब्राउज़र में निजी संदर्भ परियोजनाएँ बनाएँ। बिना खाते खोजें, क्रमबद्ध करें, टिप्पणी जोड़ें, संपादित करें, पुनः प्रारूपित, आयात, निर्यात और साझा करें।",
    keyword1: "संदर्भ-सूची निर्माता",
    keyword2: "उद्धरण प्रबंधक",
    keyword3: "टिप्पणीयुक्त संदर्भ-सूची उपकरण",
    ogTitle: "संदर्भ-सूची स्टूडियो",
    ogDescription:
      "उद्धरण व्यवस्थित, प्रारूपित, टिप्पणी, आयात और निर्यात करने का निजी पूर्ण-पृष्ठ कार्यक्षेत्र।",
    ogImageTitle: "संदर्भ-सूची स्टूडियो",
    ogImageSubtitle:
      "संदर्भ व्यवस्थित करें, टिप्पणी जोड़ें, प्रारूप बदलें, निर्यात और साझा करें।",
    ogKind: "उद्धरण कार्यक्षेत्र",
    breadcrumb: "संदर्भ-सूची स्टूडियो",
    eyebrow: "ब्राउज़र में निजी कार्यक्षेत्र",
    lead: "किसी शोधपत्र के सभी संदर्भ एक जगह सँभालें। जब तक आप निर्यात या साझा नहीं करते, परियोजनाएँ इसी ब्राउज़र में रहती हैं।",
    privacyTitle: "डिफ़ॉल्ट रूप से निजी",
    privacyBody:
      "परियोजनाएँ और टिप्पणियाँ ब्राउज़र के स्थानीय संग्रह में रहती हैं। साझा लिंक उद्धरण रखते हैं, पर निजी नोट जानबूझकर छोड़ देते हैं।",
    workflowTitle: "स्रोत सूची से अंतिम शोधपत्र तक",
    workflowBody:
      "परियोजना बदलें, संदर्भ खोजें और क्रमबद्ध करें, टिप्पणी या स्थान जोड़ें, मेटाडेटा सुधारें और पूरी सूची को एक शैली में पुनः प्रारूपित करें।",
    formatsTitle: "संदर्भ आयात करें और कहीं भी ले जाएँ",
    formatsBody:
      "BibTeX, RIS या CSL-JSON आयात करें। प्रारूपित सूचियाँ कॉपी करें या Word, RTF, RIS, CSL-JSON, HTML, BibTeX और टिप्पणीयुक्त संस्करण निर्यात करें।",
  },

  // The 95-term glossary: /glossary and /glossary/[slug].
  //
  // The chrome only. Each term's own prose — `short`, the `body` paragraphs, the
  // example — is ~10,600 words that cannot live in a flat string map and must not be
  // copied verbatim into sixteen files; it lives in `src/content/glossary/<locale>.json`
  // and is read through `lib/localized-content.ts`.
  glossaryPage: {
    metaTitle: "{term} - परिभाषा और उदाहरण",
    notFoundTitle: "शब्द नहीं मिला",
    keywordDefinition: "{term} परिभाषा",
    keywordWhatIs: "{term} क्या है",
    ogTitle: "{term} - CitationEasy शब्दावली",
    ogKind: "उद्धरण शब्दावली",
    breadcrumb: "शब्दावली",
    alsoCalled: "इसे यह भी कहा जाता है: {aliases}",
    doItHeading: "CitationEasy पर करें",
    seeAlsoHeading: "यह भी देखें",
    moreInHeading: "{category} में और अधिक",
    navLabel: "शब्दावली नेविगेशन",
    allTermsLink: "सभी {count} शब्दावली शब्द",
    generatorLink: "निःशुल्क उद्धरण जनरेटर",
    termSetName: "CitationEasy उद्धरण शब्दावली",
    hubMetaTitle: "उद्धरण शब्दावली - {count} शब्द समझाए गए",
    hubMetaDescription:
      "{count} उद्धरण और शैक्षणिक-लेखन शब्दों की सरल शब्दों में परिभाषाएँ: et al., ibid., DOI, हैंगिंग इंडेंट, patchwriting, संस्करण-सम्मत प्रति और अधिक — प्रत्येक के साथ उदाहरण।",
    hubKeyword1: "उद्धरण शब्दावली",
    hubKeyword2: "उद्धरण शब्द",
    hubKeyword3: "शैक्षणिक लेखन शब्दावली",
    hubKeyword4: "et al का क्या अर्थ है",
    hubKeyword5: "DOI क्या है",
    hubKeyword6: "संदर्भ शब्दावली",
    hubOgTitle: "उद्धरण शब्दावली",
    hubOgDescription:
      "उदाहरणों सहित {count} उद्धरण और शैक्षणिक-लेखन शब्दों की परिभाषाएँ।",
    hubOgImageTitle: "उद्धरण शब्दावली",
    hubOgImageSubtitle:
      "{count} उद्धरण और शैक्षणिक-लेखन शब्द, सरल शब्दों में उदाहरणों सहित परिभाषित।",
    hubOgKind: "संदर्भ",
    hubTermSetDescription:
      "{count} उद्धरण, संदर्भ और शैक्षणिक-लेखन शब्दों की परिभाषाएँ।",
    hubCollectionName: "उद्धरण शब्दावली",
    hubCollectionDescription:
      "{count} उद्धरण और शैक्षणिक-लेखन शब्दों की सरल शब्दों में परिभाषाएँ।",
    hubHeading: "उद्धरण शब्दावली",
    hubIntro:
      "उद्धरण और शैक्षणिक लेखन के {count} शब्द, सरल शब्दों में उदाहरणों सहित परिभाषित — वे संक्षिप्ताक्षर जो शैली मार्गदर्शिकाओं में दिखते हैं, वे भाग जिनसे एक संदर्भ बनता है, वे पहचानकर्ता जो किसी स्रोत को सटीक रूप से चिह्नित करते हैं, और शैक्षणिक प्रकाशन की शब्दावली।",
    hubJumpLabel: "अक्षर पर जाएँ",
    hubBrowseHeading: "विषय के अनुसार ब्राउज़ करें",
    hubAllHeading: "सभी शब्द A–Z",
    hubWorkHeading: "शब्दों को उपयोग में लाएँ",
    hubWorkGenerator: "निःशुल्क उद्धरण जनरेटर",
    hubWorkStyles: "उद्धरण शैली मार्गदर्शिकाएँ",
    hubWorkHowTo: "किसी भी स्रोत को कैसे उद्धृत करें",
    hubWorkCompare: "उद्धरण शैलियों की तुलना करें",
    hubWorkTools: "लेखन एवं उद्धरण उपकरण",
    hubWorkFaq: "उद्धरण अक्सर पूछे जाने वाले प्रश्न",
  },

  // /faq — the 17-question hub. The questions and answers themselves are in
  // `src/data/faq.ts` (the one source the API, the MCP tool and /md also read); this is
  // the page around them.
  faqPage: {
    metaTitle: "उद्धरण अक्सर पूछे जाने वाले प्रश्न - सामान्य उद्धरण प्रश्नों के त्वरित उत्तर",
    metaDescription:
      "छात्र वास्तव में जो उद्धरण प्रश्न पूछते हैं उनके तेज़, सटीक उत्तर: DOI, बिना लेखक वाले स्रोत, et al., हैंगिंग इंडेंट, AI का उद्धरण देना, चोरी के नियम, APA बनाम MLA और अधिक — पूर्ण मार्गदर्शिकाओं के लिंक सहित।",
    ogTitle: "उद्धरण अक्सर पूछे जाने वाले प्रश्न",
    ogDescription:
      "DOI और et al. से लेकर ChatGPT का उद्धरण देने तक, सबसे सामान्य उद्धरण प्रश्नों के त्वरित उत्तर।",
    ogImageTitle: "उद्धरण प्रश्न एवं उत्तर",
    ogImageSubtitle:
      "उद्धरण देने के बारे में छात्र वास्तव में जो प्रश्न पूछते हैं, उनके संक्षिप्त, सटीक उत्तर।",
    ogKind: "FAQ",
    breadcrumbLabel: "ब्रेडक्रंब",
    breadcrumbHome: "होम",
    breadcrumbCurrent: "उद्धरण अक्सर पूछे जाने वाले प्रश्न",
    heading: "उद्धरण अक्सर पूछे जाने वाले प्रश्न",
    intro:
      "छात्र वास्तव में जो उद्धरण प्रश्न पूछते हैं उनके त्वरित, सटीक उत्तर — जब आपको अधिक गहराई चाहिए तो पूर्ण मार्गदर्शिका या उपकरण के लिंक सहित।",
    contentsLabel: "प्रश्नोत्तर सूची",
    stillStuckHeading: "अब भी उलझन में हैं?",
    stillStuckBody:
      "[पूर्ण मार्गदर्शिका पुस्तकालय](/guides) देखें, [शैली त्वरित संदर्भ पत्रक](/cheat-sheets) जाँचें, [उद्धरण शब्दावली](/glossary) में कोई शब्द खोजें, [पूरी साइट पर खोजें](/search), या बस [उद्धरण बनाएँ](/) और फ़ॉर्मेटर को आपके लिए नियम लागू करने दें।",
  },

  // /cheat-sheets and its three style sheets. The citation FORMATS in them
  // ("Author, A. A. (Year)…") are the styles' own templates and stay as they are in
  // every language, exactly as the per-style examples do; the labels around them do not.
  cheatSheets: {
    hubMetaTitle: "उद्धरण शैली त्वरित संदर्भ पत्रक - त्वरित संदर्भ मार्गदर्शिकाएँ",
    hubMetaDescription:
      "APA, MLA और Chicago उद्धरण शैलियों के लिए त्वरित-संदर्भ पत्रक। सामान्य स्रोत प्रकार के उदाहरणों सहित प्रिंट-अनुकूल मार्गदर्शिकाएँ।",
    hubBreadcrumbHome: "होम",
    hubBreadcrumbCurrent: "उद्धरण शैली त्वरित संदर्भ पत्रक",
    hubBackLink: "← जनरेटर पर वापस जाएँ",
    hubHeading: "उद्धरण शैली त्वरित संदर्भ पत्रक",
    hubIntro:
      "सबसे लोकप्रिय उद्धरण शैलियों के लिए त्वरित-संदर्भ मार्गदर्शिकाएँ। प्रिंट-अनुकूल और हमेशा अद्यतित।",
    hubApaTitle: "APA 7वाँ संस्करण त्वरित संदर्भ पत्रक",
    hubApaDesc: "मनोविज्ञान, सामाजिक विज्ञान, शिक्षा, नर्सिंग",
    hubMlaTitle: "MLA 9वाँ संस्करण त्वरित संदर्भ पत्रक",
    hubMlaDesc: "साहित्य, भाषाएँ, मानविकी, सांस्कृतिक अध्ययन",
    hubChicagoTitle: "Chicago शैली त्वरित संदर्भ पत्रक",
    hubChicagoDesc: "इतिहास, कला इतिहास, दर्शनशास्त्र, धर्म",
    backToSheets: "← त्वरित संदर्भ पत्रकों पर वापस जाएँ",
    generalRules: "सामान्य नियम",
    inTextCitations: "पाठ-अंतर्गत उद्धरण",
    colSituation: "स्थिति",
    colFormat: "प्रारूप",
    colExample: "उदाहरण",
    book: "पुस्तक",
    journalArticle: "शोध-पत्रिका लेख",
    website: "वेबसाइट",
    apaMetaTitle: "APA 7वाँ संस्करण त्वरित संदर्भ पत्रक - त्वरित संदर्भ मार्गदर्शिका",
    apaMetaDescription:
      "पुस्तकों, पत्रिकाओं, वेबसाइटों और अधिक के उदाहरणों सहित APA 7वें संस्करण का उद्धरण त्वरित संदर्भ पत्रक। प्रिंट-अनुकूल त्वरित संदर्भ।",
    apaHeading: "APA 7वाँ संस्करण त्वरित संदर्भ पत्रक",
    apaLead: "सबसे सामान्य APA उद्धरण प्रारूपों के लिए त्वरित संदर्भ।",
    apaRule1:
      'हैंगिंग इंडेंट का उपयोग करें (पहली पंक्ति बाईं ओर सीधी, बाद की पंक्तियाँ 0.5" इंडेंट)',
    apaRule2: "सभी प्रविष्टियों में दोहरी दूरी रखें",
    apaRule3: "लेखक के उपनाम के अनुसार वर्णानुक्रम में रखें",
    apaRule4: "पुस्तकों, पत्रिकाओं और खंडों के शीर्षकों को इटैलिक करें",
    apaRule5: "उपलब्ध होने पर DOI का उपयोग करें",
    apaRow1Situation: "1 लेखक",
    apaRow1Format: "(लेखक, वर्ष)",
    apaRow1Example: "(Smith, 2024)",
    apaRow2Situation: "2 लेखक",
    apaRow2Format: "(लेखक और लेखक, वर्ष)",
    apaRow2Example: "(Smith & Jones, 2024)",
    apaRow3Situation: "3+ लेखक",
    apaRow3Format: "(पहला लेखक et al., वर्ष)",
    apaRow3Example: "(Smith et al., 2024)",
    apaRow4Situation: "प्रत्यक्ष उद्धरण",
    apaRow4Format: "(लेखक, वर्ष, पृ. #)",
    apaRow4Example: "(Smith, 2024, p. 45)",
    apaRow5Situation: "बिना लेखक",
    apaRow5Format: '("शीर्षक," वर्ष)',
    apaRow5Example: '("Study Results," 2024)',
    apaReferenceHeading: "संदर्भ सूची उदाहरण",
    apaBookExample:
      "Author, A. A. (Year). *Title of work: Capital letter also for subtitle*. Publisher. https://doi.org/xxxxx",
    apaJournalExample:
      "Author, A. A., & Author, B. B. (Year). Title of article. *Title of Periodical, Volume*(Issue), Page–Page. https://doi.org/xxxxx",
    apaWebsiteExample:
      "Author, A. A. (Year, Month Day). *Title of page*. Site Name. https://www.example.com/page",
    apaChapterLabel: "संपादित पुस्तक अध्याय",
    apaChapterExample:
      "Author, A. A. (Year). Title of chapter. In E. E. Editor (Ed.), *Title of book* (pp. #–#). Publisher.",
    apaConferenceLabel: "सम्मेलन शोध-पत्र",
    apaConferenceExample:
      "Author, A. A. (Year, Month Days). *Title of paper* [Paper presentation]. Conference Name, Location.",
    apaDifferencesHeading: "APA 6वें से मुख्य अंतर",
    apaDifference1: 'URL से पहले "Retrieved from" नहीं',
    apaDifference2: "DOI को https://doi.org/ लिंक प्रारूप में शामिल करें",
    apaDifference3: "दीर्घवृत्त (...) का उपयोग करने से पहले 20 लेखकों तक सूचीबद्ध करें",
    apaDifference4: "प्रकाशक का स्थान अब आवश्यक नहीं",
    apaDifference5: 'लिंग-तटस्थ भाषा के लिए एकवचन "they" का उपयोग करें',
    apaCtaText: "स्वचालित रूप से सटीक APA उद्धरण बनाएँ",
    apaCtaButton: "APA उद्धरण जनरेटर →",
    mlaMetaTitle: "MLA 9वाँ संस्करण त्वरित संदर्भ पत्रक - त्वरित संदर्भ मार्गदर्शिका",
    mlaMetaDescription:
      "पुस्तकों, लेखों, वेबसाइटों और अधिक के उदाहरणों सहित MLA 9वें संस्करण का उद्धरण त्वरित संदर्भ पत्रक। प्रिंट-अनुकूल त्वरित संदर्भ।",
    mlaHeading: "MLA 9वाँ संस्करण त्वरित संदर्भ पत्रक",
    mlaLead: "सबसे सामान्य MLA उद्धरण प्रारूपों के लिए त्वरित संदर्भ।",
    mlaRule1: "हैंगिंग इंडेंट का उपयोग करें",
    mlaRule2: "सभी प्रविष्टियों में दोहरी दूरी रखें",
    mlaRule3: "लेखक के उपनाम के अनुसार वर्णानुक्रम में रखें",
    mlaRule4: 'पृष्ठ का शीर्षक "उद्धृत रचना सूची" रखें',
    mlaRule5: "कंटेनरों के शीर्षकों को इटैलिक करें (पुस्तकें, पत्रिकाएँ, वेबसाइटें)",
    mlaRow1Situation: "1 लेखक",
    mlaRow1Format: "(लेखक पृष्ठ)",
    mlaRow1Example: "(Smith 45)",
    mlaRow2Situation: "2 लेखक",
    mlaRow2Format: "(लेखक और लेखक पृष्ठ)",
    mlaRow2Example: "(Smith and Jones 45)",
    mlaRow3Situation: "3+ लेखक",
    mlaRow3Format: "(पहला लेखक et al. पृष्ठ)",
    mlaRow3Example: "(Smith et al. 45)",
    mlaRow4Situation: "बिना लेखक",
    mlaRow4Format: '("शीर्षक" पृष्ठ)',
    mlaRow4Example: '("Study Results" 45)',
    mlaRow5Situation: "बिना पृष्ठ संख्या",
    mlaRow5Format: "(लेखक)",
    mlaRow5Example: "(Smith)",
    mlaWorksCitedHeading: "उद्धृत रचना सूची उदाहरण",
    mlaBookExample: "Last, First. *Title of Book*. Publisher, Year.",
    mlaJournalExample:
      'Last, First. "Title of Article." *Journal Title*, vol. #, no. #, Year, pp. #–#.',
    mlaWebsiteExample:
      'Last, First. "Title of Page." *Website Name*, Day Month Year, URL.',
    mlaAnthologyLabel: "संकलन/संपादित पुस्तक",
    mlaAnthologyExample:
      'Last, First. "Title of Essay." *Title of Collection*, edited by First Last, Publisher, Year, pp. #–#.',
    mlaCoreHeading: "MLA मूल तत्व (क्रम में)",
    mlaCore1: "लेखक।",
    mlaCore2: '"स्रोत का शीर्षक।"',
    mlaCore3: "*कंटेनर का शीर्षक*,",
    mlaCore4: "योगदानकर्ता,",
    mlaCore5: "संस्करण,",
    mlaCore6: "संख्या,",
    mlaCore7: "प्रकाशक,",
    mlaCore8: "प्रकाशन तिथि,",
    mlaCore9: "स्थान (पृष्ठ, URL, DOI)।",
    mlaCtaText: "स्वचालित रूप से सटीक MLA उद्धरण बनाएँ",
    mlaCtaButton: "MLA उद्धरण जनरेटर →",
    chicagoMetaTitle: "Chicago शैली त्वरित संदर्भ पत्रक - त्वरित संदर्भ मार्गदर्शिका",
    chicagoMetaDescription:
      "Notes-Bibliography और Author-Date उदाहरणों सहित Chicago Manual of Style उद्धरण त्वरित संदर्भ पत्रक। प्रिंट-अनुकूल त्वरित संदर्भ।",
    chicagoHeading: "Chicago शैली त्वरित संदर्भ पत्रक",
    chicagoLead:
      "Chicago Manual of Style (18वाँ संस्करण) उद्धरण प्रारूपों के लिए त्वरित संदर्भ।",
    chicagoSystemsHeading: "Chicago की दो प्रणालियाँ",
    chicagoColNb: "टिप्पणी-ग्रंथ सूची (NB)",
    chicagoColAd: "लेखक-तिथि (AD)",
    chicagoRow1Nb: "पाद-टिप्पणियाँ/अंत-टिप्पणियाँ + ग्रंथ सूची",
    chicagoRow1Ad: "कोष्ठक उद्धरण + संदर्भ सूची",
    chicagoRow2Nb: "इतिहास, कला, मानविकी",
    chicagoRow2Ad: "विज्ञान, सामाजिक विज्ञान",
    chicagoRow3Nb: "अधिक विस्तृत पहली टिप्पणियाँ",
    chicagoRow3Ad: "APA प्रारूप के समान",
    chicagoExamplesHeading: "टिप्पणी-ग्रंथ सूची उदाहरण",
    chicagoNoteLabel: "टिप्पणी:",
    chicagoBibliographyLabel: "ग्रंथ सूची:",
    chicagoBookLabel: "पुस्तक (पाद-टिप्पणी)",
    chicagoBookNote: "1. First Last, *Title of Book* (Publisher, Year), page.",
    chicagoBookBibliography: "Last, First. *Title of Book*. Publisher, Year.",
    chicagoJournalLabel: "शोध-पत्रिका लेख (पाद-टिप्पणी)",
    chicagoJournalNote:
      '1. First Last, "Title of Article," *Journal Title* Vol, no. Issue (Year): pages.',
    chicagoJournalBibliography:
      'Last, First. "Title of Article." *Journal Title* Vol, no. Issue (Year): pages.',
    chicagoWebsiteLabel: "वेबसाइट (पाद-टिप्पणी)",
    chicagoWebsiteNote:
      '1. First Last, "Title of Page," Site Name, Month Day, Year, URL.',
    chicagoWebsiteBibliography:
      'Last, First. "Title of Page." Site Name. Month Day, Year. URL.',
    chicagoShortHeading: "संक्षिप्त टिप्पणियाँ",
    chicagoShortIntro: "पहले पूर्ण उद्धरण के बाद, संक्षिप्त पाद-टिप्पणियों का उपयोग करें:",
    chicagoShortExample: "1. Last, *Short Title*, page.",
    chicagoRulesHeading: "मुख्य स्वरूपण नियम",
    chicagoRule1: "पाठ में पाद-टिप्पणी संदर्भों के लिए सुपरस्क्रिप्ट संख्याओं का उपयोग करें",
    chicagoRule2: "ग्रंथ सूची की प्रविष्टियाँ हैंगिंग इंडेंट का उपयोग करती हैं",
    chicagoRule3:
      'एक ही स्रोत के लगातार उद्धरणों के लिए "Ibid." के बजाय संक्षिप्त नोट का उपयोग करें',
    chicagoRule4: "शीर्षक: पुस्तकें और पत्रिकाएँ इटैलिक में, लेख और अध्याय उद्धरण चिह्नों में",
    chicagoRule5: "बदल सकने वाले ऑनलाइन स्रोतों के लिए पहुँच तिथियों का उपयोग करें",
    chicagoCtaText: "स्वचालित रूप से सटीक Chicago उद्धरण बनाएँ",
    chicagoCtaButton: "Chicago उद्धरण जनरेटर →",
  },

  // The catalog's page-type labels (`CATALOG_TYPE_LABELS`), which the search page shows
  // as facet chips and beside every result. Layer 2: a fact from `src/lib/**` rather
  // than page chrome, and English until it is mapped through here.
  catalogTypes: {
    core: "मुख्य पृष्ठ",
    styleLanding: "प्रमुख उद्धरण शैली हब",
    style: "उद्धरण शैली संदर्भ पृष्ठ",
    styleExamples: "उद्धरण उदाहरण पृष्ठ",
    styleFormat: "पेपर स्वरूपण मार्गदर्शिकाएँ",
    styleInText: "पाठ-अंतर्गत उद्धरण मार्गदर्शिकाएँ",
    styleAnnotatedBibliography: "टिप्पणी-सहित संदर्भ सूची मार्गदर्शिकाएँ",
    styleReferencePage: "संदर्भ/उद्धृत रचना सूची पृष्ठ मार्गदर्शिकाएँ",
    tool: "निःशुल्क लेखन एवं उद्धरण उपकरण",
    guide: "शैक्षिक मार्गदर्शिकाएँ",
    guideCategory: "मार्गदर्शिका श्रेणियाँ",
    toolCollection: "टूल संग्रह",
    howToCite: "<style> में <source> कैसे उद्धृत करें",
    comparison: "उद्धरण शैली तुलनाएँ",
    converter: "पहचानकर्ता और प्रारूप परिवर्तक",
    field: "शैक्षणिक क्षेत्र अनुसार उद्धरण शैलियाँ",
    region: "देश/क्षेत्र अनुसार उद्धरण शैलियाँ",
    category: "विषय श्रेणी अनुसार उद्धरण शैलियाँ",
    cheatSheet: "एक-पृष्ठ त्वरित संदर्भ पत्रक",
    glossary: "उद्धरण एवं शैक्षणिक लेखन शब्दावली",
  },

  // /about
  aboutPage: {
    metaTitle: "CitationEasy के बारे में - निःशुल्क उद्धरण जनरेटर",
    metaDescription:
      "CitationEasy एक निःशुल्क उद्धरण जनरेटर है जो {count} शैलियों का समर्थन करता है। Citation Style Language, Citation.js और Next.js जैसे ओपन-सोर्स उपकरणों का उपयोग करके Samuel Sergi द्वारा निर्मित।",
    backLink: "← जनरेटर पर वापस जाएँ",
    heading: "CitationEasy के बारे में",
    intro:
      "CitationEasy एक निःशुल्क, खुली-पहुँच वाला उद्धरण जनरेटर है जो छात्रों, शोधकर्ताओं और शैक्षणिक लेखकों के लिए बनाया गया है। यह **{count} उद्धरण शैलियों** का समर्थन करता है और लेखन उपकरणों, शैक्षिक मार्गदर्शिकाओं और संदर्भ संसाधनों का एक बढ़ता हुआ संग्रह प्रदान करता है — बिना किसी पंजीकरण या सदस्यता की आवश्यकता के।",
    offerHeading: "हम क्या प्रदान करते हैं",
    offer1:
      "[उद्धरण जनरेटर](/) {count} शैलियों के साथ, जिनमें APA 7वाँ, MLA 9वाँ, Chicago 18वाँ, Harvard, Vancouver, IEEE और हज़ारों अन्य शामिल हैं",
    offer2:
      "[40 निःशुल्क लेखन और उद्धरण उपकरण](/tools) — शब्द गणक, पठनीयता जाँचकर्ता, DOI सत्यापनकर्ता, संदर्भ सूची वर्णानुक्रमक और अधिक",
    offer3:
      "[750 उद्धरण कैसे दें मार्गदर्शिकाएँ](/how-to-cite) जो 6 उद्धरण शैलियों में हर प्रमुख स्रोत प्रकार को कवर करती हैं",
    offer4:
      "[100+ शैक्षिक मार्गदर्शिकाएँ](/guides) उद्धरण की सर्वोत्तम प्रथाओं, शैक्षणिक लेखन और शोध कौशल पर",
    offer5:
      "[शैली तुलना उपकरण](/compare), [उद्धरण शैली प्रश्नोत्तरी](/quiz), और त्वरित संदर्भ के लिए [त्वरित संदर्भ पत्रक](/cheat-sheets)",
    offer6:
      "7 निर्यात प्रारूप: सादा टेक्स्ट, BibTeX, Word, क्रमांकित सूची, बुलेटेड सूची, RIS और CSV",
    openSourceHeading: "ओपन सोर्स के साथ निर्मित",
    openSourceIntro:
      "CitationEasy कई उत्कृष्ट ओपन-सोर्स परियोजनाओं और API के कारण संभव हुआ है। हम उचित श्रेय देने में विश्वास रखते हैं:",
    openSource1:
      "[Citation Style Language (CSL)](https://citationstyles.org/) — वह खुला मानक जो हमारी {count} उद्धरण शैलियों को शक्ति प्रदान करता है। CSL स्वयंसेवकों के एक समुदाय द्वारा बनाए रखा जाता है और Zotero, Mendeley और Papers जैसे संदर्भ प्रबंधकों द्वारा उपयोग किया जाता है। शैली परिभाषाएँ GitHub पर [CSL शैली रिपॉज़िटरी](https://github.com/citation-style-language/styles) से आती हैं।",
    openSource2:
      "[Citation.js](https://citation.js.org/) — वह JavaScript लाइब्रेरी जो उद्धरणों को प्रोसेस करती है और उन्हें CSL शैलियों के अनुसार स्वरूपित करती है। Lars Willighagen द्वारा निर्मित।",
    openSource3:
      "[Open Library API](https://openlibrary.org/developers/api) — Internet Archive द्वारा प्रदान की गई निःशुल्क पुस्तक खोज API, जो शीर्षक या ISBN द्वारा पुस्तक मेटाडेटा खोजने के लिए उपयोग की जाती है।",
    openSource4:
      "[DOI Foundation](https://www.doi.org/) — DOI को हल करने और सत्यापित करने के लिए उपयोग की जाने वाली डिजिटल ऑब्जेक्ट पहचानकर्ता प्रणाली।",
    createdHeading: "निर्माता",
    createdBody:
      "CitationEasy को **Samuel Sergi** द्वारा बनाया और बनाए रखा जाता है। लक्ष्य सरल है: एक वास्तव में निःशुल्क, उच्च-गुणवत्ता वाला उद्धरण उपकरण प्रदान करना जो सुविधाओं को पेवॉल के पीछे न रखे या खाते की आवश्यकता न रखे।",
    contactPrompt: "प्रश्न, प्रतिक्रिया या सुझाव हैं? संपर्क करें:",
    contactEmail: "Email: [sam@sammysergi.com](mailto:sam@sammysergi.com)",
    missionHeading: "हमारा मिशन",
    mission1:
      "सटीक उद्धरणों की कीमत नहीं होनी चाहिए। कई उद्धरण उपकरण निःशुल्क होने का विज्ञापन करते हैं लेकिन निर्यात प्रारूपों को सीमित करते हैं, उद्धरणों की संख्या सीमित करते हैं, या उपयोगकर्ताओं को प्रीमियम योजनाओं की ओर धकेलते हैं। CitationEasy पूरी तरह निःशुल्क रहने के लिए प्रतिबद्ध है — कोई पंजीकरण नहीं, कोई सीमा नहीं, कोई प्रीमियम स्तर नहीं।",
    mission2:
      "इस साइट पर हर सुविधा, उद्धरण जनरेटर से लेकर लेखन उपकरण और शैक्षिक मार्गदर्शिकाओं तक, सभी के लिए मुफ़्त उपलब्ध है। हम मानते हैं कि शैक्षणिक निष्ठा उपकरण सभी छात्रों और शोधकर्ताओं के लिए सुलभ होने चाहिए, चाहे उनका बजट कुछ भी हो।",
  },

  // /contact
  contactPage: {
    metaTitle: "संपर्क करें",
    metaDescription:
      "CitationEasy से संपर्क करें। हमारे निःशुल्क उद्धरण जनरेटर और लेखन उपकरणों के बारे में प्रश्न, प्रतिक्रिया या सुझाव हैं? हमें आपसे सुनना अच्छा लगेगा।",
    backLink: "← जनरेटर पर वापस जाएँ",
    heading: "संपर्क करें",
    intro:
      "CitationEasy के बारे में आपके पास प्रश्न, प्रतिक्रिया या सुझाव हैं? हमें आपसे सुनना अच्छा लगेगा। चाहे आपको कोई बग मिला हो, कोई फीचर सुझाव हो, या किसी उद्धरण में मदद चाहिए हो, बेझिझक हमसे संपर्क करें।",
    touchHeading: "हमसे संपर्क करें",
    touchBody:
      "हमसे संपर्क करने का सबसे अच्छा तरीका ईमेल है। हम 48 घंटों के भीतर जवाब देने का प्रयास करते हैं।",
    emailLine: "**Email:** [sam@sammysergi.com](mailto:sam@sammysergi.com)",
    commonHeading: "सामान्य प्रश्न",
    commonIntro:
      "संपर्क करने से पहले, आपको अपने प्रश्न का उत्तर इन संसाधनों में से किसी एक में मिल सकता है:",
    resource1:
      "[उद्धरण मार्गदर्शिकाएँ](/guides) — हर प्रमुख शैली में स्रोतों को उद्धृत करने के लिए चरण-दर-चरण निर्देश",
    resource2:
      "[उद्धरण कैसे दें मार्गदर्शिकाएँ](/how-to-cite) — उदाहरणों सहित 750 स्रोत-प्रकार और शैली संयोजन",
    resource3:
      "[त्वरित संदर्भ पत्रक](/cheat-sheets) — APA, MLA और Chicago स्वरूपण के लिए त्वरित संदर्भ",
    resource4:
      "[लेखन उपकरण](/tools) — शब्द गणक, पठनीयता जाँचकर्ता, DOI सत्यापनकर्ता और अधिक",
    issueHeading: "समस्या की रिपोर्ट करें",
    issueIntro:
      "यदि आपको कोई उद्धरण स्वरूपण त्रुटि, कोई टूटा हुआ फीचर, या गलत शैली मिली है, तो कृपया हमसे संपर्क करते समय अधिक से अधिक विवरण शामिल करें:",
    issue1: "आप जिस उद्धरण शैली का उपयोग कर रहे थे",
    issue2: "स्रोत प्रकार (पुस्तक, वेबसाइट, शोध-पत्रिका लेख, आदि)",
    issue3: "आपने क्या अपेक्षा की थी बनाम क्या जनरेट हुआ",
    issue4: "आपका ब्राउज़र और डिवाइस (यदि प्रासंगिक हो)",
    issueOutro: "इससे हमें समस्या को जल्दी पहचानने और ठीक करने में मदद मिलती है।",
    aboutHeading: "CitationEasy के बारे में",
    aboutBody:
      "CitationEasy एक निःशुल्क उद्धरण जनरेटर है जो 10,000 से अधिक उद्धरण शैलियों का समर्थन करता है। इसे Samuel Sergi द्वारा हर किसी के लिए सटीक उद्धरण सुलभ बनाने के लक्ष्य से बनाया गया था। हमारे [परिचय पृष्ठ](/about) पर अधिक जानें।",
  },

  // /ai — the agent and developer docs.
  //
  // The code samples, endpoint paths and MCP tool NAMES are deliberately absent: they are
  // the API's identifiers, served in English by the API itself, and a translated one
  // would document an endpoint that does not exist.
  aiPage: {
    metaTitle: "AI सहायकों और एजेंटों के लिए CitationEasy - API, MCP सर्वर, llms.txt",
    metaDescription:
      "CitationEasy को प्रोग्रामेटिक रूप से उपयोग करें: {count} शैलियों में उद्धरणों के लिए एक निःशुल्क, अप्रमाणीकृत JSON API, एजेंटों के लिए एक MCP सर्वर, llms.txt, एक OpenAPI स्पेक, और हर पृष्ठ का मार्कडाउन दृश्य।",
    keyword1: "उद्धरण API",
    keyword2: "MCP सर्वर",
    keyword3: "उद्धरण जनरेटर API",
    keyword4: "llms.txt",
    keyword5: "OpenAPI",
    keyword6: "AI एजेंट उद्धरण",
    keyword7: "निःशुल्क उद्धरण API",
    webApiDescription:
      "निःशुल्क, अप्रमाणीकृत JSON API जो URL, DOI, ISBN, PubMed ID, arXiv ID या CSL-JSON मेटाडेटा से {count} Citation Style Language शैलियों में उद्धरण स्वरूपित करता है।",
    breadcrumb: "AI और एजेंटों के लिए",
    heading: "AI सहायकों और एजेंटों के लिए CitationEasy",
    intro:
      "इस साइट पर सब कुछ सॉफ़्टवेयर के साथ-साथ लोगों के लिए भी उपलब्ध है: एक निःशुल्क JSON API, एक MCP सर्वर, एक OpenAPI स्पेक, एक llms.txt इंडेक्स, और सभी {count} पृष्ठों का मार्कडाउन दृश्य। कोई कुंजी नहीं, कोई खाता नहीं, हमारी अपनी कोई दर सीमा नहीं।",
    whyHeading: "स्वयं उद्धरण लिखने के बजाय API क्यों कॉल करें",
    whyBody:
      "उद्धरण स्वरूपण एक टेक्स्ट-जनरेशन समस्या जैसी दिखती है लेकिन है नहीं। हर शैली लेखक उलटाव, आद्याक्षर, टाइटल केस, कंटेनर विराम चिह्न, संस्करण विवरण और तिथि स्थान के बारे में सैकड़ों नियमों को एनकोड करती है, और ये इस तरह भिन्न होते हैं कि याद से लिखने पर सूक्ष्म रूप से गलत होना आसान है। CitationEasy आधिकारिक Citation Style Language परिभाषाओं के विरुद्ध **citeproc-js** चलाता है — वही इंजन जो Zotero और Mendeley उपयोग करते हैं — इसलिए आउटपुट नियतात्मक होता है और किसी पत्रिका के सबमिशन सिस्टम की अपेक्षा से मेल खाता है। मेटाडेटा Crossref, Open Library और PubMed से आता है; कुछ भी गढ़ा नहीं जाता, और स्रोत पर गायब कोई फ़ील्ड एक प्रशंसनीय अनुमान से भरने के बजाय गायब ही रहती है।",
    generateHeading: "एक उद्धरण बनाएँ",
    generateBody:
      "एक ही कॉल में 10 स्रोतों तक के लिए `input` के बजाय `inputs` भेजें, या लुकअप को पूरी तरह छोड़ने के लिए अपने पास पहले से मौजूद CSL-JSON मेटाडेटा के साथ `entry` भेजें। पाद-टिप्पणी रूप के लिए `note: true` जोड़ें। प्रति-स्रोत विफलताएँ उसी स्रोत पर वापस आती हैं, इसलिए एक बैच कभी पूरी तरह विफल नहीं होता।",
    mcpHeading: "MCP के माध्यम से कनेक्ट करें",
    mcpIntro:
      "`/api/mcp` पर Model Context Protocol एंडपॉइंट streamable HTTP पर JSON-RPC 2.0 बोलता है और किसी क्रेडेंशियल की आवश्यकता नहीं है।",
    mcpToolsHeading: "यह जो उपकरण प्रदान करता है",
    endpointsHeading: "एंडपॉइंट",
    colEndpoint: "एंडपॉइंट",
    colWhat: "यह क्या करता है",
    endpointCite:
      "एक साथ 10 स्रोतों तक स्वरूपित करता है। एक URL, DOI, ISBN, PubMed ID, arXiv ID, BibTeX/RIS/CSL-JSON टेक्स्ट, या एक CSL-JSON प्रविष्टि ऑब्जेक्ट लेता है। संदर्भ प्रविष्टि लौटाता है, और वैकल्पिक रूप से पाठ-अंतर्गत उद्धरण और पाद-टिप्पणी भी।",
    endpointStyles:
      "नाम, उद्धरण-प्रारूप वर्ग, विषय या क्षेत्र के अनुसार सभी {count} शैलियों को खोजें।",
    endpointStyleSlug:
      "एक शैली पूर्ण रूप से, उसकी अपनी CSL परिभाषा से बनाए गए वास्तविक स्वरूपित उदाहरणों सहित।",
    endpointSearch: "साइट के हर पृष्ठ पर प्रासंगिकता-रैंक की गई खोज।",
    endpointPages:
      "पृष्ठ प्रकार के अनुसार फ़िल्टर करने योग्य, संरचित प्रविष्टियों के रूप में संपूर्ण साइट कैटलॉग।",
    endpointHowToCite:
      "हर स्रोत-प्रकार × शैली मार्गदर्शन पृष्ठ, दोनों में से किसी के अनुसार फ़िल्टर करने योग्य।",
    endpointTools: "हर निःशुल्क उपकरण, उसकी श्रेणी और कीवर्ड सहित।",
    endpointGuides: "हर शैक्षिक मार्गदर्शिका, उसकी श्रेणी सहित।",
    endpointConverters: "साइट द्वारा दिए जाने वाले हर पहचानकर्ता और प्रारूप परिवर्तन।",
    endpointComparisons: "साथ-साथ शैली तुलनाएँ, दोनों शैलियों के रिकॉर्ड से जुड़ी हुई।",
    endpointFields:
      'शैक्षणिक क्षेत्र, विषय श्रेणियाँ और क्षेत्र — "मुझे कौन-सी शैली उपयोग करनी चाहिए?" के उत्तर के लिए।',
    endpointFaq: "सामान्य उद्धरण प्रश्नों के जाँचे-परखे उत्तर, q के साथ फ़िल्टर करने योग्य।",
    endpointGlossary:
      "पूर्ण परिभाषाओं सहित उद्धरण और शैक्षणिक-लेखन शब्द — प्रतिक्रिया में ही टेक्स्ट होता है, इसलिए बाद में कोई पृष्ठ लाने की आवश्यकता नहीं है।",
    endpointIndex: "एंडपॉइंट खोज दस्तावेज़। यदि आप खोजबीन कर रहे हैं तो यहाँ से शुरू करें।",
    discoveryHeading: "खोज फ़ाइलें",
    discoveryLlms: "भाषा मॉडलों के लिए लिखा गया साइट का चयनित इंडेक्स।",
    discoveryLlmsFull:
      "साइट द्वारा प्रकाशित हर पृष्ठ, प्रकार के अनुसार समूहित, प्रत्येक एक पंक्ति में।",
    discoveryOpenapi: "पूरे सार्वजनिक API का OpenAPI 3.1 विवरण।",
    discoveryMcp:
      "MCP एंडपॉइंट (streamable HTTP)। विवरण के लिए इसे ब्राउज़र में GET करें।",
    discoveryWellKnownMcp:
      "किसी डोमेन की जाँच करने वाले एजेंटों के लिए MCP खोज दस्तावेज़।",
    discoveryAiPlugin:
      "पुराना प्लगइन मैनिफेस्ट, उन फ्रेमवर्क के लिए जो अभी भी इसे खोजते हैं।",
    discoveryMd: "साइट के किसी भी पृष्ठ का मार्कडाउन दृश्य।",
    discoverySitemap: "हर इंडेक्स करने योग्य URL।",
    catalogHeading: "कैटलॉग में क्या है",
    catalogIntro:
      "नीचे दिया गया हर पृष्ठ HTML के रूप में, `/md/` के तहत मार्कडाउन के रूप में, और `/api/v1/pages` से एक संरचित प्रविष्टि के रूप में पहुँच योग्य है।",
    catalogStyles:
      "**{count}** उद्धरण शैलियाँ, प्रत्येक अपनी CSL परिभाषा से बने वास्तविक उदाहरणों सहित",
    catalogTools: "**{count}** निःशुल्क ब्राउज़र उपकरण",
    catalogGuides: "**{count}** शैक्षिक मार्गदर्शिकाएँ",
    catalogHowToCite: "**{count}** उद्धरण-कैसे-दें पृष्ठ",
    catalogComparisons: "**{count}** शैली तुलनाएँ",
    catalogConverters: "**{count}** परिवर्तक",
    catalogFields: "**{count}** शैक्षणिक क्षेत्र",
    catalogStyleLandings: "**{count}** प्रमुख शैली हब, पूर्ण स्वरूपण नियमों सहित",
    faqHeading: "अक्सर पूछे जाने वाले प्रश्न",
    faqFreeQ: "क्या CitationEasy API निःशुल्क है, और क्या मुझे API कुंजी चाहिए?",
    faqFreeA:
      "यह निःशुल्क है और कोई API कुंजी नहीं चाहिए। /api/v1 के तहत हर एंडपॉइंट अप्रमाणीकृत और CORS-खुला है, इसलिए आप इसे बिना पंजीकरण के ब्राउज़र, नोटबुक या एजेंट से कॉल कर सकते हैं। हमारी अपनी कोई दर सीमा नहीं है, लेकिन पहचानकर्ता लुकअप Crossref, Open Library और PubMed को प्रॉक्सी किए जाते हैं, जो अपनी स्वयं की उचित-उपयोग सीमाएँ लागू करते हैं — कई समानांतर अनुरोध भेजने के बजाय `inputs` के साथ बैच करें।",
    faqLlmQ: "क्या उद्धरण किसी भाषा मॉडल द्वारा जनरेट किए जाते हैं?",
    faqLlmA:
      "नहीं। स्वरूपण आधिकारिक Citation Style Language परिभाषाओं के विरुद्ध citeproc-js चलाता है, वही इंजन जो संदर्भ प्रबंधक उपयोग करते हैं। समान इनपुट और शैली हमेशा समान स्ट्रिंग बनाते हैं। ग्रंथसूची मेटाडेटा Crossref (DOI), Open Library (ISBN) और PubMed (PMID) से आता है — CitationEasy फ़ील्ड नहीं गढ़ता, इसलिए स्रोत पर गायब कोई भी चीज़ अनुमान लगाने के बजाय आउटपुट में गायब ही रहती है।",
    faqMcpQ: "मैं किसी एजेंट को MCP के माध्यम से CitationEasy से कैसे जोड़ूँ?",
    faqMcpA:
      "streamable HTTP ट्रांसपोर्ट का उपयोग करके किसी भी Model Context Protocol क्लाइंट को https://www.citationeasy.com/api/mcp पर इंगित करें। किसी क्रेडेंशियल की आवश्यकता नहीं है। Claude Code में: `claude mcp add --transport http citationeasy https://www.citationeasy.com/api/mcp`। सर्वर उद्धरण बनाने, {count} शैलियों को खोजने, स्रोत-प्रकार मार्गदर्शन, साइट खोज और किसी भी पृष्ठ को मार्कडाउन के रूप में पढ़ने के लिए उपकरण प्रदान करता है।",
    faqStylesQ: "API कौन-सी उद्धरण शैलियाँ बना सकता है?",
    faqStylesA:
      'Citation Style Language रिपॉज़िटरी की सभी {count} शैलियाँ, जिनमें APA 7, MLA 9, दोनों Chicago प्रणालियाँ, Harvard, Vancouver, IEEE, AMA और हज़ारों अलग-अलग पत्रिका शैलियाँ शामिल हैं। `style` फ़ील्ड में शैली का स्लग पास करें। "chicago" और "harvard" जैसे सरल स्लग सही CSL वैरिएंट में हल हो जाते हैं, और /api/v1/styles?q= बाकी को खोज लेता है।',
    faqLlmsTxtQ: "llms.txt क्या है और CitationEasy का कहाँ है?",
    faqLlmsTxtA:
      "llms.txt किसी साइट का सादा-टेक्स्ट इंडेक्स है जो ब्राउज़रों के बजाय भाषा मॉडलों के लिए लिखा गया है। CitationEasy का /llms.txt पर है; साइट के हर पृष्ठ को सूचीबद्ध करने वाला संपूर्ण संस्करण /llms-full.txt पर है।",
    faqMarkdownQ:
      "क्या मैं CitationEasy के पृष्ठों को HTML के बजाय मार्कडाउन के रूप में पढ़ सकता हूँ?",
    faqMarkdownA:
      "हाँ। किसी भी साइट पथ के आगे /md/ लगाएँ — उदाहरण के लिए /md/citation-style/apa या /md/tools/word-counter। डेटा-संचालित पृष्ठ अपनी पूरी सामग्री लौटाते हैं, जिसमें प्रत्येक शैली की अपनी CSL परिभाषा से बने वास्तविक स्वरूपित उदाहरण शामिल हैं। हाथ से लिखे गद्य पृष्ठ (मार्गदर्शिकाएँ, त्वरित संदर्भ पत्रक) एक सारांश कार्ड और कैननिकल HTML URL लौटाते हैं, क्योंकि उनका टेक्स्ट स्वयं पृष्ठ में रहता है।",
    faqReuseQ: "क्या मैं CitationEasy के आउटपुट को अपने ही उत्पाद में उपयोग कर सकता हूँ?",
    faqReuseA:
      "हाँ। एक स्वरूपित उद्धरण किसी स्रोत के बारे में एक तथ्य है; इसे स्वतंत्र रूप से उपयोग करें। CSL शैली परिभाषाएँ स्वयं Citation Style Language परियोजना से CC BY-SA 3.0 के तहत आती हैं। CitationEasy को श्रेय देना सराहनीय है पर आवश्यक नहीं।",
    missingHeading: "कुछ छूट रहा है?",
    missingBody:
      "यदि आपके एजेंट को कोई एंडपॉइंट, फ़ील्ड, या प्रारूप चाहिए जो यहाँ नहीं है, तो [हमें बताएँ](/contact)। इसके बजाय हाथ से ब्राउज़ कर रहे हैं? [उद्धरण जनरेटर से शुरू करें](/)।",
  },

  // /quiz. The client component reads these as a prop rather than through a context:
  // it is one component, not the generator's nine, so there is nothing to drill through.
  quizPage: {
    metaTitle: "मुझे कौन-सी उद्धरण शैली उपयोग करनी चाहिए? - निःशुल्क शैली प्रश्नोत्तरी",
    metaDescription:
      "अपने बेहतरीन उद्धरण शैली खोजने के लिए अपने क्षेत्र, पेपर प्रकार और प्राथमिकताओं के बारे में कुछ त्वरित प्रश्नों के उत्तर दें। APA, MLA, Chicago, Vancouver और अधिक।",
    ogTitle: "मुझे कौन-सी उद्धरण शैली उपयोग करनी चाहिए?",
    ogDescription:
      "अपने पेपर के लिए सर्वोत्तम उद्धरण शैली खोजने हेतु हमारी निःशुल्क प्रश्नोत्तरी लें।",
    breadcrumbHome: "CitationEasy",
    breadcrumbCurrent: "शैली प्रश्नोत्तरी",
    backLink: "← जनरेटर पर वापस जाएँ",
    heading: "मुझे कौन-सी उद्धरण शैली उपयोग करनी चाहिए?",
    intro:
      "कुछ त्वरित प्रश्नों के उत्तर दें और हम आपके पेपर के लिए सर्वोत्तम उद्धरण शैली सुझाएँगे।",
    progress: "प्रश्न {current} / {total}",
    qDiscipline: "आपका अध्ययन क्षेत्र क्या है?",
    optSocialScience: "मनोविज्ञान / सामाजिक विज्ञान",
    optHumanities: "साहित्य / मानविकी",
    optHistory: "इतिहास / कला इतिहास",
    optMedical: "चिकित्सा / नर्सिंग / स्वास्थ्य",
    optEngineering: "इंजीनियरिंग / कंप्यूटर विज्ञान",
    optNaturalScience: "प्राकृतिक विज्ञान (जीव विज्ञान, रसायन विज्ञान)",
    optLaw: "विधि",
    optBusiness: "व्यवसाय / अर्थशास्त्र",
    qPaperType: "आप किस प्रकार का पेपर लिख रहे हैं?",
    optResearch: "शोध पत्र या शोध-प्रबंध",
    optReview: "साहित्य समीक्षा",
    optReport: "प्रयोगशाला रिपोर्ट या तकनीकी रिपोर्ट",
    optEssay: "निबंध या कक्षा असाइनमेंट",
    optJournal: "शोध-पत्रिका लेख सबमिशन",
    qRegion: "आपकी संस्था कहाँ स्थित है?",
    optUs: "संयुक्त राज्य अमेरिका",
    optUk: "यूनाइटेड किंगडम / ऑस्ट्रेलिया",
    optCanada: "कनाडा",
    optEurope: "यूरोप (यूके को छोड़कर)",
    optOther: "अन्य",
    qPreference: "क्या आपकी उद्धरण प्रारूप के लिए कोई प्राथमिकता है?",
    optAuthorDate: "पाठ-अंतर्गत उद्धरण (लेखक, वर्ष)",
    optNumeric: "क्रमांकित संदर्भ [1]",
    optFootnotes: "पाद-टिप्पणियाँ",
    optNoPreference: "कोई प्राथमिकता नहीं",
    styleVancouver: "Vancouver",
    styleAma: "AMA (अमेरिकन मेडिकल एसोसिएशन)",
    styleIeee: "IEEE",
    styleBluebook: "Bluebook",
    styleCse: "CSE (काउंसिल ऑफ साइंस एडिटर्स)",
    styleChicagoNotes: "Chicago (टिप्पणी एवं ग्रंथ सूची)",
    styleMla: "MLA (9वाँ संस्करण)",
    styleApa: "APA (7वाँ संस्करण)",
    styleHarvard: "Harvard",
    reasonVancouverMedical:
      "Vancouver चिकित्सा और स्वास्थ्य विज्ञान पत्रिकाओं के लिए मानक है, जो क्रमांकित संदर्भों का उपयोग करता है।",
    reasonAma:
      "AMA चिकित्सा पत्रिकाओं में व्यापक रूप से उपयोग होता है और क्रमांकित उद्धरण का उपयोग करता है।",
    reasonIeee:
      "IEEE इंजीनियरिंग, कंप्यूटर विज्ञान और IT क्षेत्रों के लिए मानक उद्धरण शैली है।",
    reasonBluebook:
      "Bluebook विधिक लेखन के लिए निश्चित उद्धरण शैली है। Chicago शैली सबसे नज़दीकी सामान्य-प्रयोजन विकल्प है।",
    reasonCse: "CSE जीव विज्ञान और प्राकृतिक विज्ञान के लिए मानक है।",
    reasonChicagoHistory:
      "Chicago टिप्पणी एवं ग्रंथ सूची इतिहास और कला इतिहास के लिए स्वर्ण मानक है, जो उद्धरणों के लिए पाद-टिप्पणियों का उपयोग करता है।",
    reasonChicagoHumanities:
      "Chicago टिप्पणी एवं ग्रंथ सूची अपने पाद-टिप्पणी-आधारित दृष्टिकोण के साथ मानविकी के लिए अच्छी तरह उपयुक्त है।",
    reasonMla: "MLA साहित्य, भाषा और मानविकी क्षेत्रों के लिए मानक है।",
    reasonApaBusiness:
      "APA व्यवसाय, अर्थशास्त्र और प्रबंधन क्षेत्रों में व्यापक रूप से उपयोग होता है।",
    reasonHarvard:
      "Harvard संदर्भ शैली यूके और ऑस्ट्रेलियाई विश्वविद्यालयों में सबसे सामान्य शैली है।",
    reasonChicagoFootnotes:
      "Chicago टिप्पणी एवं ग्रंथ सूची पाद-टिप्पणियों का उपयोग करता है, जो विस्तृत उद्धरणों के लिए आदर्श है।",
    reasonVancouverNumeric:
      "Vancouver क्रमांकित उद्धरणों का उपयोग करता है, जिससे आपका पाठ स्वच्छ और पठनीय बना रहता है।",
    reasonApaDefault:
      "APA सामाजिक विज्ञान, शिक्षा और कई अन्य विषयों में सबसे व्यापक रूप से उपयोग की जाने वाली उद्धरण शैली है।",
    recommendLabel: "हम सुझाते हैं",
    generateButton: "{style} उद्धरण बनाएँ",
    retakeButton: "फिर से प्रश्नोत्तरी लें",
    guidesLink: "अधिक सहायता के लिए हमारी उद्धरण मार्गदर्शिकाएँ देखें →",
    previousButton: "← पिछला प्रश्न",
  },

  // /search — the server-rendered site search.
  searchPage: {
    metaTitle: "CitationEasy खोजें",
    metaDescription:
      "CitationEasy पर एक साथ हर पृष्ठ खोजें: {count} उद्धरण शैलियाँ, 250+ निःशुल्क उपकरण, मार्गदर्शिकाएँ, उद्धरण-कैसे-दें पृष्ठ, शैली तुलनाएँ, परिवर्तक और शब्दावली।",
    keyword1: "उद्धरण शैलियाँ खोजें",
    keyword2: "उद्धरण मार्गदर्शिका खोजें",
    keyword3: "उद्धरण उपकरण खोज",
    ogDescription:
      "साइट पर एक साथ हर पृष्ठ खोजें — शैलियाँ, उपकरण, मार्गदर्शिकाएँ, उद्धरण-कैसे-दें पृष्ठ, तुलनाएँ, परिवर्तक और शब्दावली शब्द।",
    ogImageSubtitle:
      "हर उद्धरण शैली, उपकरण, मार्गदर्शिका, कैसे-करें पृष्ठ, तुलना, परिवर्तक और शब्दावली शब्द — एक साथ खोजे गए।",
    ogKind: "खोज",
    breadcrumb: "खोज",
    heading: "CitationEasy खोजें",
    intro:
      "साइट पर हर उद्धरण शैली, उपकरण, मार्गदर्शिका, कैसे-करें पृष्ठ, तुलना, परिवर्तक और शब्दावली शब्द — एक साथ खोजे गए।",
    inputLabel: "खोज क्वेरी",
    inputPlaceholder: "उदाहरण: APA में पॉडकास्ट उद्धृत करें, हैंगिंग इंडेंट, DOI",
    submit: "खोजें",
    browseHeading: "या अनुभाग के अनुसार ब्राउज़ करें",
    browseStyles: "उद्धरण शैलियाँ",
    browseStylesNote: "{count} शैलियाँ",
    browseTools: "निःशुल्क उपकरण",
    browseToolsNote: "{count} उपकरण",
    browseHowTo: "किसी भी स्रोत को कैसे उद्धृत करें",
    browseHowToNote: "{count} पृष्ठ",
    browseGuides: "मार्गदर्शिकाएँ",
    browseGuidesNote: "{count} मार्गदर्शिकाएँ",
    browseGlossary: "शब्दावली",
    browseGlossaryNote: "{count} शब्द",
    browseComparisons: "शैली तुलनाएँ",
    browseComparisonsNote: "{count} तुलनाएँ",
    browseConverters: "परिवर्तक",
    browseConvertersNote: "{count} परिवर्तक",
    browseCheatSheets: "त्वरित संदर्भ पत्रक",
    browseCheatSheetsNote: "{count} पत्रक",
    facetsLabel: "पृष्ठ प्रकार के अनुसार फ़िल्टर करें",
    facetAll: "सभी ({count})",
    noMatches: "किसी भी पृष्ठ में “{query}” नहीं मिला।",
    matchesOne: "{count} पृष्ठ “{query}” से मेल खाता है।",
    matchesMany: "{count} पृष्ठ “{query}” से मेल खाते हैं।",
    pagerLabel: "परिणाम पृष्ठ",
    pagerPrevious: "← पिछला",
    pagerNext: "अगला →",
    pagerPosition: "पृष्ठ {page} / {total}",
    paletteLoading: "खोज जारी है…",
    paletteError: "खोज अभी उपलब्ध नहीं है। कृपया फिर से कोशिश करें।",
    paletteViewAll: "“{query}” के सभी परिणाम देखें",
    apiNote:
      "कुछ बना रहे हैं? यही इंडेक्स JSON के रूप में [/api/v1/search](/api/v1/search?q=podcast) पर और MCP के माध्यम से भी उपलब्ध है — देखें [एजेंट दस्तावेज़](/ai)।",
  },

  // /cite-this-page. The six FAQ answers used to exist twice — once in the layout for the
  // FAQPage markup and once in the page for the visible list — which is exactly the drift
  // this dictionary removes: both now read the same keys.
  citeThisPage: {
    metaTitle: "इस पृष्ठ को उद्धृत करें - एक-क्लिक उद्धरण (बुकमार्कलेट और Chrome एक्सटेंशन)",
    metaDescription:
      "किसी भी वेब पृष्ठ को एक क्लिक में उद्धृत करें। निःशुल्क 'इस पृष्ठ को उद्धृत करें' बुकमार्कलेट को अपने बुकमार्क बार में खींचें, या टूलबार बटन और राइट-क्लिक उद्धरण सुविधा वाला निःशुल्क Chrome एक्सटेंशन इंस्टॉल करें। यह Chromebook और प्रतिबंधित ब्राउज़रों पर भी काम करता है।",
    ogTitle: "इस पृष्ठ को उद्धृत करें बुकमार्कलेट और Chrome एक्सटेंशन",
    ogDescription:
      "किसी भी पृष्ठ से एक-क्लिक वेबसाइट उद्धरण — एक ड्रैग-एंड-ड्रॉप बुकमार्कलेट और राइट-क्लिक उद्धरण वाला निःशुल्क Chrome एक्सटेंशन।",
    breadcrumbRoot: "CitationEasy",
    breadcrumbSchemaCurrent: "इस पृष्ठ को उद्धृत करें बुकमार्कलेट",
    appName: "इस पृष्ठ को उद्धृत करें बुकमार्कलेट",
    appDescription:
      "एक निःशुल्क बुकमार्कलेट जो आपके द्वारा पढ़े जा रहे वेब पृष्ठ को एक क्लिक में उद्धृत करता है — यह पृष्ठ के URL के साथ पहले से भरा हुआ CitationEasy खोलता है, फिर उद्धरण को APA, MLA, Chicago और {count} अन्य शैलियों में स्वरूपित करता है।",
    breadcrumbLabel: "ब्रेडक्रंब",
    breadcrumbHome: "होम",
    breadcrumbCurrent: "इस पृष्ठ को उद्धृत करें बुकमार्कलेट",
    heading: "इस पृष्ठ को उद्धृत करें: बुकमार्कलेट और Chrome एक्सटेंशन",
    intro:
      "किसी भी वेब पृष्ठ को एक क्लिक में उद्धृत करें — बिना पंजीकरण के। नीचे दिए गए बुकमार्कलेट को अपने बुकमार्क बार में खींचें (कोई इंस्टॉल नहीं चाहिए), या टूलबार बटन और राइट-क्लिक उद्धरण के लिए निःशुल्क Chrome एक्सटेंशन प्राप्त करें।",
    dragPrompt: "इस बटन को अपने बुकमार्क बार में खींचें:",
    buttonTitle: "मुझे अपने बुकमार्क बार में खींचें",
    buttonLabel: "📑 इस पृष्ठ को उद्धृत करें",
    dontClick: "इसे यहाँ क्लिक न करें — पहले इसे अपने बुकमार्क बार में खींचें।",
    installHeading: "इसे कैसे इंस्टॉल करें",
    step1Title: "अपना बुकमार्क बार दिखाएँ",
    step1Body:
      "अधिकांश ब्राउज़रों में बुकमार्क बार को चालू/बंद करने के लिए Ctrl+Shift+B (Mac पर Cmd+Shift+B) दबाएँ ताकि आपके पास बटन छोड़ने के लिए जगह हो।",
    step2Title: "बटन को ऊपर खींचें",
    step2Body:
      "नीचे दिए गए 'इस पृष्ठ को उद्धृत करें' बटन को क्लिक करके पकड़ें, फिर इसे अपने बुकमार्क बार पर खींचें और छोड़ दें। यह एक सामान्य बुकमार्क बन जाता है।",
    step3Title: "इसे किसी भी पृष्ठ पर क्लिक करें",
    step3Body:
      "किसी लेख, समाचार कहानी या पत्रिका पृष्ठ को पढ़ते समय, अपने नए बुकमार्क पर क्लिक करें। CitationEasy उस पृष्ठ के URL के साथ पहले से भरा हुआ खुलता है और उद्धरण कॉपी करने के लिए तैयार होता है।",
    manualHeading: "इसे खींच नहीं सकते? इसे मैन्युअल रूप से जोड़ें",
    manualBody:
      'एक नया बुकमार्क बनाएँ, इसका नाम "इस पृष्ठ को उद्धृत करें" रखें, और इसे URL/पते के रूप में चिपकाएँ:',
    howHeading: "यह कैसे काम करता है",
    howBody:
      "बुकमार्कलेट आपके द्वारा पढ़े जा रहे पृष्ठ पर कोई कोड नहीं चलाता। यह केवल उस पृष्ठ का वेब पता CitationEasy को देता है, जहाँ हमारा सर्वर सार्वजनिक पृष्ठ मेटाडेटा प्राप्त और पार्स करता है — वही विश्वसनीय मार्ग जो तब उपयोग होता है जब आप मैन्युअल रूप से जनरेटर में URL चिपकाते हैं। इससे यह सुरक्षित रहता है और पुराने इन-पेज बुकमार्कलेट को हटाने वाली क्रॉस-ओरिजिन सीमाओं से बचता है।",
    extensionHeading: "Chrome एक्सटेंशन पसंद करते हैं?",
    extensionBody:
      "निःशुल्क CitationEasy एक्सटेंशन एक टूलबार बटन जोड़ता है जो वर्तमान टैब को उद्धृत करता है, साथ ही किसी लिंक — या चयनित DOI या ISBN — को बिना खोले उद्धृत करने के लिए राइट-क्लिक विकल्प देता है। बुकमार्कलेट की तरह, यह आपके द्वारा देखे जाने वाले पृष्ठों पर कोई कोड नहीं चलाता: यह केवल URL को CitationEasy को देता है। इसे केवल `activeTab` और `contextMenus` अनुमतियों की आवश्यकता है, और यह Chrome, Edge, Brave और अन्य Chromium ब्राउज़रों में काम करता है।",
    downloadButton: "⬇ Chrome एक्सटेंशन डाउनलोड करें (.zip)",
    install1: "एक्सटेंशन डाउनलोड करें और अनज़िप करें।",
    install2: "`chrome://extensions` खोलें और **डेवलपर मोड** चालू करें (ऊपर दाईं ओर)।",
    install3: "**अनपैक्ड लोड करें** पर क्लिक करें और अनज़िप की गई फ़ोल्डर चुनें।",
    install4:
      "CitationEasy बटन को पिन करें, फिर उद्धृत करने के लिए इसे किसी भी पृष्ठ पर क्लिक करें।",
    faqHeading: "अक्सर पूछे जाने वाले प्रश्न",
    faqWhatQ: "'इस पृष्ठ को उद्धृत करें' बुकमार्कलेट क्या है?",
    faqWhatA:
      "यह एक छोटा बुकमार्क है जिसे आप अपने ब्राउज़र के बुकमार्क बार में खींचते हैं। जब आप इसे किसी भी वेब पृष्ठ पर क्लिक करते हैं, तो यह उस पृष्ठ के URL के साथ पहले से भरे हुए एक नए टैब में CitationEasy खोलता है, ताकि आपको एक क्लिक में स्वरूपित उद्धरण मिल जाए — कोई कॉपी-पेस्ट नहीं।",
    faqExtensionNeededQ: "क्या मुझे कोई एक्सटेंशन इंस्टॉल करना होगा?",
    faqExtensionNeededA:
      "नहीं। बुकमार्कलेट सिर्फ एक बुकमार्क है, इसलिए इंस्टॉल करने के लिए कुछ नहीं है और कोई अनुमति देने की आवश्यकता नहीं है। यह प्रतिबंधित स्कूल Chromebook और अधिकांश मोबाइल ब्राउज़रों पर काम करता है जहाँ एक्सटेंशन अवरुद्ध होते हैं। यदि आप एक्सटेंशन पसंद करते हैं, तो इस पृष्ठ पर एक निःशुल्क Chrome एक्सटेंशन भी उपलब्ध है।",
    faqChromeQ: "क्या कोई Chrome एक्सटेंशन है?",
    faqChromeA:
      "हाँ। निःशुल्क CitationEasy Chrome एक्सटेंशन एक टूलबार बटन जोड़ता है जो वर्तमान टैब को उद्धृत करता है, साथ ही किसी लिंक या चयनित DOI/ISBN को बिना खोले उद्धृत करने के लिए राइट-क्लिक विकल्प देता है। यह आपके द्वारा देखे जाने वाले पृष्ठों पर कोई कोड नहीं चलाता और इसे केवल activeTab और contextMenus अनुमतियों की आवश्यकता है। इसे इस पृष्ठ से डाउनलोड करें और chrome://extensions के माध्यम से लोड करें, यह Chrome, Edge, Brave और अन्य Chromium ब्राउज़रों में काम करता है।",
    faqAddQ: "मैं बुकमार्कलेट कैसे जोड़ूँ?",
    faqAddA:
      "सुनिश्चित करें कि आपका बुकमार्क बार दिखाई दे रहा है, फिर इस पृष्ठ पर 'इस पृष्ठ को उद्धृत करें' बटन को उस पर खींचें। यदि खींचना संभव नहीं है (उदाहरण के लिए मोबाइल पर), तो मैन्युअल रूप से एक नया बुकमार्क बनाएँ और बुकमार्कलेट कोड को URL के रूप में चिपकाएँ।",
    faqSafeQ: "क्या यह सुरक्षित है? क्या यह उस पृष्ठ को पढ़ता है जिस पर मैं हूँ?",
    faqSafeA:
      "हाँ, यह सुरक्षित है। बुकमार्कलेट आपके द्वारा पढ़े जा रहे पृष्ठ पर कोई कोड नहीं चलाता — यह केवल उस पृष्ठ का वेब पता CitationEasy को भेजता है, जहाँ हमारा सर्वर सार्वजनिक पृष्ठ मेटाडेटा प्राप्त और पार्स करता है, बिल्कुल वैसे ही जैसे जब आप मैन्युअल रूप से URL चिपकाते हैं।",
    faqOtherSourcesQ: "क्या यह वेबसाइटों के अलावा अन्य स्रोतों के लिए काम करता है?",
    faqOtherSourcesA:
      "बुकमार्कलेट वेब पृष्ठों के लिए है, लेकिन अंतर्निहित लिंक ?source= पैरामीटर के माध्यम से DOI, ISBN, PMID या arXiv ID भी स्वीकार करता है — इसलिए एक साझा करने योग्य 'उद्धृत करें' लिंक शोध-पत्रिका लेखों और पुस्तकों के लिए भी काम करता है।",
    relatedHeading: "संबंधित उपकरण",
    relatedGenerator: "उद्धरण जनरेटर",
    relatedHowToCite: "वेबसाइट को कैसे उद्धृत करें",
    relatedTools: "सभी उपकरण",
  },

  // /shared-bibliography — opens a bibliography that travelled inside a share link.
  sharedBibliographyPage: {
    metaTitle: "साझा संदर्भ सूची - साझा उद्धरण देखें और आयात करें",
    metaDescription:
      "CitationEasy से किसी द्वारा आपके साथ साझा की गई संदर्भ सूची खोलें। स्वरूपित उद्धरण देखें, उन्हें कॉपी करें, या पूरी सूची को अपनी संदर्भ सूची में आयात करें — निःशुल्क, बिना खाते के, और डेटा लिंक में ही रहता है।",
    ogTitle: "साझा संदर्भ सूची",
    ogDescription:
      "एक साझा संदर्भ सूची देखें और आयात करें। उद्धरण लिंक के भीतर ही यात्रा करते हैं — कुछ भी सर्वर पर संग्रहीत नहीं होता, और लिंक कभी समाप्त नहीं होते।",
    breadcrumbRoot: "CitationEasy",
    breadcrumbLabel: "ब्रेडक्रंब",
    breadcrumbHome: "होम",
    breadcrumbCurrent: "साझा संदर्भ सूची",
    heading: "साझा संदर्भ सूची",
    intro:
      "किसी ने ये उद्धरण आपके साथ साझा किए हैं। उन्हें कॉपी करें, या एक क्लिक में पूरी सूची को अपनी CitationEasy संदर्भ सूची में आयात करें।",
    loading: "साझा संदर्भ सूची खोली जा रही है…",
    copyAll: "सभी कॉपी करें",
    copied: "कॉपी हो गया",
    copyFailed: "कॉपी विफल",
    citationOne: "उद्धरण",
    citationMany: "उद्धरण",
    addAll: "सभी को मेरी संदर्भ सूची में जोड़ें",
    added: "{count} आपकी संदर्भ सूची में जोड़े गए",
    skippedOne: "{count} डुप्लिकेट छोड़ा गया",
    skippedMany: "{count} डुप्लिकेट छोड़े गए",
    openGenerator: "जनरेटर खोलें",
    emptyHeading: "इस लिंक में कोई साझा संदर्भ सूची नहीं है",
    emptyBody:
      "यह पृष्ठ CitationEasy से साझा की गई संदर्भ सूचियाँ प्रदर्शित करता है। अपनी सूची साझा करने के लिए, [उद्धरण जनरेटर](/) में अपनी संदर्भ सूची खोलें, **निर्यात करें → साझा करने का लिंक कॉपी करें** चुनें, और लिंक किसी को भी भेजें। उद्धरण लिंक के भीतर ही यात्रा करते हैं — कुछ भी सर्वर पर संग्रहीत नहीं होता, इसलिए लिंक हमेशा काम करते रहते हैं और आपका डेटा निजी रहता है।",
    decodeError: "यह साझा लिंक खोला नहीं जा सका।",
  },

  // The 19 source types the 15 detailed styles show worked examples for
  // (`DetailedStyleData.examples[].sourceType`). 75 rows, 19 distinct values — so this
  // is a vocabulary, not per-page copy, and it belongs here rather than repeated in
  // every locale's `src/content/style-pages/<locale>.json`.
  //
  // Two casings for the same reason `howToCitePage.refList*Lower` has two: the pages
  // print the label as a heading ("Book") and inside a sentence ("a sample APA entry
  // for a book"). Lower-casing the translated noun in code is wrong in German, where
  // every one of these is capitalised, so the lower form is a real key a translator
  // fills rather than a `.toLowerCase()` call.
  //
  // The citations themselves — `referenceEntry` and `inTextCitation` — are NOT here and
  // are not translatable anywhere: they are worked examples in a specific style's own
  // punctuation. See `src/lib/localized-content.ts`.
  sourceTypes: {
    book: "पुस्तक",
    bookLower: "पुस्तक",
    bookChapter: "पुस्तक अध्याय",
    bookChapterLower: "पुस्तक अध्याय",
    case: "मामला",
    caseLower: "मामला",
    conferencePaper: "सम्मेलन शोध-पत्र",
    conferencePaperLower: "सम्मेलन शोध-पत्र",
    courtCase: "न्यायालय मामला",
    courtCaseLower: "न्यायालय मामला",
    federalStatute: "संघीय अधिनियम",
    federalStatuteLower: "संघीय अधिनियम",
    governmentDocument: "सरकारी दस्तावेज़",
    governmentDocumentLower: "सरकारी दस्तावेज़",
    governmentReport: "सरकारी रिपोर्ट",
    governmentReportLower: "सरकारी रिपोर्ट",
    journalArticle: "शोध-पत्रिका लेख",
    journalArticleLower: "शोध-पत्रिका लेख",
    lawReviewArticle: "विधि पत्रिका लेख",
    lawReviewArticleLower: "विधि पत्रिका लेख",
    legislation: "विधान",
    legislationLower: "विधान",
    newspaperArticle: "समाचार-पत्र लेख",
    newspaperArticleLower: "समाचार-पत्र लेख",
    patent: "पेटेंट",
    patentLower: "पेटेंट",
    podcast: "पॉडकास्ट",
    podcastLower: "पॉडकास्ट",
    preprint: "प्रीप्रिंट",
    preprintLower: "प्रीप्रिंट",
    standard: "मानक",
    standardLower: "मानक",
    thesis: "शोध-प्रबंध",
    thesisLower: "शोध-प्रबंध",
    website: "वेबसाइट",
    websiteLower: "वेबसाइट",
    youtubeVideo: "YouTube वीडियो",
    youtubeVideoLower: "YouTube वीडियो",
  },

  // Chrome shared by the five per-style guide routes — /examples, /format,
  // /in-text-citation, /reference-page and /annotated-bibliography, 15 styles each.
  //
  // One section rather than five copies: the CTA, the back link and the cross-links
  // between the five pages are the same sentences on every one of them, and duplicating
  // them per route would be five identical translation units instead of one.
  styleGuidePages: {
    backToStyle: "{style} पर वापस जाएँ",
    backToGenerator: "उद्धरण जनरेटर पर वापस जाएँ",
    ctaHeading: "स्वचालित रूप से {style} उद्धरण बनाएँ",
    ctaButton: "अभी {style} में उद्धृत करें →",
    faqHeading: "अक्सर पूछे जाने वाले प्रश्न",
    resourcesHeading: "अधिक संसाधन",
    relatedHeading: "संबंधित {style} मार्गदर्शिकाएँ",
    resourceGenerator: "निःशुल्क उद्धरण जनरेटर ({count} शैलियाँ)",
    resourceTools: "निःशुल्क लेखन उपकरण",
    resourceGuides: "सभी उद्धरण मार्गदर्शिकाएँ",
    resourceStyleGenerator: "{style} उद्धरण जनरेटर",
    resourceExamples: "{style} उद्धरण उदाहरण",
    resourceFormat: "{style} स्वरूपण मार्गदर्शिका",
    resourceInText: "{style} पाठ-अंतर्गत उद्धरण मार्गदर्शिका",
    resourceAnnotatedBib: "{style} टिप्पणी-सहित संदर्भ सूची मार्गदर्शिका",
    resourceReferencePage: "{style} {list} मार्गदर्शिका",
    notFoundTitle: "नहीं मिला",
  },

  // /examples/<style> — the copy-ready worked examples for all 15 detailed styles.
  examplesPage: {
    metaTitle: "{style} उद्धरण उदाहरण - सभी स्रोत प्रकार [2026]",
    metaDescription:
      "पुस्तकों, शोध-पत्रिका लेखों, वेबसाइटों और अन्य के लिए स्वरूपित {style} ({edition}) उद्धरण उदाहरण देखें। कॉपी के लिए तैयार {list} प्रविष्टियाँ और पाठ-अंतर्गत उद्धरण।",
    ogTitle: "{style} उद्धरण उदाहरण",
    ogDescription:
      "हर सामान्य स्रोत प्रकार के लिए कॉपी के लिए तैयार {style} प्रविष्टियाँ।",
    ogImageTitle: "{style} उद्धरण उदाहरण",
    ogKind: "{style} {edition}",
    keywordExamples: "{style} उद्धरण उदाहरण",
    keywordReference: "{style} संदर्भ उदाहरण",
    keywordInText: "{style} पाठ-अंतर्गत उद्धरण उदाहरण",
    keywordList: "{style} {listLower} उदाहरण",
    keywordHowTo: "{style} में उद्धरण कैसे दें",
    breadcrumb: "{style} उद्धरण उदाहरण",
    heading: "{style} उद्धरण उदाहरण",
    lead: "{count} सामान्य स्रोत प्रकारों के लिए सही ढंग से स्वरूपित {style} ({edition}) उद्धरण उदाहरण देखें। हर उदाहरण में {listLower} प्रविष्टि और संबंधित पाठ-अंतर्गत उद्धरण दोनों शामिल हैं।",
    entryLabel: "{list} प्रविष्टि:",
    inTextLabel: "पाठ-अंतर्गत उद्धरण:",
    ctaBody:
      "मैन्युअल स्वरूपण छोड़ें। CitationEasy में DOI, URL या ISBN चिपकाएँ और सेकंडों में पूरी तरह से स्वरूपित {style} उद्धरण पाएँ।",
    faqLookQ: "{style} उद्धरण कैसा दिखता है?",
    faqLookA:
      "{style} उद्धरण में पूरे स्रोत विवरण सहित एक {listLower} प्रविष्टि और एक पाठ-अंतर्गत उद्धरण शामिल होता है। प्रारूप स्रोत प्रकार के अनुसार बदलता है। उदाहरण के लिए, {style} ({edition}) में पुस्तक उद्धरण में लेखक, वर्ष, शीर्षक और प्रकाशक शामिल होते हैं।",
    faqHowManyQ: "कितने {style} उद्धरण उदाहरण उपलब्ध हैं?",
    faqHowManyA:
      "CitationEasy {types} सहित {count} स्रोत प्रकारों के लिए {style} उद्धरण उदाहरण प्रदान करता है। हर उदाहरण में {listLower} प्रविष्टि और संबंधित पाठ-अंतर्गत उद्धरण दोनों शामिल हैं।",
    faqCopyQ: "क्या मैं इन {style} उद्धरण उदाहरणों को कॉपी कर सकता हूँ?",
    faqCopyA:
      "हाँ, इस पृष्ठ पर {style} उदाहरण हर स्रोत प्रकार के लिए सटीक स्वरूपण दिखाते हैं। आप इन्हें अपने उद्धरणों के लिए टेम्पलेट के रूप में उपयोग कर सकते हैं। स्वचालित स्वरूपण के लिए, हमारे निःशुल्क {style} उद्धरण जनरेटर का उपयोग करें।",
  },

  // /format/<style> — font, margins, spacing, title page and headers. The VALUES those
  // labels take are per-style prose and live in the overlay, not here.
  formatPage: {
    metaTitle: "{style} स्वरूपण मार्गदर्शिका - पेपर स्वरूपण नियम [2026]",
    metaDescription:
      "संपूर्ण {style} ({edition}) पेपर स्वरूपण मार्गदर्शिका। सही फ़ॉन्ट, हाशिया, दूरी, शीर्षक पृष्ठ, हेडर और {listLower} स्वरूपण नियम जानें।",
    ogTitle: "{style} पेपर प्रारूप",
    ogDescription: "{style} पेपर के लिए हाशिया, फ़ॉन्ट, दूरी और शीर्षक पृष्ठ।",
    ogImageTitle: "{style} पेपर प्रारूप",
    ogImageSubtitle: "{margins} हाशिया · {spacing}",
    ogKind: "{style} {edition}",
    keywordFormat: "{style} प्रारूप",
    keywordPaperFormat: "{style} पेपर प्रारूप",
    keywordRules: "{style} स्वरूपण नियम",
    keywordMargins: "{style} हाशिया फ़ॉन्ट दूरी",
    keywordList: "{style} {listLower} प्रारूप",
    breadcrumb: "{style} स्वरूपण मार्गदर्शिका",
    heading: "{style} स्वरूपण मार्गदर्शिका",
    lead: "अपने दस्तावेज़ को आवश्यक मानकों के अनुरूप बनाने के लिए इन {style} ({edition}) पेपर स्वरूपण नियमों का पालन करें। इस मार्गदर्शिका में फ़ॉन्ट, हाशिया, दूरी, शीर्षक पृष्ठ, हेडर और {listLower} स्वरूपण शामिल हैं।",
    paperHeading: "पेपर स्वरूपण",
    paperIntro:
      "{style} ({edition}) शैली में लिखे गए पेपर के लिए मूल स्वरूपण आवश्यकताएँ नीचे दी गई हैं।",
    labelFont: "फ़ॉन्ट",
    labelFontSize: "फ़ॉन्ट आकार",
    labelMargins: "हाशिया",
    labelSpacing: "दूरी",
    labelTitlePage: "शीर्षक पृष्ठ",
    labelHeaders: "हेडर / पृष्ठ संख्या",
    listHeading: "{list} स्वरूपण",
    listIntro:
      "{style} शैली में सही ढंग से स्वरूपित होने के लिए आपकी {listLower} को इन नियमों का पालन करना चाहिए:",
    ctaBody:
      "स्वरूपण CitationEasy पर छोड़ दें। DOI, URL या ISBN चिपकाएँ और सेकंडों में पूरी तरह से स्वरूपित {style} उद्धरण पाएँ।",
    faqFontQ: "{style} प्रारूप के लिए मुझे कौन-सा फ़ॉन्ट और आकार उपयोग करना चाहिए?",
    faqFontA:
      "{style} ({edition}) में {font} आवश्यक है। मानक फ़ॉन्ट आकार {fontSize} है।",
    faqMarginsQ: "{style} के लिए हाशिया आवश्यकताएँ क्या हैं?",
    faqMarginsA:
      "{style} पेपर में {margins} आवश्यक है। यह हर पृष्ठ के ऊपर, नीचे, बाएँ और दाएँ हाशिये पर लागू होता है।",
    faqTitlePageQ: "क्या {style} में शीर्षक पृष्ठ आवश्यक है?",
  },

  // /in-text-citation/<style> — the six in-text forms. The forms themselves
  // ("(Smith, 2024)") are per-style prose in the overlay.
  inTextCitationPage: {
    metaTitle: "{style} पाठ-अंतर्गत उद्धरण मार्गदर्शिका - नियम एवं उदाहरण [2026]",
    metaDescription:
      "{style} ({edition}) पाठ-अंतर्गत उद्धरण स्वरूपित करना सीखें। एक लेखक, कई लेखक, प्रत्यक्ष उद्धरण, बिना लेखक और बिना तिथि के लिए उदाहरण सहित नियम।",
    ogTitle: "{style} पाठ-अंतर्गत उद्धरण",
    ogDescription: "उदाहरणों सहित हर {style} पाठ-अंतर्गत उद्धरण रूप।",
    ogImageTitle: "{style} पाठ-अंतर्गत उद्धरण",
    ogImageSubtitle: "एक लेखक {singleAuthor} · तीन या अधिक {threeOrMore}",
    ogKind: "{style} {edition}",
    keywordInText: "{style} पाठ-अंतर्गत उद्धरण",
    keywordExamples: "{style} पाठ-अंतर्गत उद्धरण उदाहरण",
    keywordParenthetical: "{style} कोष्ठक उद्धरण",
    keywordRules: "{style} उद्धरण नियम",
    keywordHowTo: "{style} में पाठ-अंतर्गत उद्धरण कैसे दें",
    breadcrumb: "{style} पाठ-अंतर्गत उद्धरण",
    heading: "{style} पाठ-अंतर्गत उद्धरण",
    lead: "इस संपूर्ण मार्गदर्शिका से {style} ({edition}) पाठ-अंतर्गत उद्धरण में महारत हासिल करें। एक और कई लेखकों, प्रत्यक्ष उद्धरणों और अधूरी जानकारी वाले स्रोतों सहित हर स्थिति के लिए सही प्रारूप जानें।",
    rulesHeading: "पाठ-अंतर्गत उद्धरण नियम",
    rulesIntro:
      "अपना पेपर लिखते समय आने वाली हर सामान्य स्थिति के लिए {style} पाठ-अंतर्गत उद्धरण नियम नीचे दिए गए हैं।",
    labelSingleAuthor: "एकल लेखक",
    labelTwoAuthors: "दो लेखक",
    labelThreeOrMore: "तीन या अधिक लेखक",
    labelDirectQuote: "प्रत्यक्ष उद्धरण",
    labelNoAuthor: "बिना लेखक",
    labelNoDate: "बिना तिथि",
    examplesHeading: "त्वरित उदाहरण",
    examplesIntro:
      "विभिन्न स्रोत प्रकारों के लिए वास्तविक {style} पाठ-अंतर्गत उद्धरण उदाहरण यहाँ दिए गए हैं:",
    ctaBody:
      "पाठ-अंतर्गत उद्धरण स्वरूपण की चिंता करना बंद करें। CitationEasy में DOI, URL या ISBN चिपकाएँ और तुरंत {listLower} प्रविष्टि और पाठ-अंतर्गत उद्धरण दोनों पाएँ।",
    faqFormatQ: "मैं {style} पाठ-अंतर्गत उद्धरण कैसे स्वरूपित करूँ?",
    faqFormatA:
      "{style} में एक लेखक के लिए {singleAuthor} प्रारूप उपयोग करें। दो लेखकों के लिए {twoAuthors} उपयोग करें। तीन या अधिक लेखकों के लिए {threeOrMore} उपयोग करें।",
    faqQuoteQ: "मैं {style} में प्रत्यक्ष उद्धरण कैसे दूँ?",
    faqQuoteA:
      "{style} ({edition}) में प्रत्यक्ष उद्धरणों के लिए यह प्रारूप उपयोग करें: {directQuote}।",
    faqMissingQ: "यदि {style} में लेखक या तिथि न हो तो क्या करें?",
    faqMissingA:
      "जब {style} में लेखक न हो, तो उपयोग करें: {noAuthor}। जब तिथि न हो, तो उपयोग करें: {noDate}।",
  },

  // /reference-page/<style> — how to build the list at the back of the paper.
  //
  // The five `mistake*` strings carry `**bold**` inline markup because the lead-in of
  // each bullet is emphasised inside the sentence; they render through `InlineText`.
  referenceListPage: {
    metaTitle: "{style} {list} मार्गदर्शिका - स्वरूपण नियम [2026]",
    metaDescription:
      "{style} {listLower} ({edition}) को स्वरूपित करना सीखें। {fullName} के लिए चरण-दर-चरण स्वरूपण नियम, उदाहरण और बचने योग्य सामान्य गलतियाँ।",
    ogTitle: "{style} {listLower}",
    ogDescription: "{style} में {list} कैसे तैयार करें।",
    ogImageTitle: "{style} {list}",
    ogKind: "{style} {edition}",
    breadcrumb: "{style} {list} कैसे स्वरूपित करें",
    heading: "{style} {list} कैसे स्वरूपित करें",
    lead: "{listLower}, {style} ({edition}) में स्वरूपित किसी भी शैक्षणिक पेपर के सबसे महत्वपूर्ण भागों में से एक है। यह पाठकों को आपके द्वारा उद्धृत हर स्रोत का पूरा विवरण देती है, जिससे वे आपके संदर्भों को खोज और सत्यापित कर सकें। सही स्वरूपण शैक्षणिक विश्वसनीयता के लिए आवश्यक है। इस मार्गदर्शिका में सटीक नियम, वास्तविक उदाहरण और छात्रों द्वारा की जाने वाली सबसे सामान्य गलतियाँ शामिल हैं।",
    rulesHeading: "स्वरूपण नियम",
    rulesIntro: "अपनी {style} {listLower} बनाते समय इन नियमों का पालन करें:",
    exampleHeading: "उदाहरण {list}",
    exampleIntro:
      "अलग-अलग स्रोत प्रकारों की प्रविष्टियों के साथ {style} {listLower} इस तरह दिखती है:",
    mistakesHeading: "बचने योग्य सामान्य गलतियाँ",
    mistakesIntro:
      "{style} {listLower} बनाते समय छात्रों द्वारा की जाने वाली पाँच सबसे सामान्य स्वरूपण त्रुटियाँ ये हैं:",
    mistakeIndent:
      "**गायब या गलत हैंगिंग इंडेंट:** हर प्रविष्टि की पहली पंक्ति बाईं ओर सीधी होनी चाहिए और बाद की सभी पंक्तियाँ 0.5 इंच इंडेंट होनी चाहिए। Tab कुंजी दबाने के बजाय अपने वर्ड प्रोसेसर की पैराग्राफ सेटिंग्स का उपयोग करें।",
    mistakeOrder:
      '**गलत वर्णानुक्रम या क्रम:** प्रविष्टियों को {style} नियमों के अनुसार व्यवस्थित किया जाना चाहिए। वर्णानुक्रम करते समय "A," "An," और "The" जैसे उपपदों को अनदेखा करें। संख्या-आधारित शैलियों के लिए, प्रविष्टियों को पाठ में पहली बार दिखने के क्रम में सूचीबद्ध करें।',
    mistakeSpacing:
      "**असंगत दूरी:** पूरी {listLower} में अपनी लाइन दूरी की दोबारा जाँच करें। एकल और दोहरी दूरी को मिलाना एक सामान्य त्रुटि है जिसे अक्सर अनदेखा कर दिया जाता है।",
    mistakeItalics:
      "**इटैलिक का गलत उपयोग:** पुस्तकों और पत्रिकाओं जैसी स्वतंत्र रचनाओं के शीर्षकों को इटैलिक करें, लेकिन लेख या अध्याय के शीर्षकों को इटैलिक न करें। कौन-से तत्व इटैलिक होने चाहिए, यह जानने के लिए {style} दिशानिर्देश देखें।",
    mistakeLinks:
      "**गायब या टूटे हुए DOI और URL:** जब भी उपलब्ध हो, DOI को क्लिक करने योग्य लिंक के रूप में अवश्य शामिल करें। अपना पेपर सबमिट करने से पहले हर URL की जाँच करें ताकि वह सही स्रोत तक ले जाए।",
    ctaHeading: "अपनी {list} स्वचालित रूप से बनाएँ",
    ctaBody:
      "मैन्युअल स्वरूपण छोड़ें। CitationEasy में DOI, URL या ISBN चिपकाएँ और सेकंडों में अपनी {listLower} के लिए तैयार, पूरी तरह से स्वरूपित {style} उद्धरण पाएँ।",
    faqWhatQ: "{style} {list} क्या है?",
    faqWhatA:
      "{style} {list} आपके पेपर के अंत का वह भाग है जिसमें आपके द्वारा पाठ में उद्धृत सभी स्रोत सूचीबद्ध होते हैं, जो {fullName} ({edition}) दिशानिर्देशों के अनुसार स्वरूपित होते हैं। यह पाठकों को आपके संदर्भित हर स्रोत को खोजने और सत्यापित करने में सक्षम बनाता है।",
    faqFormatQ: "मैं {style} {listLower} कैसे स्वरूपित करूँ?",
    faqFormatA:
      'एक नए पृष्ठ पर शुरू करें, उसका शीर्षक "{list}" रखें, और अपने पेपर में उद्धृत सभी स्रोतों को सूचीबद्ध करें। हैंगिंग इंडेंट, दूरी, वर्णानुक्रम या क्रमांकन क्रम, और इटैलिक के लिए विशिष्ट {style} नियमों का पालन करें।',
    faqDifferenceQ: "{listLower} और ग्रंथ सूची में क्या अंतर है?",
    faqDifferenceA:
      '{listLower} में केवल वे स्रोत शामिल होते हैं जिन्हें आपने अपने पेपर में सीधे उद्धृत किया है, जबकि ग्रंथ सूची में वे स्रोत भी शामिल हो सकते हैं जिन्हें आपने देखा लेकिन उद्धृत नहीं किया। {style} ({edition}) में, पेपर के अंत की सूची को "{list}" कहा जाता है।',
  },

  // /annotated-bibliography/<style>. `whatTypes` carries `**bold**` inline markup.
  //
  // `exampleAnnotation` is a specimen annotation, not a citation: it is ordinary prose
  // about an imaginary source and translates like any other paragraph. The reference
  // entry printed above it does not — that comes from `DETAILED_STYLES` and stays as
  // the style wrote it.
  annotatedBibPage: {
    metaTitle: "{style} टिप्पणी-सहित संदर्भ सूची मार्गदर्शिका एवं उदाहरण [2026]",
    metaDescription:
      "{style} ({edition}) में टिप्पणी-सहित संदर्भ सूची लिखना सीखें। इसमें {fullName} टिप्पणी-सहित संदर्भ सूचियों के लिए स्वरूपण नियम, उदाहरण प्रविष्टियाँ और सुझाव शामिल हैं।",
    ogTitle: "{style} टिप्पणी-सहित संदर्भ सूची",
    ogDescription: "{style} में टिप्पणी-सहित संदर्भ सूची कैसे स्वरूपित करें।",
    ogImageTitle: "{style} टिप्पणी-सहित संदर्भ सूची",
    ogKind: "{style} {edition}",
    breadcrumb: "{style} टिप्पणी-सहित संदर्भ सूची",
    heading: "{style} टिप्पणी-सहित संदर्भ सूची",
    lead: "टिप्पणी-सहित संदर्भ सूची स्रोत उद्धरणों की एक सूची है जिसमें प्रत्येक के साथ एक संक्षिप्त वर्णनात्मक या मूल्यांकनात्मक अनुच्छेद शामिल होता है। {style} प्रारूप ({edition}) में, हर प्रविष्टि सही ढंग से स्वरूपित संदर्भ से शुरू होती है, उसके बाद एक टिप्पणी होती है जो स्रोत का सारांश, मूल्यांकन या विश्लेषण प्रस्तुत करती है। यह मार्गदर्शिका आपको एक परिष्कृत {style} टिप्पणी-सहित संदर्भ सूची बनाने के लिए आवश्यक नियमों, स्वरूपण और उदाहरणों के माध्यम से मार्गदर्शन करती है।",
    whatHeading: "टिप्पणी-सहित संदर्भ सूची क्या है?",
    whatBody:
      "टिप्पणी-सहित संदर्भ सूची एक मानक {listLower} से आगे जाकर हर उद्धरण के बाद एक संक्षिप्त अनुच्छेद जोड़ती है। यह टिप्पणी पाठकों को स्रोत की सामग्री, गुणवत्ता और प्रासंगिकता के बारे में जानकारी देती है। शिक्षक अक्सर छात्रों को अपने स्रोतों का समालोचनात्मक मूल्यांकन करने और यह दर्शाने में मदद करने के लिए टिप्पणी-सहित संदर्भ सूचियाँ सौंपते हैं कि प्रत्येक स्रोत उनके शोध विषय में कैसे योगदान देता है।",
    whatTypes:
      "टिप्पणियों के तीन सामान्य प्रकार हैं: **वर्णनात्मक** टिप्पणियाँ जो स्रोत का सारांश देती हैं, **मूल्यांकनात्मक** टिप्पणियाँ जो कार्य की गुणवत्ता और विश्वसनीयता का आकलन करती हैं, और **संयोजन** टिप्पणियाँ जो दोनों करती हैं। आपके असाइनमेंट के निर्देशों में बताया जाना चाहिए कि किस प्रकार का उपयोग करना है।",
    rulesHeading: "{style} टिप्पणी-सहित संदर्भ सूची नियम",
    rulesIntro:
      "{fullName} में टिप्पणी-सहित संदर्भ सूची स्वरूपित करते समय इन नियमों का पालन करें:",
    exampleHeading: "उदाहरण टिप्पणी-सहित संदर्भ सूची प्रविष्टि",
    exampleIntro:
      "नीचे {sourceType} के लिए एक नमूना {style} टिप्पणी-सहित संदर्भ सूची प्रविष्टि दी गई है:",
    exampleAnnotation:
      "यह स्रोत विषय का एक व्यापक अवलोकन प्रदान करता है, जो अनुभवजन्य साक्ष्य द्वारा समर्थित सुदृढ़ तर्क प्रस्तुत करता है। लेखक एक ठोस मामला बनाने के लिए प्राथमिक और द्वितीयक स्रोतों की एक विस्तृत श्रृंखला का उपयोग करता है। कार्यप्रणाली कठोर है और निष्कर्ष स्पष्ट रूप से प्रस्तुत किए गए हैं, जिससे यह कार्य विषय को समझने के लिए एक मूल्यवान संसाधन बन जाता है। यह स्रोत शोध परियोजना के सैद्धांतिक ढाँचे को स्थापित करने के लिए विशेष रूप से उपयोगी है और संदर्भ सूची के अन्य कार्यों के पूरक दृष्टिकोण प्रदान करता है।",
    tipsHeading: "{style} टिप्पणियाँ लिखने के लिए सुझाव",
    tipSummarize:
      "स्रोत का दो से तीन वाक्यों में सारांश देकर शुरू करें, फिर उसकी शक्तियों, सीमाओं और प्रासंगिकता का अपना मूल्यांकन जोड़ें।",
    tipTone:
      "अपनी टिप्पणियों में हमेशा अन्य पुरुष और शैक्षणिक लहजे का उपयोग करें। जब तक शिक्षक न कहें, अनौपचारिक भाषा या प्रथम पुरुष में विचार व्यक्त करने से बचें।",
    tipLength:
      "हर टिप्पणी को 100 से 200 शब्दों के बीच रखें। संक्षिप्त रहें और स्रोत के सबसे महत्वपूर्ण पहलुओं पर ध्यान केंद्रित करें।",
    tipRelevance:
      "बताएँ कि स्रोत आपके समग्र शोध में कैसे फिट बैठता है। वर्णन करें कि यह कौन-सा विशिष्ट दृष्टिकोण या साक्ष्य प्रदान करता है।",
    tipCitation:
      "टिप्पणी लिखने से पहले सुनिश्चित करें कि हर प्रविष्टि का उद्धरण भाग {fullName} के स्वरूपण नियमों का बिल्कुल पालन करता है।",
    ctaHeading: "अपनी टिप्पणी-सहित संदर्भ सूची स्वचालित रूप से बनाएँ",
    ctaBody:
      "सही ढंग से स्वरूपित {style} उद्धरण बनाने के लिए CitationEasy टिप्पणी-सहित संदर्भ सूची निर्माता का उपयोग करें, फिर अपनी टिप्पणियाँ जोड़ें।",
    ctaButton: "टिप्पणी-सहित संदर्भ सूची निर्माता खोलें →",
    faqWhatQ: "{style} में टिप्पणी-सहित संदर्भ सूची क्या है?",
    faqWhatA:
      "{style} ({edition}) में टिप्पणी-सहित संदर्भ सूची {fullName} शैली में स्वरूपित उद्धरणों की एक सूची है, जिसमें हर उद्धरण के बाद एक संक्षिप्त अनुच्छेद होता है जो स्रोत का सारांश, मूल्यांकन या विश्लेषण प्रस्तुत करता है। यह पाठकों को हर स्रोत की प्रासंगिकता और गुणवत्ता समझने में मदद करता है।",
    faqLengthQ: "टिप्पणियाँ कितनी लंबी होनी चाहिए?",
    faqLengthA:
      "टिप्पणियाँ आमतौर पर 100 से 200 शब्दों की होती हैं। अपेक्षित विश्लेषण की गहराई के आधार पर कुछ असाइनमेंट में छोटी या लंबी टिप्पणियों की आवश्यकता हो सकती है। विशिष्ट लंबाई आवश्यकताओं के लिए हमेशा अपने शिक्षक के दिशानिर्देश देखें।",
    faqIncludeQ: "एक टिप्पणी में क्या शामिल होना चाहिए?",
    faqIncludeA:
      "एक टिप्पणी में स्रोत के मुख्य तर्क या निष्कर्षों का संक्षिप्त सारांश, स्रोत की विश्वसनीयता और उपयोगिता का मूल्यांकन, और यह विश्लेषण शामिल होना चाहिए कि स्रोत आपके शोध में कैसे फिट बैठता है। कुछ टिप्पणियाँ पूरी तरह वर्णनात्मक होती हैं, जबकि अन्य में समालोचनात्मक विश्लेषण शामिल होता है।",
  },

  guidePage: {
    byline: "लेखक: {author}",
    published: "प्रकाशित: {date}",
    updated: "अपडेट किया गया: {date}",
    readingTime: "one:{count} मिनट में पढ़ें|other:{count} मिनट में पढ़ें",
    wordCount: "one:{count} शब्द|other:{count} शब्द",
  },

  // /guides hub, /guides/<category> index pages, and the chrome around each guide
  guideLibrary: {
    eyebrow: "मार्गदर्शिका पुस्तकालय",
    browseByCategory: "श्रेणी के अनुसार देखें",
    recentlyUpdated: "हाल ही में अपडेट",
    allGuides: "सभी मार्गदर्शिकाएँ",
    guideCount: "one:{count} मार्गदर्शिका|other:{count} मार्गदर्शिकाएँ",
    updatedOn: "{date} को अपडेट किया गया",
    minRead: "one:{count} मिनट पढ़ने का समय|other:{count} मिनट पढ़ने का समय",
    onThisPage: "इस पृष्ठ पर",
    viewAllInCategory: "{category} की सभी मार्गदर्शिकाएँ",
    moreInCategory: "{category} में और",
    aboutThisGuide: "इस मार्गदर्शिका के बारे में",
    provenance:
      "{author} द्वारा लिखित। {published} को प्रकाशित; अंतिम अपडेट {updated}।",
    categoryIntroSuffix:
      "हर मार्गदर्शिका निःशुल्क है, छात्रों और शोधकर्ताओं के लिए लिखी गई है, और दिनांकित है ताकि आप देख सकें कि इसे आखिरी बार कब जाँचा गया।",
    photoCredit: "फ़ोटो: {author}, {source} ({license})",
    imageAlt: "{category} मार्गदर्शिकाओं को दर्शाती तस्वीर",
    imageSourceCommons: "विकिमीडिया कॉमन्स",
    apaStyleName: "APA शैली",
    apaStyleDescription:
      "APA 7वें संस्करण में वेबसाइट, जर्नल लेख, पुस्तकें, वीडियो आदि का हवाला कैसे दें, प्रत्येक के लिए संदर्भ-सूची और पाठ-में उदाहरणों के साथ।",
    mlaStyleName: "MLA शैली",
    mlaStyleDescription:
      "MLA 9वें संस्करण में वेब पेज और जर्नल लेख से लेकर कविता, नाटक, फ़िल्म और पाठ्य सामग्री तक हर सामान्य स्रोत का हवाला कैसे दें।",
    chicagoStyleName: "शिकागो शैली",
    chicagoStyleDescription:
      "पुस्तकों, लेखों, अभिलेखागार, सरकारी दस्तावेज़ों और मीडिया के लिए नोट्स-ग्रंथसूची और लेखक-तिथि उद्धरणों को कवर करने वाली शिकागो मैनुअल ऑफ़ स्टाइल मार्गदर्शिकाएँ।",
    styleComparisonsName: "शैली तुलना",
    styleComparisonsDescription:
      "APA, MLA, शिकागो, हार्वर्ड, वैंकूवर, IEEE आदि की आमने-सामने तुलना, साथ ही सलाह कि आपका विषय किस शैली की अपेक्षा करता है।",
    researchMethodsName: "शोध विधियाँ",
    researchMethodsDescription:
      "शोध पत्र की योजना, साहित्य समीक्षा, नोट्स लेना, स्रोतों का मूल्यांकन, साहित्यिक चोरी से बचाव और ग्रंथसूची बनाना।",
    academicWritingName: "अकादमिक लेखन",
    academicWritingDescription:
      "सार, परिचय, निष्कर्ष, थीसिस कथन, कार्यप्रणाली अनुभाग और स्पष्ट अकादमिक गद्य के लिए लेखन मार्गदर्शिकाएँ।",
    fieldSpecificName: "विषय-विशिष्ट",
    fieldSpecificDescription:
      "मनोविज्ञान, इतिहास और साहित्य से लेकर चिकित्सा, इंजीनियरिंग, विधि और नर्सिंग तक अलग-अलग विषयों के लिए उद्धरण मार्गदर्शिकाएँ।",
    sourceEvaluationName: "स्रोत मूल्यांकन",
    sourceEvaluationDescription:
      "विश्वसनीयता कैसे परखें, विद्वत्तापूर्ण और लोकप्रिय स्रोतों में अंतर, Google Scholar और पुस्तकालय डेटाबेस का उपयोग, और पूर्वाग्रह की पहचान।",
    citationHelpName: "उद्धरण सहायता",
    citationHelpDescription:
      "कठिन मामलों के उत्तर: लेखक या तिथि न होना, कई लेखक, PDF, AI उपकरण, कानूनी मामले, और उद्धरण आयात या निर्यात।",
  },

  common: {
    backToGuides: "← मार्गदर्शिकाओं पर लौटें",
    free: "निःशुल्क",
    noSignup: "पंजीकरण आवश्यक नहीं",
    backToHome: "संदर्भ जनरेटर पर लौटें",
    inEnglish: "अंग्रेज़ी में",
    viewInEnglish: "अंग्रेज़ी में देखें",
    availableInEnglish: "यह पृष्ठ अधिक विस्तार के साथ अंग्रेज़ी में उपलब्ध है।",
    otherLanguages: "अन्य भाषाएँ",
    skipToContent: "सामग्री पर जाएँ",
    cookieNotice:
      "CitationEasy को मुफ़्त रखने के लिए हम विश्लेषण और विज्ञापन हेतु कुकीज़ का उपयोग करते हैं।",
    privacyPolicy: "गोपनीयता नीति",
    accept: "स्वीकारें",
    decline: "अस्वीकारें",
    advertisement: "विज्ञापन",
  },
  legalPage: {
    backLink: "← जनरेटर पर वापस जाएँ",
    effective: "प्रभावी तिथि:",
    updated: "अंतिम अद्यतन:",
  },
};

export default hi;
